module.exports.send = {
   10101 : [
      {s:'sex', t:2},
      {s:'name', t:7},
      {s:'career', t:3},
      {s:'playform', t:7}
   ],
   10102 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   10103 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   10200 : [
      {s:'battle_id', t:6},
      {s:'id', t:6},
      {s:'code', t:4}
   ],
   10215 : [
      {s:'base_id', t:6},
      {s:'x', t:4},
      {s:'y', t:4},
      {s:'dir', t:2}
   ],
   10300 : [
   ],
   10309 : [
      {s:'signature', t:7}
   ],
   10312 : [
   ],
   10315 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   10316 : [
      {s:'type', t:2},
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'idx', t:6}
   ],
   10317 : [
   ],
   10318 : [
      {s:'auto_pk', t:2}
   ],
   10322 : [
      {s:'code', t:2}
   ],
   10325 : [
   ],
   10327 : [
      {s:'face_id', t:6}
   ],
   10343 : [
      {s:'name', t:7},
      {s:'sex', t:2}
   ],
   10345 : [
   ],
   10346 : [
      {s:'id', t:6}
   ],
   10347 : [
      {s:'id', t:6}
   ],
   10348 : [
      {s:'is_show_vip', t:2}
   ],
   10380 : [
   ],
   10391 : [
      {s:'msg', t:7}
   ],
   10395 : [
      {s:'age', t:1}
   ],
   10397 : [
      {s:'status', t:2}
   ],
   10399 : [
      {s:'msg', t:7}
   ],
   10400 : [
   ],
   10402 : [
      {s:'id', t:6}
   ],
   10405 : [
      {s:'id', t:6}
   ],
   10406 : [
      {s:'id', t:6}
   ],
   10500 : [
   ],
   10501 : [
   ],
   10515 : [
      {s:'id', t:6},
      {s:'quantity', t:4},
      {s:'args', t:9, f:[
          {s:'name', t:2},
          {s:'value', t:6},
          {s:'str', t:7}
      ]}
   ],
   10520 : [
      {s:'id', t:6},
      {s:'storage', t:2}
   ],
   10522 : [
      {s:'storage', t:2},
      {s:'args', t:9, f:[
          {s:'id', t:6},
          {s:'bid', t:6},
          {s:'num', t:4}
      ]}
   ],
   10523 : [
      {s:'id', t:6},
      {s:'num', t:4}
   ],
   10524 : [
      {s:'star_list', t:9, f:[
          {s:'star', t:2}
      ]}
   ],
   10525 : [
   ],
   10526 : [
      {s:'type', t:2}
   ],
   10528 : [
   ],
   10535 : [
      {s:'type', t:2},
      {s:'id', t:6},
      {s:'partner_id', t:6},
      {s:'code', t:6}
   ],
   10536 : [
      {s:'id', t:6},
      {s:'srv_id', t:7}
   ],
   10800 : [
   ],
   10801 : [
      {s:'id', t:6},
      {s:'srv_id', t:7}
   ],
   10802 : [
   ],
   10804 : [
      {s:'ids', t:9, f:[
          {s:'id', t:6},
          {s:'srv_id', t:7}
      ]}
   ],
   10805 : [
      {s:'id', t:6},
      {s:'srv_id', t:7}
   ],
   10810 : [
      {s:'issue_type', t:2},
      {s:'title', t:7},
      {s:'content', t:7}
   ],
   10900 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'hour', t:6},
      {s:'interdict', t:7}
   ],
   10901 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'hour', t:6},
      {s:'banned', t:7}
   ],
   10902 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'stop_role', t:7}
   ],
   10905 : [
   ],
   10906 : [
   ],
   10922 : [
   ],
   10923 : [
      {s:'id', t:4}
   ],
   10924 : [
   ],
   10925 : [
      {s:'id', t:4}
   ],
   10926 : [
   ],
   10927 : [
      {s:'time', t:6}
   ],
   10945 : [
      {s:'card_id', t:7}
   ],
   10946 : [
   ],
   10950 : [
   ],
   10952 : [
      {s:'id', t:6}
   ],
   10955 : [
   ],
   10956 : [
      {s:'key', t:4},
      {s:'val', t:6}
   ],
   10999 : [
      {s:'msg', t:7}
   ],
   1110 : [
      {s:'args', t:9, f:[
          {s:'key', t:7},
          {s:'val', t:7}
      ]}
   ],
   1198 : [
      {s:'time', t:6}
   ],
   1199 : [
   ],
   11000 : [
   ],
   11001 : [
   ],
   11002 : [
   ],
   11003 : [
      {s:'partner_id', t:6}
   ],
   11004 : [
      {s:'partner_id', t:6}
   ],
   11005 : [
      {s:'partner_id', t:6},
      {s:'expend1', t:9, f:[
          {s:'partner_id', t:6}
      ]},
      {s:'expend2', t:9, f:[
          {s:'partner_id', t:6}
      ]}
   ],
   11006 : [
   ],
   11007 : [
   ],
   11008 : [
      {s:'bid', t:6},
      {s:'num', t:6}
   ],
   11009 : [
   ],
   11010 : [
      {s:'partner_id', t:6},
      {s:'item_id', t:6}
   ],
   11011 : [
      {s:'partner_id', t:6},
      {s:'pos_id', t:6}
   ],
   11012 : [
   ],
   11015 : [
      {s:'partner_id', t:6},
      {s:'type', t:2}
   ],
   11016 : [
      {s:'partner_id', t:6}
   ],
   11017 : [
   ],
   11019 : [
      {s:'partner_id', t:6},
      {s:'skin_id', t:6}
   ],
   11020 : [
   ],
   11025 : [
   ],
   11026 : [
      {s:'partner_ids', t:9, f:[
          {s:'partner_id', t:6}
      ]}
   ],
   11030 : [
      {s:'partner_id', t:6},
      {s:'pos_id', t:2},
      {s:'artifact_id', t:6},
      {s:'type', t:2}
   ],
   11031 : [
   ],
   11032 : [
      {s:'partner_id', t:6},
      {s:'artifact_id', t:6},
      {s:'expends', t:9, f:[
          {s:'artifact_id', t:6}
      ]}
   ],
   11033 : [
      {s:'partner_id', t:6},
      {s:'artifact_id', t:6},
      {s:'skills', t:9, f:[
          {s:'skill_id', t:6}
      ]}
   ],
   11034 : [
      {s:'partner_id', t:6},
      {s:'artifact_id', t:6},
      {s:'type', t:2}
   ],
   11035 : [
      {s:'artifact_id', t:6}
   ],
   11036 : [
      {s:'item_id', t:6},
      {s:'expends', t:9, f:[
          {s:'artifact_id', t:6}
      ]}
   ],
   11037 : [
   ],
   11038 : [
   ],
   11040 : [
   ],
   11041 : [
      {s:'partner_id', t:6},
      {s:'start', t:2},
      {s:'num', t:2}
   ],
   11042 : [
      {s:'partner_id', t:6}
   ],
   11043 : [
      {s:'partner_id', t:6},
      {s:'msg', t:7}
   ],
   11044 : [
      {s:'partner_id', t:6},
      {s:'comment_id', t:6},
      {s:'type', t:2}
   ],
   11045 : [
      {s:'partner_id', t:6}
   ],
   11046 : [
   ],
   11047 : [
   ],
   11050 : [
   ],
   11051 : [
      {s:'fields', t:9, f:[
          {s:'pos', t:6},
          {s:'partner_id', t:6}
      ]}
   ],
   11052 : [
   ],
   11053 : [
      {s:'pos', t:2}
   ],
   11055 : [
      {s:'is_point', t:2}
   ],
   11056 : [
   ],
   11060 : [
      {s:'partner_id', t:6},
      {s:'channel', t:4}
   ],
   11061 : [
      {s:'r_rid', t:6},
      {s:'r_srvid', t:7},
      {s:'partner_id', t:6}
   ],
   11062 : [
      {s:'id', t:6},
      {s:'srv_id', t:7}
   ],
   11063 : [
      {s:'partner_id', t:6}
   ],
   11070 : [
      {s:'partner_bid', t:6}
   ],
   11073 : [
   ],
   11075 : [
      {s:'list', t:9, f:[
          {s:'partner_id', t:6}
      ]}
   ],
   11076 : [
      {s:'list', t:9, f:[
          {s:'partner_id', t:6}
      ]}
   ],
   11077 : [
      {s:'partner_bid', t:6}
   ],
   11078 : [
      {s:'id', t:6},
      {s:'flag', t:2}
   ],
   11079 : [
      {s:'base_id', t:6},
      {s:'num', t:6}
   ],
   11080 : [
      {s:'base_id', t:6},
      {s:'num', t:6}
   ],
   11081 : [
      {s:'base_id', t:6},
      {s:'num', t:6}
   ],
   11082 : [
   ],
   11083 : [
      {s:'partner_id', t:6},
      {s:'item_id', t:6}
   ],
   11085 : [
   ],
   11086 : [
      {s:'partner_id', t:6}
   ],
   11087 : [
      {s:'list', t:9, f:[
          {s:'partner_id', t:6}
      ]}
   ],
   11088 : [
      {s:'item_ids', t:9, f:[
          {s:'item_id', t:6}
      ]}
   ],
   11089 : [
      {s:'item_ids', t:9, f:[
          {s:'item_id', t:6}
      ]}
   ],
   11090 : [
      {s:'partner_id', t:6},
      {s:'holy_eqm_id', t:6},
      {s:'type', t:2}
   ],
   11091 : [
   ],
   11092 : [
      {s:'partner_ids', t:9, f:[
          {s:'partner_id', t:6}
      ]}
   ],
   11093 : [
      {s:'partner_id', t:6},
      {s:'holy_eqm_id', t:6},
      {s:'type', t:2}
   ],
   11094 : [
      {s:'partner_id', t:6},
      {s:'holy_eqm_id', t:6},
      {s:'pos', t:9, f:[
          {s:'pos', t:2}
      ]}
   ],
   11095 : [
   ],
   11096 : [
      {s:'partner_id', t:6},
      {s:'pos', t:2},
      {s:'skill_id', t:6}
   ],
   11097 : [
      {s:'partner_id', t:6},
      {s:'pos', t:2}
   ],
   11098 : [
      {s:'partner_id', t:6},
      {s:'pos', t:2}
   ],
   11099 : [
      {s:'partner_ids', t:9, f:[
          {s:'partner_id', t:6}
      ]}
   ],
   11100 : [
      {s:'drama_bid', t:6},
      {s:'step_id', t:2}
   ],
   11102 : [
      {s:'drama_bid', t:6}
   ],
   11111 : [
      {s:'type', t:4},
      {s:'bid', t:6}
   ],
   11121 : [
      {s:'id', t:6},
      {s:'n', t:6}
   ],
   11122 : [
      {s:'id', t:6},
      {s:'is_skip', t:6}
   ],
   11200 : [
   ],
   11201 : [
      {s:'id', t:2},
      {s:'pos_info', t:9, f:[
          {s:'pos', t:2},
          {s:'id', t:2}
      ]},
      {s:'hallows_id', t:6}
   ],
   11211 : [
      {s:'type', t:2}
   ],
   11212 : [
      {s:'type', t:2},
      {s:'formation_type', t:2},
      {s:'pos_info', t:9, f:[
          {s:'pos', t:2},
          {s:'id', t:6}
      ]},
      {s:'hallows_id', t:6}
   ],
   11213 : [
      {s:'type_list', t:9, f:[
          {s:'type', t:2}
      ]}
   ],
   11300 : [
   ],
   11301 : [
   ],
   11302 : [
      {s:'set_id', t:6},
      {s:'pos_id', t:6},
      {s:'partner_id', t:6}
   ],
   11303 : [
      {s:'set_id', t:6},
      {s:'pos_id', t:6},
      {s:'partner_id', t:6}
   ],
   11304 : [
      {s:'set_id', t:6},
      {s:'id', t:6}
   ],
   11305 : [
      {s:'set_id', t:6},
      {s:'id', t:6}
   ],
   11306 : [
      {s:'id', t:6},
      {s:'set_id', t:6}
   ],
   11307 : [
      {s:'set_id', t:6}
   ],
   11308 : [
   ],
   11310 : [
      {s:'set_id', t:6},
      {s:'id', t:6}
   ],
   11311 : [
      {s:'set_id', t:6},
      {s:'id', t:6}
   ],
   11320 : [
   ],
   11321 : [
   ],
   11322 : [
      {s:'tower', t:6}
   ],
   11323 : [
   ],
   11324 : [
      {s:'tower', t:6}
   ],
   11325 : [
      {s:'tower', t:6}
   ],
   11326 : [
   ],
   11327 : [
   ],
   11328 : [
      {s:'id', t:6}
   ],
   11329 : [
   ],
   11330 : [
   ],
   11331 : [
      {s:'type', t:2},
      {s:'count', t:2}
   ],
   11332 : [
   ],
   11333 : [
      {s:'replay_id', t:6},
      {s:'channel', t:4},
      {s:'tower', t:6}
   ],
   12700 : [
   ],
   12701 : [
      {s:'base_id', t:6}
   ],
   12702 : [
   ],
   12703 : [
      {s:'base_id', t:6}
   ],
   12720 : [
      {s:'to_rid', t:6},
      {s:'to_srv_id', t:7},
      {s:'len', t:2},
      {s:'msg', t:7}
   ],
   12723 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   12725 : [
      {s:'voice', t:8},
      {s:'voice_len', t:4},
      {s:'time', t:2},
      {s:'type', t:2}
   ],
   12726 : [
      {s:'srv_id', t:7},
      {s:'voice_id', t:6}
   ],
   12730 : [
      {s:'type', t:6},
      {s:'is_push', t:2}
   ],
   12731 : [
   ],
   12732 : [
      {s:'type', t:6},
      {s:'msg', t:7}
   ],
   12762 : [
      {s:'channel', t:4},
      {s:'len', t:2},
      {s:'msg', t:7}
   ],
   12764 : [
      {s:'channel', t:4},
      {s:'id', t:7},
      {s:'msg', t:7}
   ],
   12766 : [
      {s:'channel', t:4}
   ],
   12767 : [
   ],
   12768 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'channel', t:4},
      {s:'msg', t:7}
   ],
   12770 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'type', t:2},
      {s:'msg', t:7},
      {s:'history', t:9, f:[
          {s:'id', t:2}
      ]}
   ],
   12771 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   12900 : [
      {s:'type', t:4},
      {s:'start', t:2},
      {s:'num', t:2},
      {s:'is_cluster', t:2}
   ],
   12901 : [
      {s:'type', t:4},
      {s:'is_cluster', t:2}
   ],
   12902 : [
      {s:'is_cluster', t:2}
   ],
   12903 : [
      {s:'start', t:2},
      {s:'num', t:2}
   ],
   12904 : [
      {s:'start', t:2},
      {s:'num', t:2}
   ],
   13000 : [
   ],
   13002 : [
   ],
   13003 : [
      {s:'is_auto', t:2}
   ],
   13004 : [
   ],
   13005 : [
      {s:'dun_id', t:6},
      {s:'num', t:4}
   ],
   13006 : [
   ],
   13008 : [
   ],
   13009 : [
      {s:'id', t:6}
   ],
   13011 : [
   ],
   13012 : [
   ],
   13013 : [
   ],
   13014 : [
      {s:'chapter_id', t:6},
      {s:'award_id', t:6}
   ],
   13015 : [
      {s:'dun_id', t:6}
   ],
   13017 : [
   ],
   13018 : [
   ],
   13019 : [
   ],
   13020 : [
   ],
   13030 : [
   ],
   13031 : [
      {s:'id', t:6}
   ],
   13032 : [
      {s:'id', t:6}
   ],
   13039 : [
   ],
   13040 : [
   ],
   13300 : [
   ],
   13303 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   13305 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'agreed', t:2}
   ],
   13306 : [
      {s:'role_ids', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7}
      ]}
   ],
   13307 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   13309 : [
      {s:'role_ids', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7}
      ]}
   ],
   13311 : [
   ],
   13312 : [
   ],
   13314 : [
      {s:'name', t:7}
   ],
   13315 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   13316 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'code', t:2}
   ],
   13317 : [
      {s:'code', t:2},
      {s:'list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7}
      ]}
   ],
   13320 : [
   ],
   13330 : [
   ],
   13332 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   13333 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   13334 : [
      {s:'role_ids', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7}
      ]}
   ],
   13401 : [
      {s:'type', t:2}
   ],
   13402 : [
      {s:'eid', t:6},
      {s:'num', t:6}
   ],
   13403 : [
      {s:'type', t:6}
   ],
   13405 : [
      {s:'type', t:6}
   ],
   13407 : [
      {s:'order', t:6},
      {s:'type', t:6},
      {s:'buy_type', t:6}
   ],
   13408 : [
      {s:'type', t:2}
   ],
   13409 : [
      {s:'type', t:2}
   ],
   13410 : [
      {s:'type', t:2},
      {s:'pos', t:6}
   ],
   13411 : [
      {s:'type', t:2}
   ],
   13412 : [
   ],
   13413 : [
      {s:'id', t:6}
   ],
   13414 : [
   ],
   13415 : [
      {s:'type', t:6}
   ],
   13416 : [
      {s:'order', t:6},
      {s:'type', t:6},
      {s:'buy_type', t:6}
   ],
   13417 : [
      {s:'type', t:6}
   ],
   13419 : [
      {s:'num', t:6}
   ],
   13420 : [
   ],
   13500 : [
      {s:'name', t:7},
      {s:'sign', t:7},
      {s:'apply_type', t:2},
      {s:'apply_lev', t:2}
   ],
   13501 : [
      {s:'page', t:4},
      {s:'flag', t:2},
      {s:'num', t:4},
      {s:'name', t:7}
   ],
   13503 : [
      {s:'gid', t:6},
      {s:'gsrv_id', t:7},
      {s:'type', t:2}
   ],
   13505 : [
      {s:'type', t:2},
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   13507 : [
      {s:'page', t:2},
      {s:'num', t:2}
   ],
   13513 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   13514 : [
   ],
   13516 : [
   ],
   13518 : [
   ],
   13519 : [
   ],
   13520 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'position', t:2}
   ],
   13521 : [
      {s:'sign', t:7}
   ],
   13522 : [
      {s:'apply_type', t:2},
      {s:'apply_lev', t:2}
   ],
   13523 : [
   ],
   13524 : [
      {s:'type', t:2}
   ],
   13534 : [
   ],
   13535 : [
      {s:'type', t:2},
      {s:'num', t:4},
      {s:'msg_id', t:2},
      {s:'loss_type', t:2}
   ],
   13536 : [
      {s:'id', t:6}
   ],
   13540 : [
      {s:'id', t:6}
   ],
   13541 : [
   ],
   13545 : [
   ],
   13546 : [
   ],
   13558 : [
   ],
   13565 : [
   ],
   13568 : [
      {s:'name', t:7}
   ],
   13573 : [
   ],
   13574 : [
      {s:'box_id', t:2}
   ],
   13575 : [
   ],
   13576 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   13601 : [
   ],
   13602 : [
      {s:'type', t:2},
      {s:'day_type', t:6},
      {s:'id', t:6},
      {s:'item', t:6}
   ],
   13603 : [
   ],
   13604 : [
   ],
   13605 : [
   ],
   13606 : [
      {s:'id', t:6}
   ],
   13607 : [
   ],
   13608 : [
      {s:'id', t:4}
   ],
   14100 : [
   ],
   14101 : [
   ],
   14102 : [
   ],
   14103 : [
      {s:'id', t:2}
   ],
   16400 : [
   ],
   16401 : [
   ],
   16402 : [
      {s:'id', t:6}
   ],
   16601 : [
   ],
   16602 : [
   ],
   16603 : [
      {s:'bid', t:6}
   ],
   16604 : [
      {s:'bid', t:6},
      {s:'aim', t:6},
      {s:'arg', t:6}
   ],
   16605 : [
      {s:'bid_list', t:9, f:[
          {s:'bid', t:6}
      ]}
   ],
   16607 : [
   ],
   16620 : [
      {s:'id_list', t:9, f:[
          {s:'id', t:6}
      ]}
   ],
   16630 : [
   ],
   16631 : [
   ],
   16633 : [
   ],
   16634 : [
   ],
   16635 : [
   ],
   16636 : [
      {s:'number', t:7},
      {s:'code', t:7}
   ],
   16637 : [
   ],
   16638 : [
      {s:'type', t:6},
      {s:'type2', t:6}
   ],
   16639 : [
   ],
   16640 : [
      {s:'type', t:6},
      {s:'id', t:6}
   ],
   16641 : [
   ],
   16642 : [
      {s:'type', t:6}
   ],
   16643 : [
      {s:'type', t:6},
      {s:'type2', t:6}
   ],
   16650 : [
      {s:'bid', t:6}
   ],
   16660 : [
   ],
   16661 : [
      {s:'bid', t:6},
      {s:'aim', t:6},
      {s:'num', t:6}
   ],
   16665 : [
      {s:'bid', t:6},
      {s:'ids', t:9, f:[
          {s:'id', t:6},
          {s:'num', t:6}
      ]}
   ],
   16666 : [
      {s:'bid', t:6}
   ],
   16670 : [
   ],
   16671 : [
      {s:'count', t:2},
      {s:'flag', t:2}
   ],
   16672 : [
   ],
   16673 : [
      {s:'id', t:2}
   ],
   16674 : [
      {s:'type', t:2}
   ],
   16675 : [
      {s:'num', t:6}
   ],
   16676 : [
   ],
   16680 : [
   ],
   16681 : [
   ],
   16682 : [
      {s:'pos', t:2}
   ],
   16683 : [
   ],
   16684 : [
      {s:'num', t:4}
   ],
   16685 : [
      {s:'type', t:2}
   ],
   16686 : [
      {s:'partner_id', t:6},
      {s:'partner_bid', t:6},
      {s:'expend', t:9, f:[
          {s:'partner_id', t:6}
      ]}
   ],
   16687 : [
      {s:'bid', t:6}
   ],
   16688 : [
   ],
   16689 : [
      {s:'id', t:6},
      {s:'num', t:6}
   ],
   16691 : [
      {s:'id', t:2}
   ],
   16692 : [
      {s:'id', t:2}
   ],
   16693 : [
      {s:'id', t:2}
   ],
   16694 : [
      {s:'id', t:2}
   ],
   16695 : [
   ],
   16696 : [
   ],
   16697 : [
   ],
   16698 : [
   ],
   16700 : [
   ],
   16705 : [
   ],
   16706 : [
      {s:'card_type', t:2}
   ],
   16707 : [
   ],
   16708 : [
   ],
   16710 : [
   ],
   16711 : [
      {s:'lev', t:2}
   ],
   16712 : [
   ],
   16713 : [
      {s:'id', t:2}
   ],
   16730 : [
   ],
   16731 : [
   ],
   16800 : [
      {s:'idx', t:6},
      {s:'val', t:6},
      {s:'str', t:7}
   ],
   16801 : [
   ],
   16802 : [
   ],
   16900 : [
   ],
   16901 : [
   ],
   16903 : [
      {s:'id', t:6}
   ],
   16904 : [
   ],
   19800 : [
   ],
   19801 : [
      {s:'code', t:6}
   ],
   19802 : [
   ],
   19804 : [
   ],
   19805 : [
      {s:'id', t:2}
   ],
   19806 : [
   ],
   19807 : [
   ],
   19901 : [
      {s:'type', t:2}
   ],
   19902 : [
      {s:'type', t:2},
      {s:'cond_type', t:6},
      {s:'start', t:6},
      {s:'num', t:2}
   ],
   19903 : [
      {s:'id', t:6},
      {s:'srv_id', t:7},
      {s:'combat_type', t:2}
   ],
   19904 : [
      {s:'id', t:6},
      {s:'type', t:2},
      {s:'srv_id', t:7},
      {s:'combat_type', t:2}
   ],
   19905 : [
      {s:'id', t:6},
      {s:'channel', t:4},
      {s:'srv_id', t:7},
      {s:'combat_type', t:2}
   ],
   19906 : [
   ],
   19907 : [
      {s:'replay_id', t:6},
      {s:'partner_id', t:6},
      {s:'type', t:2},
      {s:'srv_id', t:7},
      {s:'combat_type', t:2}
   ],
   19908 : [
      {s:'replay_id', t:6},
      {s:'srv_id', t:7},
      {s:'type', t:2},
      {s:'channel', t:4}
   ],
   20000 : [
   ],
   20001 : [
   ],
   20002 : [
   ],
   20004 : [
   ],
   20005 : [
   ],
   20006 : [
   ],
   20008 : [
   ],
   20009 : [
   ],
   20013 : [
   ],
   20014 : [
      {s:'target_id', t:6},
      {s:'target_srv_id', t:7},
      {s:'is_province', t:2}
   ],
   20015 : [
      {s:'target_id', t:6},
      {s:'target_srv_id', t:7},
      {s:'is_agree', t:2}
   ],
   20016 : [
      {s:'target_id', t:6},
      {s:'target_srv_id', t:7},
      {s:'is_agree', t:2}
   ],
   20019 : [
   ],
   20020 : [
   ],
   20022 : [
      {s:'speed', t:2}
   ],
   20026 : [
   ],
   20027 : [
   ],
   20028 : [
   ],
   20029 : [
      {s:'replay_id', t:6}
   ],
   20030 : [
   ],
   20033 : [
   ],
   20034 : [
      {s:'replay_id', t:6},
      {s:'channel', t:4},
      {s:'target_name', t:7},
      {s:'share_type', t:2}
   ],
   20036 : [
      {s:'replay_id', t:6},
      {s:'replay_srv_id', t:7}
   ],
   20060 : [
      {s:'combat_type', t:4}
   ],
   20062 : [
   ],
   20063 : [
   ],
   20200 : [
   ],
   20201 : [
   ],
   20202 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   20203 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   20204 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'pos', t:2}
   ],
   20206 : [
   ],
   20207 : [
      {s:'num', t:4}
   ],
   20208 : [
   ],
   20209 : [
      {s:'num', t:2}
   ],
   20220 : [
   ],
   20221 : [
   ],
   20222 : [
   ],
   20223 : [
   ],
   20250 : [
   ],
   20251 : [
   ],
   20252 : [
   ],
   20253 : [
   ],
   20254 : [
      {s:'bet_type', t:2},
      {s:'bet_val', t:6}
   ],
   20255 : [
   ],
   20256 : [
   ],
   20258 : [
   ],
   20260 : [
   ],
   20261 : [
   ],
   20262 : [
   ],
   20263 : [
      {s:'group', t:2},
      {s:'pos', t:2}
   ],
   20280 : [
   ],
   20281 : [
   ],
   20300 : [
   ],
   20301 : [
      {s:'activity', t:4}
   ],
   20500 : [
   ],
   20501 : [
      {s:'boss_id', t:6}
   ],
   20502 : [
      {s:'boss_id', t:6}
   ],
   20530 : [
   ],
   20531 : [
   ],
   20532 : [
      {s:'boss_id', t:6}
   ],
   20533 : [
      {s:'boss_id', t:6}
   ],
   20535 : [
   ],
   20537 : [
      {s:'boss_id', t:6}
   ],
   20538 : [
      {s:'boss_id', t:6}
   ],
   20540 : [
   ],
   20541 : [
      {s:'boss_list', t:9, f:[
          {s:'boss_id', t:6}
      ]}
   ],
   20542 : [
   ],
   20600 : [
   ],
   20601 : [
   ],
   20602 : [
   ],
   20604 : [
   ],
   20605 : [
      {s:'plist', t:9, f:[
          {s:'id', t:6}
      ]}
   ],
   20606 : [
   ],
   20607 : [
      {s:'skill_id', t:6},
      {s:'val', t:6}
   ],
   20608 : [
      {s:'room_id', t:2}
   ],
   20609 : [
   ],
   20610 : [
      {s:'id', t:6}
   ],
   20611 : [
   ],
   20620 : [
      {s:'room_id', t:2},
      {s:'action', t:2},
      {s:'ext_list', t:9, f:[
          {s:'type', t:2},
          {s:'val', t:6}
      ]}
   ],
   20632 : [
   ],
   20633 : [
      {s:'id', t:6}
   ],
   20634 : [
   ],
   20635 : [
      {s:'id', t:6}
   ],
   20700 : [
   ],
   20701 : [
   ],
   20702 : [
      {s:'pos', t:2},
      {s:'num', t:2}
   ],
   20703 : [
      {s:'pos', t:2}
   ],
   21000 : [
   ],
   21001 : [
      {s:'id', t:2}
   ],
   21002 : [
   ],
   21003 : [
   ],
   21004 : [
   ],
   21005 : [
   ],
   21006 : [
   ],
   21007 : [
      {s:'type', t:2}
   ],
   21008 : [
   ],
   21009 : [
   ],
   21010 : [
   ],
   21011 : [
   ],
   21012 : [
   ],
   21013 : [
      {s:'id', t:2}
   ],
   21014 : [
      {s:'id', t:2}
   ],
   21015 : [
   ],
   21016 : [
      {s:'charge_id', t:6}
   ],
   21020 : [
   ],
   21100 : [
   ],
   21101 : [
      {s:'day', t:2}
   ],
   21200 : [
   ],
   21201 : [
      {s:'id', t:2}
   ],
   21210 : [
   ],
   21211 : [
   ],
   21220 : [
   ],
   21300 : [
   ],
   21303 : [
   ],
   21304 : [
      {s:'fid', t:6}
   ],
   21305 : [
   ],
   21308 : [
      {s:'boss_id', t:6},
      {s:'formation_type', t:4},
      {s:'pos_info', t:9, f:[
          {s:'pos', t:2},
          {s:'id', t:6}
      ]},
      {s:'hallows_id', t:6}
   ],
   21312 : [
      {s:'type', t:2}
   ],
   21317 : [
      {s:'boss_id', t:6}
   ],
   21318 : [
   ],
   21319 : [
      {s:'boss_id', t:6},
      {s:'start_num', t:6},
      {s:'end_num', t:6}
   ],
   21320 : [
   ],
   21321 : [
      {s:'fid', t:6}
   ],
   21322 : [
   ],
   21323 : [
   ],
   21401 : [
   ],
   21403 : [
   ],
   21410 : [
   ],
   21421 : [
      {s:'id', t:2}
   ],
   21425 : [
   ],
   21427 : [
      {s:'type', t:2},
      {s:'num', t:2}
   ],
   21500 : [
   ],
   21501 : [
      {s:'base_id', t:6}
   ],
   21502 : [
   ],
   21503 : [
      {s:'base_id', t:6}
   ],
   21504 : [
   ],
   22100 : [
   ],
   22101 : [
      {s:'step', t:2}
   ],
   22200 : [
   ],
   22202 : [
      {s:'id', t:2},
      {s:'list', t:9, f:[
          {s:'id', t:6}
      ]}
   ],
   22203 : [
      {s:'id', t:2}
   ],
   22204 : [
      {s:'id', t:2},
      {s:'list1', t:9, f:[
          {s:'id', t:6}
      ]},
      {s:'list2', t:9, f:[
          {s:'id', t:6}
      ]}
   ],
   22700 : [
      {s:'is_cluster', t:2}
   ],
   22701 : [
      {s:'id', t:2}
   ],
   22702 : [
   ],
   22703 : [
   ],
   22704 : [
      {s:'quest_id', t:6}
   ],
   23200 : [
   ],
   23201 : [
      {s:'group_id', t:4},
      {s:'times', t:2},
      {s:'recruit_type', t:2}
   ],
   23202 : [
   ],
   23203 : [
   ],
   23204 : [
   ],
   23205 : [
   ],
   23210 : [
   ],
   23211 : [
      {s:'id', t:6}
   ],
   23212 : [
   ],
   23213 : [
      {s:'group_id', t:4}
   ],
   23214 : [
   ],
   23215 : [
      {s:'partner_id', t:6},
      {s:'action', t:2}
   ],
   23216 : [
   ],
   23217 : [
      {s:'times', t:2},
      {s:'recruit_type', t:2}
   ],
   23218 : [
   ],
   23219 : [
      {s:'bid', t:6}
   ],
   23220 : [
   ],
   23221 : [
      {s:'times', t:2},
      {s:'recruit_type', t:2}
   ],
   23222 : [
   ],
   23300 : [
   ],
   23301 : [
      {s:'base_id', t:6}
   ],
   23302 : [
   ],
   23303 : [
      {s:'base_id', t:6}
   ],
   23400 : [
   ],
   23402 : [
   ],
   23403 : [
      {s:'id', t:2}
   ],
   23500 : [
      {s:'catalg', t:6}
   ],
   23501 : [
      {s:'base_id', t:6},
      {s:'num', t:4}
   ],
   23502 : [
      {s:'id', t:6},
      {s:'num', t:4}
   ],
   23504 : [
      {s:'package_type', t:2},
      {s:'item_id', t:6},
      {s:'num', t:2},
      {s:'percent', t:6},
      {s:'cell_id', t:2}
   ],
   23505 : [
      {s:'type', t:2},
      {s:'id', t:2},
      {s:'num', t:2}
   ],
   23506 : [
      {s:'cell_id', t:2}
   ],
   23507 : [
   ],
   23508 : [
      {s:'item_base_id', t:6}
   ],
   23509 : [
      {s:'refresh_type', t:2}
   ],
   23511 : [
      {s:'cell_id', t:2}
   ],
   23512 : [
   ],
   23513 : [
      {s:'cell_id', t:2},
      {s:'percent', t:6},
      {s:'num', t:2}
   ],
   23514 : [
      {s:'type', t:2}
   ],
   23516 : [
      {s:'base_ids', t:9, f:[
          {s:'base_id', t:6}
      ]}
   ],
   23518 : [
      {s:'catalg', t:6}
   ],
   23519 : [
   ],
   23520 : [
   ],
   23601 : [
   ],
   23602 : [
   ],
   23603 : [
   ],
   23604 : [
   ],
   23606 : [
   ],
   23607 : [
      {s:'id', t:2}
   ],
   23700 : [
      {s:'career', t:2}
   ],
   23701 : [
      {s:'skill_id', t:6}
   ],
   23702 : [
   ],
   23703 : [
   ],
   23800 : [
   ],
   23801 : [
   ],
   23802 : [
      {s:'order_id', t:6},
      {s:'assign_ids', t:9, f:[
          {s:'partner_id', t:6}
      ]}
   ],
   23803 : [
      {s:'order_id', t:6},
      {s:'type', t:2}
   ],
   23804 : [
   ],
   23805 : [
   ],
   23820 : [
   ],
   23821 : [
   ],
   23900 : [
   ],
   23901 : [
      {s:'formation_type', t:4},
      {s:'pos_info', t:9, f:[
          {s:'pos', t:2},
          {s:'owner_id', t:6},
          {s:'owner_srv_id', t:7},
          {s:'id', t:6}
      ]},
      {s:'hallows_id', t:6}
   ],
   23902 : [
   ],
   23903 : [
   ],
   23904 : [
      {s:'id', t:6}
   ],
   23905 : [
   ],
   23906 : [
   ],
   23907 : [
   ],
   23908 : [
      {s:'id', t:6}
   ],
   23909 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'id', t:6},
      {s:'flag', t:2}
   ],
   23910 : [
   ],
   23911 : [
      {s:'buff_id', t:4}
   ],
   24000 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   24001 : [
      {s:'type', t:2}
   ],
   24002 : [
   ],
   24003 : [
   ],
   24004 : [
   ],
   24005 : [
   ],
   24006 : [
   ],
   24010 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   24011 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   24012 : [
   ],
   24013 : [
      {s:'type', t:2}
   ],
   24014 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'id', t:6},
      {s:'type', t:2}
   ],
   24015 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'id', t:6}
   ],
   24017 : [
      {s:'id', t:6}
   ],
   24018 : [
   ],
   24019 : [
   ],
   24020 : [
   ],
   24100 : [
   ],
   24101 : [
      {s:'id', t:6},
      {s:'is_auto', t:2}
   ],
   24103 : [
      {s:'hallows_id', t:6}
   ],
   24104 : [
      {s:'hallows_id', t:6},
      {s:'num', t:6}
   ],
   24107 : [
   ],
   24108 : [
   ],
   24120 : [
   ],
   24121 : [
   ],
   24122 : [
      {s:'id', t:6}
   ],
   24123 : [
      {s:'id', t:6}
   ],
   24124 : [
   ],
   24125 : [
   ],
   24126 : [
   ],
   24127 : [
   ],
   24128 : [
   ],
   24129 : [
   ],
   24130 : [
      {s:'id', t:6}
   ],
   24131 : [
      {s:'id', t:6}
   ],
   24132 : [
      {s:'id', t:6},
      {s:'hallows_id', t:6},
      {s:'flag', t:2}
   ],
   24133 : [
   ],
   24200 : [
   ],
   24201 : [
      {s:'pos', t:6}
   ],
   24202 : [
      {s:'pos', t:2},
      {s:'hp', t:4},
      {s:'flag', t:2}
   ],
   24204 : [
   ],
   24205 : [
   ],
   24206 : [
   ],
   24207 : [
   ],
   24208 : [
   ],
   24209 : [
      {s:'g_id1', t:6},
      {s:'g_sid1', t:7},
      {s:'pos', t:6}
   ],
   24210 : [
   ],
   24212 : [
   ],
   24213 : [
   ],
   24214 : [
   ],
   24220 : [
   ],
   24221 : [
      {s:'order', t:4}
   ],
   24223 : [
   ],
   24300 : [
   ],
   24301 : [
   ],
   24302 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   24303 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   24304 : [
   ],
   24305 : [
   ],
   24306 : [
   ],
   24308 : [
   ],
   24309 : [
   ],
   24310 : [
   ],
   24311 : [
   ],
   24312 : [
   ],
   24313 : [
   ],
   24314 : [
   ],
   24315 : [
   ],
   24316 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'pos', t:2}
   ],
   24400 : [
   ],
   24401 : [
      {s:'id', t:2}
   ],
   24402 : [
      {s:'id', t:2}
   ],
   24403 : [
      {s:'formation_type', t:2},
      {s:'pos_info', t:9, f:[
          {s:'pos', t:2},
          {s:'owner_id', t:6},
          {s:'owner_srv_id', t:7},
          {s:'id', t:6}
      ]},
      {s:'hallows_id', t:6}
   ],
   24404 : [
   ],
   24405 : [
   ],
   24406 : [
   ],
   24407 : [
      {s:'id', t:6}
   ],
   24408 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'id', t:6}
   ],
   24409 : [
   ],
   24410 : [
   ],
   24411 : [
   ],
   24500 : [
   ],
   24501 : [
      {s:'id', t:6}
   ],
   24502 : [
   ],
   24600 : [
   ],
   24601 : [
   ],
   24602 : [
   ],
   24603 : [
      {s:'ret_list', t:9, f:[
          {s:'id', t:6},
          {s:'topic_type', t:2},
          {s:'ret', t:7}
      ]}
   ],
   24604 : [
   ],
   24700 : [
   ],
   24701 : [
      {s:'id', t:6}
   ],
   24702 : [
      {s:'id', t:6}
   ],
   24801 : [
   ],
   24802 : [
      {s:'id', t:2}
   ],
   24803 : [
      {s:'id', t:2}
   ],
   24804 : [
   ],
   24805 : [
   ],
   24806 : [
      {s:'id', t:6}
   ],
   24807 : [
      {s:'id', t:4}
   ],
   24808 : [
   ],
   24809 : [
   ],
   24810 : [
   ],
   24811 : [
   ],
   24812 : [
      {s:'id', t:6}
   ],
   24813 : [
   ],
   24814 : [
      {s:'id', t:6}
   ],
   24815 : [
   ],
   24816 : [
      {s:'id', t:6}
   ],
   24817 : [
   ],
   24818 : [
      {s:'id', t:6}
   ],
   25100 : [
   ],
   25101 : [
      {s:'id', t:6}
   ],
   25102 : [
   ],
   25300 : [
   ],
   25301 : [
   ],
   25302 : [
      {s:'id', t:6}
   ],
   25303 : [
   ],
   25304 : [
      {s:'id', t:4}
   ],
   25305 : [
   ],
   25306 : [
   ],
   25307 : [
      {s:'id', t:4}
   ],
   25308 : [
   ],
   25309 : [
   ],
   25400 : [
   ],
   25401 : [
   ],
   25402 : [
   ],
   25403 : [
   ],
   25404 : [
   ],
   25405 : [
   ],
   25410 : [
   ],
   25411 : [
   ],
   25412 : [
   ],
   25413 : [
   ],
   25414 : [
   ],
   25800 : [
      {s:'city_id', t:6}
   ],
   25801 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   25802 : [
   ],
   25805 : [
      {s:'pos', t:2},
      {s:'id', t:6}
   ],
   25806 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   25807 : [
   ],
   25810 : [
   ],
   25811 : [
   ],
   25812 : [
      {s:'id', t:6}
   ],
   25813 : [
      {s:'id', t:6}
   ],
   25814 : [
   ],
   25815 : [
      {s:'id', t:6},
      {s:'channel', t:4}
   ],
   25816 : [
      {s:'share_id', t:6},
      {s:'srv_id', t:7}
   ],
   25817 : [
      {s:'id', t:6},
      {s:'channel', t:4}
   ],
   25818 : [
      {s:'share_id', t:6},
      {s:'srv_id', t:7}
   ],
   25819 : [
      {s:'channel', t:4}
   ],
   25820 : [
      {s:'share_id', t:6},
      {s:'srv_id', t:7}
   ],
   25830 : [
      {s:'start', t:4},
      {s:'num', t:2}
   ],
   25831 : [
      {s:'channel', t:4}
   ],
   25832 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'start', t:4},
      {s:'num', t:2}
   ],
   25835 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'msg', t:7}
   ],
   25836 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'bbs_id', t:6},
      {s:'msg', t:7}
   ],
   25837 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'start', t:4},
      {s:'num', t:2}
   ],
   25838 : [
      {s:'bbs_id', t:6}
   ],
   25839 : [
      {s:'type', t:2}
   ],
   25840 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'bbs_id', t:6}
   ],
   25841 : [
   ],
   30001 : [
   ],
   30002 : [
      {s:'id', t:6}
   ],
   30100 : [
   ],
   30101 : [
   ],
   30102 : [
   ]
};

module.exports.recv = {
   10101 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'reg_time', t:6}
   ],
   10102 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'timestamp', t:6},
      {s:'world_lev', t:4}
   ],
   10103 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'timestamp', t:6},
      {s:'world_lev', t:4}
   ],
   10200 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'battle_id', t:6},
      {s:'id', t:6},
      {s:'time', t:6}
   ],
   10210 : [
      {s:'bid', t:6},
      {s:'res_id', t:6},
      {s:'x', t:4},
      {s:'y', t:4},
      {s:'dir', t:2}
   ],
   10211 : [
      {s:'bid', t:6},
      {s:'dynamic_block', t:9, f:[
          {s:'id', t:2},
          {s:'val', t:2}
      ]}
   ],
   10213 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'speed', t:4},
      {s:'dir', t:2},
      {s:'x', t:4},
      {s:'y', t:4},
      {s:'face', t:6},
      {s:'lev', t:2},
      {s:'sex', t:2},
      {s:'avatar', t:6},
      {s:'status', t:2},
      {s:'event', t:2},
      {s:'looks', t:9, f:[
          {s:'looks_type', t:6},
          {s:'looks_mode', t:6},
          {s:'looks_val', t:6},
          {s:'looks_str', t:7}
      ]}
   ],
   10214 : [
      {s:'bid', t:6},
      {s:'role_ids', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7}
      ]}
   ],
   10215 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'dir', t:2},
      {s:'dx', t:4},
      {s:'dy', t:4}
   ],
   10216 : [
      {s:'role_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'speed', t:4},
          {s:'dir', t:2},
          {s:'x', t:4},
          {s:'y', t:4},
          {s:'face', t:6},
          {s:'lev', t:2},
          {s:'sex', t:2},
          {s:'avatar', t:6},
          {s:'status', t:2},
          {s:'event', t:2},
          {s:'looks', t:9, f:[
              {s:'looks_type', t:6},
              {s:'looks_mode', t:6},
              {s:'looks_val', t:6},
              {s:'looks_str', t:7}
          ]}
      ]}
   ],
   10217 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'speed', t:4},
      {s:'dir', t:2},
      {s:'x', t:4},
      {s:'y', t:4},
      {s:'face', t:6},
      {s:'lev', t:2},
      {s:'sex', t:2},
      {s:'avatar', t:6},
      {s:'status', t:2},
      {s:'event', t:2},
      {s:'looks', t:9, f:[
          {s:'looks_type', t:6},
          {s:'looks_mode', t:6},
          {s:'looks_val', t:6},
          {s:'looks_str', t:7}
      ]}
   ],
   10219 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'type', t:2},
      {s:'looks', t:9, f:[
          {s:'looks_type', t:6},
          {s:'looks_mode', t:6},
          {s:'looks_val', t:6},
          {s:'looks_str', t:7}
      ]}
   ],
   10220 : [
      {s:'unit_list', t:9, f:[
          {s:'battle_id', t:6},
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'name', t:7},
          {s:'status', t:2},
          {s:'speed', t:4},
          {s:'x', t:4},
          {s:'y', t:4},
          {s:'lev', t:2},
          {s:'looks', t:9, f:[
              {s:'looks_type', t:6},
              {s:'looks_mode', t:6},
              {s:'looks_val', t:6},
              {s:'looks_str', t:7}
          ]}
      ]}
   ],
   10222 : [
      {s:'role_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'speed', t:4},
          {s:'dir', t:2},
          {s:'x', t:4},
          {s:'y', t:4},
          {s:'face', t:6},
          {s:'lev', t:2},
          {s:'sex', t:2},
          {s:'avatar', t:6},
          {s:'status', t:2},
          {s:'event', t:2},
          {s:'looks', t:9, f:[
              {s:'looks_type', t:6},
              {s:'looks_mode', t:6},
              {s:'looks_val', t:6},
              {s:'looks_str', t:7}
          ]}
      ]}
   ],
   10250 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'act_type', t:6},
      {s:'num', t:2}
   ],
   10260 : [
      {s:'battle_id', t:6},
      {s:'id', t:6},
      {s:'base_id', t:6},
      {s:'name', t:7},
      {s:'status', t:2},
      {s:'speed', t:4},
      {s:'x', t:4},
      {s:'y', t:4},
      {s:'lev', t:2},
      {s:'looks', t:9, f:[
          {s:'looks_type', t:6},
          {s:'looks_mode', t:6},
          {s:'looks_val', t:6},
          {s:'looks_str', t:7}
      ]}
   ],
   10262 : [
      {s:'battle_id', t:6},
      {s:'id', t:6}
   ],
   10264 : [
      {s:'battle_id', t:6},
      {s:'id', t:6},
      {s:'dx', t:4},
      {s:'dy', t:4}
   ],
   10265 : [
      {s:'battle_id', t:6},
      {s:'id', t:6},
      {s:'msg', t:7}
   ],
   10266 : [
      {s:'battle_id', t:6},
      {s:'id', t:6},
      {s:'base_id', t:6},
      {s:'name', t:7},
      {s:'status', t:2},
      {s:'speed', t:4},
      {s:'x', t:4},
      {s:'y', t:4},
      {s:'lev', t:2},
      {s:'looks', t:9, f:[
          {s:'looks_type', t:6},
          {s:'looks_mode', t:6},
          {s:'looks_val', t:6},
          {s:'looks_str', t:7}
      ]}
   ],
   10300 : [
   ],
   10301 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'lev', t:4},
      {s:'is_vip', t:2},
      {s:'vip_lev', t:2},
      {s:'vip_exp', t:6},
      {s:'is_show_vip', t:2},
      {s:'sex', t:2},
      {s:'career', t:4},
      {s:'face_id', t:6},
      {s:'event', t:2},
      {s:'gid', t:6},
      {s:'gsrv_id', t:7},
      {s:'position', t:2},
      {s:'gname', t:7},
      {s:'signature', t:7},
      {s:'exp_max', t:6},
      {s:'exp_total_nextlev', t:6},
      {s:'buffs', t:9, f:[
          {s:'bid', t:6},
          {s:'duration', t:6},
          {s:'count', t:2},
          {s:'effect', t:9, f:[
              {s:'key', t:2},
              {s:'val', t:6}
          ]}
      ]},
      {s:'reg_time', t:6},
      {s:'guild_lev', t:2},
      {s:'power', t:6},
      {s:'is_first_rename', t:2},
      {s:'avatar_base_id', t:6},
      {s:'guild_quit_time', t:6},
      {s:'look_id', t:6},
      {s:'max_power', t:6},
      {s:'auto_pk', t:2},
      {s:'vip_card_exp', t:6},
      {s:'dun_id', t:6},
      {s:'chapter_id', t:6}
   ],
   10302 : [
      {s:'lev', t:4},
      {s:'exp', t:6},
      {s:'gold', t:6},
      {s:'gold_acc', t:6},
      {s:'coin', t:6},
      {s:'red_gold', t:6},
      {s:'energy', t:6},
      {s:'energy_max', t:6},
      {s:'arena_cent', t:6},
      {s:'activity', t:4},
      {s:'guild', t:6},
      {s:'hero_soul', t:6},
      {s:'friend_point', t:6},
      {s:'boss_point', t:6},
      {s:'silver_coin', t:6},
      {s:'star_hun', t:6},
      {s:'star_point', t:6},
      {s:'arena_guesscent', t:6},
      {s:'sky_coin', t:6},
      {s:'hero_exp', t:6},
      {s:'recruit_hero', t:6},
      {s:'recruithigh_hero', t:6},
      {s:'expedition_medal', t:6}
   ],
   10304 : [
   ],
   10305 : [
      {s:'assets', t:9, f:[
          {s:'label', t:2},
          {s:'val', t:6}
      ]}
   ],
   10306 : [
      {s:'power', t:6},
      {s:'max_power', t:6}
   ],
   10307 : [
      {s:'event', t:2}
   ],
   10309 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'signature', t:7}
   ],
   10310 : [
      {s:'is_show', t:2},
      {s:'msg', t:7}
   ],
   10312 : [
   ],
   10315 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'gname', t:7},
      {s:'lev', t:4},
      {s:'face_id', t:6},
      {s:'power', t:6},
      {s:'partner_list', t:9, f:[
          {s:'id', t:6},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'quality', t:2},
          {s:'awaken_lev', t:6},
          {s:'use_skin', t:6}
      ]},
      {s:'gid', t:6},
      {s:'gsrv_id', t:7},
      {s:'avatar_bid', t:6},
      {s:'sex', t:2},
      {s:'city', t:6},
      {s:'vip_lev', t:6},
      {s:'honor_list', t:9, f:[
          {s:'type', t:6},
          {s:'val', t:6},
          {s:'rank', t:2}
      ]}
   ],
   10316 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'type', t:2},
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'idx', t:6}
   ],
   10317 : [
      {s:'worship', t:6}
   ],
   10318 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'auto_pk', t:2}
   ],
   10322 : [
      {s:'code1', t:2}
   ],
   10323 : [
      {s:'code', t:2}
   ],
   10325 : [
      {s:'face_list', t:9, f:[
          {s:'face_id', t:6}
      ]}
   ],
   10327 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'face_id', t:6}
   ],
   10342 : [
   ],
   10343 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'name', t:7},
      {s:'sex', t:2}
   ],
   10344 : [
      {s:'old_lev', t:4},
      {s:'lev', t:4}
   ],
   10345 : [
      {s:'use_id', t:6},
      {s:'list', t:9, f:[
          {s:'id', t:6}
      ]}
   ],
   10346 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   10347 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   10348 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'is_show_vip', t:2}
   ],
   10350 : [
      {s:'holiday_assets', t:9, f:[
          {s:'id', t:6},
          {s:'val', t:6}
      ]}
   ],
   10351 : [
      {s:'holiday_assets', t:9, f:[
          {s:'id', t:6},
          {s:'val', t:6}
      ]}
   ],
   10380 : [
      {s:'reg_time', t:6},
      {s:'open_time', t:6}
   ],
   10391 : [
      {s:'type', t:2},
      {s:'data', t:7}
   ],
   10395 : [
      {s:'status', t:2},
      {s:'end_time', t:6},
      {s:'down_sec', t:6}
   ],
   10396 : [
   ],
   10397 : [
   ],
   10399 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   10400 : [
      {s:'quest_list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'accept_time', t:6},
          {s:'progress', t:9, f:[
              {s:'id', t:3},
              {s:'finish', t:2},
              {s:'target', t:6},
              {s:'target_val', t:6},
              {s:'value', t:6},
              {s:'ext_data', t:9, f:[
                  {s:'key', t:2},
                  {s:'value', t:6}
              ]}
          ]}
      ]}
   ],
   10402 : [
      {s:'flag', t:1},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   10403 : [
      {s:'quest_list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'accept_time', t:6},
          {s:'progress', t:9, f:[
              {s:'id', t:3},
              {s:'finish', t:2},
              {s:'target', t:6},
              {s:'target_val', t:6},
              {s:'value', t:6},
              {s:'ext_data', t:9, f:[
                  {s:'key', t:2},
                  {s:'value', t:6}
              ]}
          ]}
      ]}
   ],
   10404 : [
      {s:'quest_list', t:9, f:[
          {s:'id', t:6}
      ]}
   ],
   10405 : [
      {s:'flag', t:1},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   10406 : [
      {s:'flag', t:1},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   10407 : [
      {s:'quest_list', t:9, f:[
          {s:'id', t:6}
      ]}
   ],
   10408 : [
      {s:'quest_list', t:9, f:[
          {s:'id', t:6}
      ]}
   ],
   10409 : [
      {s:'quest_list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'accept_time', t:6},
          {s:'progress', t:9, f:[
              {s:'id', t:3},
              {s:'finish', t:2},
              {s:'target', t:6},
              {s:'target_val', t:6},
              {s:'value', t:6},
              {s:'ext_data', t:9, f:[
                  {s:'key', t:2},
                  {s:'value', t:6}
              ]}
          ]}
      ]}
   ],
   10500 : [
      {s:'volume', t:6},
      {s:'open_times', t:2},
      {s:'item_list', t:9, f:[
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'bind', t:2},
          {s:'quantity', t:6},
          {s:'pos', t:4},
          {s:'expire_type', t:2},
          {s:'expire_time', t:6},
          {s:'main_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'enchant', t:6},
          {s:'attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'extra_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'score', t:6},
          {s:'all_score', t:6},
          {s:'extra', t:9, f:[
              {s:'extra_k', t:6},
              {s:'extra_v', t:6}
          ]}
      ]}
   ],
   10501 : [
      {s:'volume', t:6},
      {s:'open_times', t:2},
      {s:'item_list', t:9, f:[
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'bind', t:2},
          {s:'quantity', t:6},
          {s:'pos', t:4},
          {s:'expire_type', t:2},
          {s:'expire_time', t:6},
          {s:'main_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'enchant', t:6},
          {s:'attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'extra_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'score', t:6},
          {s:'all_score', t:6},
          {s:'extra', t:9, f:[
              {s:'extra_k', t:6},
              {s:'extra_v', t:6}
          ]},
          {s:'gemstones', t:9, f:[
              {s:'lev', t:6}
          ]}
      ]}
   ],
   10510 : [
      {s:'item_list', t:9, f:[
          {s:'storage', t:2},
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'bind', t:2},
          {s:'quantity', t:6},
          {s:'pos', t:4},
          {s:'expire_type', t:2},
          {s:'expire_time', t:6},
          {s:'main_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'enchant', t:6},
          {s:'attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'extra_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'score', t:6},
          {s:'all_score', t:6},
          {s:'extra', t:9, f:[
              {s:'extra_k', t:6},
              {s:'extra_v', t:6}
          ]},
          {s:'gemstones', t:9, f:[
              {s:'lev', t:6}
          ]}
      ]}
   ],
   10511 : [
      {s:'item_list', t:9, f:[
          {s:'storage', t:2},
          {s:'id', t:6},
          {s:'pos', t:4}
      ]}
   ],
   10512 : [
      {s:'item_list', t:9, f:[
          {s:'storage', t:2},
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'bind', t:2},
          {s:'quantity', t:6},
          {s:'pos', t:4},
          {s:'expire_type', t:2},
          {s:'expire_time', t:6},
          {s:'main_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'enchant', t:6},
          {s:'attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'extra_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'score', t:6},
          {s:'all_score', t:6},
          {s:'extra', t:9, f:[
              {s:'extra_k', t:6},
              {s:'extra_v', t:6}
          ]},
          {s:'gemstones', t:9, f:[
              {s:'lev', t:6}
          ]}
      ]}
   ],
   10515 : [
      {s:'flag', t:2},
      {s:'base_id', t:6},
      {s:'msg', t:7}
   ],
   10520 : [
      {s:'id', t:6},
      {s:'storage', t:2},
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   10522 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   10523 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   10524 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   10525 : [
      {s:'star_list', t:9, f:[
          {s:'star', t:2}
      ]}
   ],
   10526 : [
      {s:'type', t:2},
      {s:'volume', t:6},
      {s:'open_times', t:2}
   ],
   10528 : [
      {s:'time', t:6},
      {s:'minu_exp', t:6}
   ],
   10530 : [
   ],
   10535 : [
      {s:'flag', t:2},
      {s:'msg', t:7},
      {s:'share_id', t:6},
      {s:'base_id', t:6},
      {s:'count', t:6},
      {s:'code', t:6}
   ],
   10536 : [
      {s:'base_id', t:6},
      {s:'quantity', t:6},
      {s:'pos', t:4},
      {s:'expire_type', t:2},
      {s:'expire_time', t:6},
      {s:'main_attr', t:9, f:[
          {s:'attr_id', t:6},
          {s:'attr_val', t:6}
      ]},
      {s:'enchant', t:6},
      {s:'attr', t:9, f:[
          {s:'attr_id', t:6},
          {s:'attr_val', t:6}
      ]},
      {s:'score', t:6},
      {s:'all_score', t:6},
      {s:'extra', t:9, f:[
          {s:'extra_k', t:6},
          {s:'extra_v', t:6}
      ]},
      {s:'gemstones', t:9, f:[
          {s:'lev', t:6}
      ]}
   ],
   10800 : [
      {s:'mail', t:9, f:[
          {s:'id', t:6},
          {s:'srv_id', t:7},
          {s:'type', t:2},
          {s:'from_name', t:7},
          {s:'subject', t:7},
          {s:'content', t:7},
          {s:'assets', t:9, f:[
              {s:'label', t:2},
              {s:'val', t:6}
          ]},
          {s:'items', t:9, f:[
              {s:'base_id', t:6},
              {s:'quantity', t:6}
          ]},
          {s:'send_time', t:6},
          {s:'read_time', t:6},
          {s:'time_out', t:6},
          {s:'status', t:2}
      ]}
   ],
   10801 : [
      {s:'id', t:6},
      {s:'srv_id', t:7},
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   10802 : [
      {s:'ids', t:9, f:[
          {s:'id', t:6},
          {s:'srv_id', t:7},
          {s:'read_time', t:6}
      ]},
      {s:'msg', t:7}
   ],
   10803 : [
      {s:'mail', t:9, f:[
          {s:'id', t:6},
          {s:'srv_id', t:7},
          {s:'type', t:2},
          {s:'from_name', t:7},
          {s:'subject', t:7},
          {s:'content', t:7},
          {s:'assets', t:9, f:[
              {s:'label', t:2},
              {s:'val', t:6}
          ]},
          {s:'items', t:9, f:[
              {s:'base_id', t:6},
              {s:'quantity', t:6}
          ]},
          {s:'send_time', t:6},
          {s:'read_time', t:6},
          {s:'time_out', t:6},
          {s:'status', t:2}
      ]}
   ],
   10804 : [
      {s:'ids', t:9, f:[
          {s:'id', t:6},
          {s:'srv_id', t:7}
      ]},
      {s:'msg', t:7}
   ],
   10805 : [
      {s:'id', t:6},
      {s:'srv_id', t:7},
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'read_time', t:6},
      {s:'is_delete', t:2}
   ],
   10810 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   10900 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   10901 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   10902 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   10905 : [
      {s:'world_lev', t:2}
   ],
   10906 : [
      {s:'open_day', t:6}
   ],
   10911 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'buffs', t:9, f:[
          {s:'bid', t:6},
          {s:'duration', t:6},
          {s:'count', t:2},
          {s:'effect', t:9, f:[
              {s:'key', t:2},
              {s:'val', t:6}
          ]}
      ]}
   ],
   10912 : [
      {s:'bid', t:6},
      {s:'effect', t:9, f:[
          {s:'key', t:2},
          {s:'val', t:6}
      ]}
   ],
   10913 : [
      {s:'buffs', t:9, f:[
          {s:'change_type', t:2},
          {s:'bid', t:6},
          {s:'duration', t:6},
          {s:'count', t:2},
          {s:'effect', t:9, f:[
              {s:'key', t:2},
              {s:'val', t:5}
          ]}
      ]}
   ],
   10922 : [
      {s:'act_list', t:9, f:[
          {s:'id', t:4},
          {s:'status', t:2},
          {s:'int_args', t:9, f:[
              {s:'val', t:6}
          ]},
          {s:'ext_args', t:9, f:[
              {s:'type', t:2},
              {s:'val', t:6},
              {s:'str', t:7}
          ]}
      ]}
   ],
   10923 : [
      {s:'id', t:4},
      {s:'status', t:2},
      {s:'int_args', t:9, f:[
          {s:'val', t:6}
      ]},
      {s:'ext_args', t:9, f:[
          {s:'type', t:2},
          {s:'val', t:6},
          {s:'str', t:7}
      ]}
   ],
   10924 : [
      {s:'act_list', t:9, f:[
          {s:'id', t:4},
          {s:'status', t:2},
          {s:'int_args', t:9, f:[
              {s:'val', t:6}
          ]},
          {s:'ext_args', t:9, f:[
              {s:'type', t:2},
              {s:'val', t:6},
              {s:'str', t:7}
          ]}
      ]}
   ],
   10925 : [
      {s:'id', t:4},
      {s:'status', t:2},
      {s:'int_args', t:9, f:[
          {s:'val', t:6}
      ]},
      {s:'ext_args', t:9, f:[
          {s:'type', t:2},
          {s:'val', t:6},
          {s:'str', t:7}
      ]}
   ],
   10926 : [
      {s:'time', t:6},
      {s:'list', t:9, f:[
          {s:'time', t:6}
      ]}
   ],
   10927 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'time', t:6}
   ],
   10945 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   10946 : [
      {s:'code', t:2}
   ],
   10950 : [
      {s:'type', t:2},
      {s:'board_list', t:9, f:[
          {s:'id', t:6},
          {s:'type', t:2},
          {s:'title', t:7},
          {s:'summary', t:7},
          {s:'content', t:7},
          {s:'start_time', t:6},
          {s:'end_time', t:6},
          {s:'flag', t:2}
      ]}
   ],
   10951 : [
      {s:'id', t:6}
   ],
   10952 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   10955 : [
      {s:'key', t:4},
      {s:'val', t:6}
   ],
   10956 : [
   ],
   10994 : [
      {s:'type', t:2}
   ],
   10995 : [
      {s:'main_srv_id', t:7},
      {s:'srv_list', t:9, f:[
          {s:'srv_id', t:7}
      ]}
   ],
   10996 : [
      {s:'cli_ver_list', t:9, f:[
          {s:'cdn_patch', t:7},
          {s:'cli_ver', t:4}
      ]}
   ],
   10997 : [
      {s:'flag', t:2}
   ],
   10999 : [
   ],
   1110 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'roles', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'sex', t:2},
          {s:'career', t:4},
          {s:'face_id', t:6},
          {s:'is_online', t:2}
      ]},
      {s:'least_career', t:2}
   ],
   1198 : [
      {s:'time', t:6}
   ],
   1199 : [
      {s:'time', t:6}
   ],
   11000 : [
      {s:'sort_type', t:2},
      {s:'num', t:6},
      {s:'buy_num', t:2},
      {s:'partners', t:9, f:[
          {s:'partner_id', t:6},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'skills', t:9, f:[
              {s:'pos', t:2},
              {s:'skill_bid', t:6}
          ]},
          {s:'break_lev', t:2},
          {s:'power', t:6},
          {s:'is_lock', t:9, f:[
              {s:'lock_type', t:6},
              {s:'is_lock', t:2}
          ]},
          {s:'use_skin', t:6},
          {s:'atk', t:6},
          {s:'def_p', t:6},
          {s:'def_s', t:6},
          {s:'hp', t:6},
          {s:'speed', t:6},
          {s:'hit_rate', t:6},
          {s:'dodge_rate', t:6},
          {s:'crit_rate', t:6},
          {s:'crit_ratio', t:6},
          {s:'hit_magic', t:6},
          {s:'dodge_magic', t:6},
          {s:'def', t:6},
          {s:'atk2', t:6},
          {s:'hp2', t:6},
          {s:'def2', t:6},
          {s:'speed2', t:6},
          {s:'eqms', t:9, f:[
              {s:'id', t:6},
              {s:'base_id', t:6},
              {s:'type', t:6}
          ]},
          {s:'artifacts', t:9, f:[
              {s:'artifact_pos', t:2},
              {s:'id', t:6},
              {s:'base_id', t:6},
              {s:'enchant', t:6},
              {s:'attr', t:9, f:[
                  {s:'attr_id', t:6},
                  {s:'attr_val', t:6}
              ]},
              {s:'extra_attr', t:9, f:[
                  {s:'attr_id', t:6},
                  {s:'attr_val', t:6}
              ]},
              {s:'extra', t:9, f:[
                  {s:'extra_k', t:6},
                  {s:'extra_v', t:6}
              ]}
          ]}
      ]}
   ],
   11001 : [
      {s:'partners', t:9, f:[
          {s:'partner_id', t:6},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'skills', t:9, f:[
              {s:'pos', t:2},
              {s:'skill_bid', t:6}
          ]},
          {s:'break_lev', t:2},
          {s:'power', t:6},
          {s:'is_lock', t:9, f:[
              {s:'lock_type', t:6},
              {s:'is_lock', t:2}
          ]},
          {s:'use_skin', t:6},
          {s:'atk', t:6},
          {s:'def_p', t:6},
          {s:'def_s', t:6},
          {s:'hp', t:6},
          {s:'speed', t:6},
          {s:'hit_rate', t:6},
          {s:'dodge_rate', t:6},
          {s:'crit_rate', t:6},
          {s:'crit_ratio', t:6},
          {s:'hit_magic', t:6},
          {s:'dodge_magic', t:6},
          {s:'def', t:6},
          {s:'atk2', t:6},
          {s:'hp2', t:6},
          {s:'def2', t:6},
          {s:'speed2', t:6},
          {s:'eqms', t:9, f:[
              {s:'id', t:6},
              {s:'base_id', t:6},
              {s:'type', t:6}
          ]},
          {s:'artifacts', t:9, f:[
              {s:'artifact_pos', t:2},
              {s:'id', t:6},
              {s:'base_id', t:6},
              {s:'enchant', t:6},
              {s:'attr', t:9, f:[
                  {s:'attr_id', t:6},
                  {s:'attr_val', t:6}
              ]},
              {s:'extra_attr', t:9, f:[
                  {s:'attr_id', t:6},
                  {s:'attr_val', t:6}
              ]},
              {s:'extra', t:9, f:[
                  {s:'extra_k', t:6},
                  {s:'extra_v', t:6}
              ]}
          ]}
      ]}
   ],
   11002 : [
      {s:'partner_id', t:6},
      {s:'bid', t:6},
      {s:'lev', t:4},
      {s:'star', t:2},
      {s:'skills', t:9, f:[
          {s:'pos', t:2},
          {s:'skill_bid', t:6}
      ]},
      {s:'break_lev', t:2},
      {s:'power', t:6},
      {s:'is_lock', t:9, f:[
          {s:'lock_type', t:6},
          {s:'is_lock', t:2}
      ]},
      {s:'use_skin', t:6},
      {s:'atk', t:6},
      {s:'def_p', t:6},
      {s:'def_s', t:6},
      {s:'hp', t:6},
      {s:'speed', t:6},
      {s:'hit_rate', t:6},
      {s:'dodge_rate', t:6},
      {s:'crit_rate', t:6},
      {s:'crit_ratio', t:6},
      {s:'hit_magic', t:6},
      {s:'dodge_magic', t:6},
      {s:'def', t:6},
      {s:'atk2', t:6},
      {s:'hp2', t:6},
      {s:'def2', t:6},
      {s:'speed2', t:6}
   ],
   11003 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11004 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11005 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11006 : [
      {s:'expend2', t:9, f:[
          {s:'partner_id', t:6}
      ]}
   ],
   11007 : [
      {s:'ref_partners', t:9, f:[
          {s:'partner_id', t:6},
          {s:'power', t:6},
          {s:'atk', t:6},
          {s:'def_p', t:6},
          {s:'def_s', t:6},
          {s:'hp', t:6},
          {s:'speed', t:6},
          {s:'hit_rate', t:6},
          {s:'dodge_rate', t:6},
          {s:'crit_rate', t:6},
          {s:'crit_ratio', t:6},
          {s:'hit_magic', t:6},
          {s:'dodge_magic', t:6},
          {s:'def', t:6}
      ]}
   ],
   11008 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'partners', t:9, f:[
          {s:'partner_bid', t:6}
      ]}
   ],
   11009 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'num', t:6},
      {s:'buy_num', t:2}
   ],
   11010 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11011 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11012 : [
      {s:'partner_id', t:6},
      {s:'power', t:6},
      {s:'atk', t:6},
      {s:'def_p', t:6},
      {s:'def_s', t:6},
      {s:'hp', t:6},
      {s:'speed', t:6},
      {s:'hit_rate', t:6},
      {s:'dodge_rate', t:6},
      {s:'crit_rate', t:6},
      {s:'crit_ratio', t:6},
      {s:'hit_magic', t:6},
      {s:'dodge_magic', t:6},
      {s:'def', t:6},
      {s:'eqms', t:9, f:[
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'type', t:6}
      ]}
   ],
   11015 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'partner_id', t:6},
      {s:'type', t:2}
   ],
   11016 : [
      {s:'atk', t:6},
      {s:'def_p', t:6},
      {s:'def_s', t:6},
      {s:'hp', t:6},
      {s:'speed', t:6},
      {s:'hit_rate', t:6},
      {s:'dodge_rate', t:6},
      {s:'crit_rate', t:6},
      {s:'crit_ratio', t:6},
      {s:'hit_magic', t:6},
      {s:'dodge_magic', t:6},
      {s:'def', t:6}
   ],
   11017 : [
      {s:'num', t:6}
   ],
   11019 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'partner_id', t:6}
   ],
   11020 : [
      {s:'partner_skins', t:9, f:[
          {s:'id', t:6},
          {s:'end_time', t:6}
      ]}
   ],
   11025 : [
      {s:'sort_type', t:2},
      {s:'num', t:6},
      {s:'buy_num', t:2},
      {s:'partners', t:9, f:[
          {s:'partner_id', t:6},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'skills', t:9, f:[
              {s:'pos', t:2},
              {s:'skill_bid', t:6}
          ]},
          {s:'break_lev', t:2},
          {s:'power', t:6},
          {s:'is_lock', t:9, f:[
              {s:'lock_type', t:6},
              {s:'is_lock', t:2}
          ]},
          {s:'use_skin', t:6}
      ]}
   ],
   11026 : [
      {s:'partners', t:9, f:[
          {s:'partner_id', t:6},
          {s:'atk', t:6},
          {s:'def_p', t:6},
          {s:'def_s', t:6},
          {s:'hp', t:6},
          {s:'speed', t:6},
          {s:'hit_rate', t:6},
          {s:'dodge_rate', t:6},
          {s:'crit_rate', t:6},
          {s:'crit_ratio', t:6},
          {s:'hit_magic', t:6},
          {s:'dodge_magic', t:6},
          {s:'def', t:6},
          {s:'eqms', t:9, f:[
              {s:'id', t:6},
              {s:'base_id', t:6},
              {s:'type', t:6}
          ]},
          {s:'artifacts', t:9, f:[
              {s:'artifact_pos', t:2},
              {s:'id', t:6},
              {s:'base_id', t:6},
              {s:'enchant', t:6},
              {s:'attr', t:9, f:[
                  {s:'attr_id', t:6},
                  {s:'attr_val', t:6}
              ]},
              {s:'extra_attr', t:9, f:[
                  {s:'attr_id', t:6},
                  {s:'attr_val', t:6}
              ]},
              {s:'extra', t:9, f:[
                  {s:'extra_k', t:6},
                  {s:'extra_v', t:6}
              ]}
          ]}
      ]}
   ],
   11030 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11031 : [
      {s:'partner_id', t:6},
      {s:'power', t:6},
      {s:'atk', t:6},
      {s:'def_p', t:6},
      {s:'def_s', t:6},
      {s:'hp', t:6},
      {s:'speed', t:6},
      {s:'hit_rate', t:6},
      {s:'dodge_rate', t:6},
      {s:'crit_rate', t:6},
      {s:'crit_ratio', t:6},
      {s:'hit_magic', t:6},
      {s:'dodge_magic', t:6},
      {s:'def', t:6},
      {s:'artifacts', t:9, f:[
          {s:'artifact_pos', t:2},
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'enchant', t:6},
          {s:'attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'extra_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'extra', t:9, f:[
              {s:'extra_k', t:6},
              {s:'extra_v', t:6}
          ]}
      ]}
   ],
   11032 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11033 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11034 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11035 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11036 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'flag', t:2}
   ],
   11037 : [
      {s:'lucky', t:6}
   ],
   11038 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11040 : [
      {s:'partners', t:9, f:[
          {s:'partner_id', t:6},
          {s:'max_star', t:2}
      ]},
      {s:'all_star', t:6},
      {s:'lev', t:6},
      {s:'decompose_partners', t:9, f:[
          {s:'partner_id', t:6}
      ]}
   ],
   11041 : [
      {s:'like', t:2},
      {s:'like_num', t:6},
      {s:'partner_comments', t:9, f:[
          {s:'comment_id', t:6},
          {s:'name', t:7},
          {s:'msg', t:7},
          {s:'like_num', t:6},
          {s:'no_like_num', t:6},
          {s:'is_like', t:2}
      ]}
   ],
   11042 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11043 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11044 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'type', t:2}
   ],
   11045 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'partner_id', t:6}
   ],
   11046 : [
      {s:'old_star', t:6},
      {s:'new_star', t:6}
   ],
   11047 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'lev', t:6}
   ],
   11050 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'lev', t:6},
      {s:'fields', t:9, f:[
          {s:'pos', t:6},
          {s:'partner_id', t:6}
      ]}
   ],
   11051 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11052 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'lev', t:6}
   ],
   11053 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'pos', t:2}
   ],
   11055 : [
   ],
   11056 : [
      {s:'is_point', t:2}
   ],
   11060 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11061 : [
      {s:'partner_id', t:6},
      {s:'bid', t:6},
      {s:'lev', t:4},
      {s:'star', t:2},
      {s:'skills', t:9, f:[
          {s:'pos', t:2},
          {s:'skill_bid', t:6}
      ]},
      {s:'break_lev', t:2},
      {s:'power', t:6},
      {s:'is_lock', t:9, f:[
          {s:'lock_type', t:6},
          {s:'is_lock', t:2}
      ]},
      {s:'use_skin', t:6},
      {s:'atk', t:6},
      {s:'def_p', t:6},
      {s:'def_s', t:6},
      {s:'hp', t:6},
      {s:'speed', t:6},
      {s:'hit_rate', t:6},
      {s:'dodge_rate', t:6},
      {s:'crit_rate', t:6},
      {s:'crit_ratio', t:6},
      {s:'hit_magic', t:6},
      {s:'dodge_magic', t:6},
      {s:'dam', t:6},
      {s:'res', t:6},
      {s:'cure', t:6},
      {s:'be_cure', t:6},
      {s:'tenacity', t:6},
      {s:'def', t:6},
      {s:'dam_p', t:6},
      {s:'dam_s', t:6},
      {s:'res_p', t:6},
      {s:'res_s', t:6},
      {s:'atk2', t:6},
      {s:'hp2', t:6},
      {s:'def2', t:6},
      {s:'speed2', t:6},
      {s:'eqms', t:9, f:[
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'type', t:6}
      ]},
      {s:'artifacts', t:9, f:[
          {s:'artifact_pos', t:2},
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'enchant', t:6},
          {s:'attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'extra_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'extra', t:9, f:[
              {s:'extra_k', t:6},
              {s:'extra_v', t:6}
          ]}
      ]},
      {s:'dower_skill', t:9, f:[
          {s:'pos', t:2},
          {s:'skill_id', t:6}
      ]},
      {s:'ext_data', t:9, f:[
          {s:'id', t:6},
          {s:'val', t:6}
      ]},
      {s:'holy_eqm', t:9, f:[
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'main_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'holy_eqm_attr', t:9, f:[
              {s:'pos', t:2},
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]}
      ]}
   ],
   11062 : [
      {s:'partner_id', t:6},
      {s:'bid', t:6},
      {s:'lev', t:4},
      {s:'star', t:2},
      {s:'skills', t:9, f:[
          {s:'pos', t:2},
          {s:'skill_bid', t:6}
      ]},
      {s:'break_lev', t:2},
      {s:'power', t:6},
      {s:'is_lock', t:9, f:[
          {s:'lock_type', t:6},
          {s:'is_lock', t:2}
      ]},
      {s:'use_skin', t:6},
      {s:'atk', t:6},
      {s:'def_p', t:6},
      {s:'def_s', t:6},
      {s:'hp', t:6},
      {s:'speed', t:6},
      {s:'hit_rate', t:6},
      {s:'dodge_rate', t:6},
      {s:'crit_rate', t:6},
      {s:'crit_ratio', t:6},
      {s:'hit_magic', t:6},
      {s:'dodge_magic', t:6},
      {s:'dam', t:6},
      {s:'res', t:6},
      {s:'cure', t:6},
      {s:'be_cure', t:6},
      {s:'tenacity', t:6},
      {s:'def', t:6},
      {s:'dam_p', t:6},
      {s:'dam_s', t:6},
      {s:'res_p', t:6},
      {s:'res_s', t:6},
      {s:'atk2', t:6},
      {s:'hp2', t:6},
      {s:'def2', t:6},
      {s:'speed2', t:6},
      {s:'eqms', t:9, f:[
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'type', t:6}
      ]},
      {s:'artifacts', t:9, f:[
          {s:'artifact_pos', t:2},
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'enchant', t:6},
          {s:'attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'extra_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'extra', t:9, f:[
              {s:'extra_k', t:6},
              {s:'extra_v', t:6}
          ]}
      ]},
      {s:'dower_skill', t:9, f:[
          {s:'pos', t:2},
          {s:'skill_id', t:6}
      ]},
      {s:'ext_data', t:9, f:[
          {s:'id', t:6},
          {s:'val', t:6}
      ]},
      {s:'holy_eqm', t:9, f:[
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'main_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'holy_eqm_attr', t:9, f:[
              {s:'pos', t:2},
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]}
      ]}
   ],
   11063 : [
      {s:'partner_id', t:6},
      {s:'atk', t:6},
      {s:'def_p', t:6},
      {s:'def_s', t:6},
      {s:'hp', t:6},
      {s:'speed', t:6},
      {s:'hit_rate', t:6},
      {s:'dodge_rate', t:6},
      {s:'crit_rate', t:6},
      {s:'crit_ratio', t:6},
      {s:'hit_magic', t:6},
      {s:'dodge_magic', t:6},
      {s:'dam', t:6},
      {s:'res', t:6},
      {s:'cure', t:6},
      {s:'be_cure', t:6},
      {s:'tenacity', t:6},
      {s:'def', t:6},
      {s:'dam_p', t:6},
      {s:'dam_s', t:6},
      {s:'res_p', t:6},
      {s:'res_s', t:6},
      {s:'ext_data', t:9, f:[
          {s:'id', t:6},
          {s:'val', t:6}
      ]}
   ],
   11070 : [
      {s:'partner_bid', t:6},
      {s:'partner_score', t:9, f:[
          {s:'id_2', t:2},
          {s:'val', t:6}
      ]},
      {s:'stronger_partner_score', t:9, f:[
          {s:'id_2', t:2},
          {s:'val', t:6}
      ]}
   ],
   11073 : [
      {s:'partners', t:9, f:[
          {s:'partner_id', t:6},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'skills', t:9, f:[
              {s:'pos', t:2},
              {s:'skill_bid', t:6}
          ]},
          {s:'break_lev', t:2},
          {s:'power', t:6},
          {s:'is_lock', t:9, f:[
              {s:'lock_type', t:6},
              {s:'is_lock', t:2}
          ]},
          {s:'use_skin', t:6},
          {s:'atk', t:6},
          {s:'def_p', t:6},
          {s:'def_s', t:6},
          {s:'hp', t:6},
          {s:'speed', t:6},
          {s:'hit_rate', t:6},
          {s:'dodge_rate', t:6},
          {s:'crit_rate', t:6},
          {s:'crit_ratio', t:6},
          {s:'hit_magic', t:6},
          {s:'dodge_magic', t:6},
          {s:'def', t:6},
          {s:'atk2', t:6},
          {s:'hp2', t:6},
          {s:'def2', t:6},
          {s:'speed2', t:6},
          {s:'eqms', t:9, f:[
              {s:'id', t:6},
              {s:'base_id', t:6},
              {s:'type', t:6}
          ]},
          {s:'artifacts', t:9, f:[
              {s:'artifact_pos', t:2},
              {s:'id', t:6},
              {s:'base_id', t:6},
              {s:'enchant', t:6},
              {s:'attr', t:9, f:[
                  {s:'attr_id', t:6},
                  {s:'attr_val', t:6}
              ]},
              {s:'extra_attr', t:9, f:[
                  {s:'attr_id', t:6},
                  {s:'attr_val', t:6}
              ]},
              {s:'extra', t:9, f:[
                  {s:'extra_k', t:6},
                  {s:'extra_v', t:6}
              ]}
          ]}
      ]}
   ],
   11075 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'num', t:6}
      ]}
   ],
   11076 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'list', t:9, f:[
          {s:'partner_id', t:6}
      ]}
   ],
   11077 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'partner_bid', t:6}
   ],
   11078 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   11079 : [
      {s:'type', t:2},
      {s:'coin', t:6},
      {s:'list', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:4}
      ]}
   ],
   11080 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11081 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11082 : [
      {s:'logs', t:9, f:[
          {s:'items', t:9, f:[
              {s:'bid', t:6},
              {s:'num', t:4}
          ]},
          {s:'time', t:6},
          {s:'coin', t:6}
      ]}
   ],
   11083 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'partner_id', t:6},
      {s:'item_id', t:6}
   ],
   11085 : [
      {s:'partner_id', t:6},
      {s:'old_star', t:6},
      {s:'new_star', t:6}
   ],
   11086 : [
      {s:'partner_id', t:6},
      {s:'power', t:6},
      {s:'atk', t:6},
      {s:'def_p', t:6},
      {s:'def_s', t:6},
      {s:'hp', t:6},
      {s:'speed', t:6},
      {s:'hit_rate', t:6},
      {s:'dodge_rate', t:6},
      {s:'crit_rate', t:6},
      {s:'crit_ratio', t:6},
      {s:'hit_magic', t:6},
      {s:'dodge_magic', t:6},
      {s:'dam', t:6},
      {s:'res', t:6},
      {s:'cure', t:6},
      {s:'be_cure', t:6},
      {s:'tenacity', t:6},
      {s:'def', t:6},
      {s:'dam_p', t:6},
      {s:'dam_s', t:6},
      {s:'res_p', t:6},
      {s:'res_s', t:6}
   ],
   11087 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'num', t:6}
      ]}
   ],
   11088 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'num', t:6}
      ]}
   ],
   11089 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   11090 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11091 : [
      {s:'partner_id', t:6},
      {s:'power', t:6},
      {s:'atk', t:6},
      {s:'def_p', t:6},
      {s:'def_s', t:6},
      {s:'hp', t:6},
      {s:'speed', t:6},
      {s:'hit_rate', t:6},
      {s:'dodge_rate', t:6},
      {s:'crit_rate', t:6},
      {s:'crit_ratio', t:6},
      {s:'hit_magic', t:6},
      {s:'dodge_magic', t:6},
      {s:'dam', t:6},
      {s:'res', t:6},
      {s:'cure', t:6},
      {s:'be_cure', t:6},
      {s:'tenacity', t:6},
      {s:'def', t:6},
      {s:'dam_p', t:6},
      {s:'dam_s', t:6},
      {s:'res_p', t:6},
      {s:'res_s', t:6},
      {s:'holy_eqm', t:9, f:[
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'main_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'holy_eqm_attr', t:9, f:[
              {s:'pos', t:2},
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'extra', t:9, f:[
              {s:'extra_k', t:6},
              {s:'extra_v', t:6}
          ]}
      ]}
   ],
   11092 : [
      {s:'partner_ids', t:9, f:[
          {s:'partner_id', t:6},
          {s:'holy_eqm', t:9, f:[
              {s:'id', t:6},
              {s:'base_id', t:6},
              {s:'main_attr', t:9, f:[
                  {s:'attr_id', t:6},
                  {s:'attr_val', t:6}
              ]},
              {s:'holy_eqm_attr', t:9, f:[
                  {s:'pos', t:2},
                  {s:'attr_id', t:6},
                  {s:'attr_val', t:6}
              ]},
              {s:'extra', t:9, f:[
                  {s:'extra_k', t:6},
                  {s:'extra_v', t:6}
              ]}
          ]}
      ]}
   ],
   11093 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11094 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11095 : [
      {s:'partner_bid', t:6},
      {s:'is_chips', t:2},
      {s:'init_star', t:2},
      {s:'status', t:2}
   ],
   11096 : [
      {s:'partner_id', t:6},
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'dower_skill', t:9, f:[
          {s:'pos', t:2},
          {s:'skill_id', t:6}
      ]}
   ],
   11097 : [
      {s:'partner_id', t:6},
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'dower_skill', t:9, f:[
          {s:'pos', t:2},
          {s:'skill_id', t:6}
      ]}
   ],
   11098 : [
      {s:'partner_id', t:6},
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'dower_skill', t:9, f:[
          {s:'pos', t:2},
          {s:'skill_id', t:6}
      ]}
   ],
   11099 : [
      {s:'partner_ids', t:9, f:[
          {s:'partner_id', t:6},
          {s:'dower_skill', t:9, f:[
              {s:'pos', t:2},
              {s:'skill_id', t:6}
          ]}
      ]}
   ],
   11100 : [
   ],
   11101 : [
      {s:'drama_bid', t:6}
   ],
   11102 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   11110 : [
      {s:'id', t:2},
      {s:'act_list', t:9, f:[
          {s:'id', t:4},
          {s:'act_type', t:2},
          {s:'base_id', t:6},
          {s:'map_bid', t:6},
          {s:'x', t:4},
          {s:'y', t:4},
          {s:'val', t:6},
          {s:'name', t:7},
          {s:'desc', t:7}
      ]}
   ],
   11111 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   11120 : [
      {s:'id', t:6},
      {s:'n', t:6}
   ],
   11121 : [
      {s:'id', t:6},
      {s:'n', t:6}
   ],
   11122 : [
   ],
   11123 : [
   ],
   11200 : [
      {s:'id', t:2},
      {s:'pos_info', t:9, f:[
          {s:'pos', t:2},
          {s:'id', t:2}
      ]},
      {s:'formation_list', t:9, f:[
          {s:'id', t:2}
      ]},
      {s:'hallows_id', t:6}
   ],
   11201 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   11211 : [
      {s:'type', t:2},
      {s:'formation_type', t:2},
      {s:'pos_info', t:9, f:[
          {s:'pos', t:2},
          {s:'id', t:6}
      ]},
      {s:'hallows_id', t:6}
   ],
   11212 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'type', t:2}
   ],
   11213 : [
      {s:'info', t:9, f:[
          {s:'type', t:2},
          {s:'formation_type', t:2},
          {s:'pos_info', t:9, f:[
              {s:'pos', t:2},
              {s:'id', t:6}
          ]},
          {s:'hallows_id', t:6}
      ]}
   ],
   11300 : [
      {s:'star', t:9, f:[
          {s:'set_id', t:6},
          {s:'add_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'set_skill_id', t:6},
          {s:'power', t:6},
          {s:'natals', t:9, f:[
              {s:'id', t:6},
              {s:'base_id', t:6},
              {s:'type', t:6},
              {s:'enchant', t:6},
              {s:'break_count', t:6},
              {s:'star_lev', t:6},
              {s:'score', t:6},
              {s:'all_score', t:6}
          ]}
      ]},
      {s:'fetters', t:9, f:[
          {s:'set_id', t:6},
          {s:'pos_id', t:6},
          {s:'partner_id', t:6}
      ]}
   ],
   11301 : [
      {s:'set_id', t:6},
      {s:'add_attr', t:9, f:[
          {s:'attr_id', t:6},
          {s:'attr_val', t:6}
      ]},
      {s:'set_skill_id', t:6},
      {s:'power', t:6},
      {s:'natals', t:9, f:[
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'type', t:6},
          {s:'enchant', t:6},
          {s:'break_count', t:6},
          {s:'star_lev', t:6},
          {s:'score', t:6},
          {s:'all_score', t:6}
      ]}
   ],
   11302 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'old_set_id', t:6},
      {s:'fetter', t:9, f:[
          {s:'set_id', t:6},
          {s:'pos_id', t:6},
          {s:'partner_id', t:6}
      ]}
   ],
   11303 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'old_set_id', t:6},
      {s:'fetter', t:9, f:[
          {s:'set_id', t:6},
          {s:'pos_id', t:6},
          {s:'partner_id', t:6}
      ]}
   ],
   11304 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11305 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11306 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   11307 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'fetter', t:9, f:[
          {s:'set_id', t:6},
          {s:'pos_id', t:6},
          {s:'partner_id', t:6}
      ]}
   ],
   11308 : [
      {s:'star', t:9, f:[
          {s:'set_id', t:6},
          {s:'add_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'set_skill_id', t:6},
          {s:'power', t:6},
          {s:'natals', t:9, f:[
              {s:'id', t:6},
              {s:'base_id', t:6},
              {s:'type', t:6},
              {s:'enchant', t:6},
              {s:'break_count', t:6},
              {s:'star_lev', t:6},
              {s:'score', t:6},
              {s:'all_score', t:6}
          ]}
      ]},
      {s:'fetters', t:9, f:[
          {s:'set_id', t:6},
          {s:'pos_id', t:6},
          {s:'partner_id', t:6}
      ]}
   ],
   11310 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'set_id', t:6},
      {s:'id', t:6},
      {s:'lev', t:6}
   ],
   11311 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'set_id', t:6},
      {s:'id', t:6}
   ],
   11320 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'max_tower', t:6},
      {s:'count', t:6},
      {s:'buy_count', t:6},
      {s:'award_list', t:9, f:[
          {s:'id', t:6},
          {s:'status', t:2}
      ]}
   ],
   11321 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'count', t:6},
      {s:'buy_count', t:6}
   ],
   11322 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11323 : [
      {s:'result', t:2},
      {s:'max_tower', t:6},
      {s:'tower', t:6},
      {s:'timer', t:6},
      {s:'count', t:6},
      {s:'first_award', t:9, f:[
          {s:'item_id', t:6},
          {s:'num', t:6}
      ]},
      {s:'award', t:9, f:[
          {s:'item_id', t:6},
          {s:'num', t:6}
      ]},
      {s:'target_role_name', t:7},
      {s:'hurt_statistics', t:9, f:[
          {s:'type', t:2},
          {s:'partner_hurts', t:9, f:[
              {s:'rid', t:6},
              {s:'srvid', t:7},
              {s:'id', t:6},
              {s:'bid', t:6},
              {s:'star', t:6},
              {s:'lev', t:6},
              {s:'camp_type', t:6},
              {s:'dps', t:6},
              {s:'cure', t:6}
          ]}
      ]}
   ],
   11324 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'count', t:6},
      {s:'buy_count', t:6}
   ],
   11325 : [
      {s:'tower_replay_data', t:9, f:[
          {s:'type', t:2},
          {s:'rid', t:6},
          {s:'sid', t:7},
          {s:'name', t:7},
          {s:'face_id', t:6},
          {s:'power', t:6},
          {s:'time', t:6},
          {s:'replay_id', t:6}
      ]},
      {s:'m_replay_id', t:6},
      {s:'my_time', t:6}
   ],
   11326 : [
      {s:'tower', t:6}
   ],
   11327 : [
      {s:'rank_lists', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'rank', t:6},
          {s:'tower', t:6}
      ]}
   ],
   11328 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   11329 : [
      {s:'award_list', t:9, f:[
          {s:'id', t:6},
          {s:'status', t:2}
      ]}
   ],
   11330 : [
      {s:'quality', t:6},
      {s:'luck', t:6},
      {s:'end_count', t:6},
      {s:'ref_count', t:6},
      {s:'day_gold_count', t:6},
      {s:'flag', t:2}
   ],
   11331 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'end_count', t:6},
      {s:'quality', t:6},
      {s:'day_gold_count', t:6},
      {s:'flag', t:2},
      {s:'award', t:9, f:[
          {s:'item_id', t:6},
          {s:'num', t:6}
      ]},
      {s:'award2', t:9, f:[
          {s:'item_id', t:6},
          {s:'num', t:6}
      ]}
   ],
   11332 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'luck', t:6},
      {s:'ref_count', t:6}
   ],
   11333 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   12700 : [
      {s:'say_frame_bid', t:6},
      {s:'say_frame', t:9, f:[
          {s:'base_id', t:6},
          {s:'expire_time', t:6}
      ]}
   ],
   12701 : [
      {s:'base_id', t:6}
   ],
   12702 : [
      {s:'say_frame', t:9, f:[
          {s:'base_id', t:6},
          {s:'expire_time', t:6}
      ]}
   ],
   12703 : [
      {s:'say_frame', t:9, f:[
          {s:'base_id', t:6},
          {s:'expire_time', t:6}
      ]}
   ],
   12720 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   12721 : [
      {s:'flag', t:2},
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'lev', t:2},
      {s:'career', t:4},
      {s:'face_id', t:4},
      {s:'len', t:2},
      {s:'msg', t:7},
      {s:'sex', t:2},
      {s:'vip_lev', t:2},
      {s:'capacity', t:2},
      {s:'head_bid', t:6},
      {s:'bubble_bid', t:6},
      {s:'tick', t:6}
   ],
   12722 : [
      {s:'offline_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:2},
          {s:'career', t:4},
          {s:'face_id', t:4},
          {s:'sex', t:2},
          {s:'vip_lev', t:2},
          {s:'capacity', t:2},
          {s:'head_bid', t:6},
          {s:'chat_bubble', t:6},
          {s:'msg_list', t:9, f:[
              {s:'len', t:2},
              {s:'msg', t:7},
              {s:'tick', t:6}
          ]}
      ]}
   ],
   12723 : [
   ],
   12725 : [
      {s:'flag', t:2},
      {s:'srv_id', t:7},
      {s:'voice_id', t:6},
      {s:'msg', t:7}
   ],
   12726 : [
      {s:'srv_id', t:7},
      {s:'voice_id', t:6},
      {s:'time', t:2},
      {s:'voice', t:8},
      {s:'type', t:2}
   ],
   12730 : [
   ],
   12731 : [
   ],
   12732 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   12733 : [
      {s:'type', t:6},
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'msg', t:7},
          {s:'time', t:6}
      ]}
   ],
   12741 : [
      {s:'msg', t:7}
   ],
   12742 : [
      {s:'asset_list', t:9, f:[
          {s:'bid', t:6},
          {s:'is_bind', t:2},
          {s:'num', t:6},
          {s:'id', t:6},
          {s:'move_to', t:2}
      ]},
      {s:'source', t:6}
   ],
   12743 : [
      {s:'msg', t:7}
   ],
   12744 : [
      {s:'type', t:2},
      {s:'msg', t:7}
   ],
   12745 : [
      {s:'bid', t:6},
      {s:'need_num', t:6},
      {s:'num', t:6}
   ],
   12761 : [
      {s:'role_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'face_id', t:4},
          {s:'lev', t:2},
          {s:'sex', t:2},
          {s:'career', t:4},
          {s:'vip_lev', t:2},
          {s:'is_show_vip', t:2},
          {s:'province', t:7},
          {s:'city', t:7},
          {s:'capacity', t:2},
          {s:'head_bid', t:6},
          {s:'bubble_bid', t:6},
          {s:'ext_list', t:9, f:[
              {s:'type', t:2},
              {s:'val', t:6}
          ]},
          {s:'gid', t:6},
          {s:'gsrv_id', t:7},
          {s:'g_name', t:7}
      ]},
      {s:'channel', t:4},
      {s:'len', t:2},
      {s:'msg', t:7},
      {s:'tick', t:6}
   ],
   12762 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   12763 : [
      {s:'channel', t:4},
      {s:'id', t:7},
      {s:'msg', t:7}
   ],
   12764 : [
   ],
   12766 : [
      {s:'channel', t:4},
      {s:'msg_list', t:9, f:[
          {s:'role_list', t:9, f:[
              {s:'rid', t:6},
              {s:'srv_id', t:7},
              {s:'name', t:7},
              {s:'face_id', t:4},
              {s:'lev', t:2},
              {s:'sex', t:2},
              {s:'career', t:4},
              {s:'vip_lev', t:2},
              {s:'is_show_vip', t:2},
              {s:'province', t:7},
              {s:'city', t:7},
              {s:'capacity', t:2},
              {s:'head_bid', t:6},
              {s:'chat_bubble', t:6},
              {s:'ext_list', t:9, f:[
                  {s:'type', t:2},
                  {s:'val', t:6}
              ]},
              {s:'gid', t:6},
              {s:'gsrv_id', t:7},
              {s:'g_name', t:7}
          ]},
          {s:'channel', t:4},
          {s:'len', t:2},
          {s:'msg', t:7},
          {s:'tick', t:6}
      ]}
   ],
   12767 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'channel', t:4},
      {s:'msg', t:7}
   ],
   12768 : [
   ],
   12770 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   12771 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'history', t:9, f:[
          {s:'id', t:2},
          {s:'channel', t:4},
          {s:'msg', t:7}
      ]}
   ],
   12799 : [
      {s:'msg', t:7}
   ],
   12900 : [
      {s:'is_cluster', t:2},
      {s:'type', t:4},
      {s:'start', t:2},
      {s:'num', t:2},
      {s:'len', t:2},
      {s:'time', t:6},
      {s:'my_idx', t:4},
      {s:'lev', t:2},
      {s:'face_id', t:4},
      {s:'avatar_bid', t:4},
      {s:'name', t:7},
      {s:'my_val1', t:6},
      {s:'my_val2', t:6},
      {s:'my_val3', t:6},
      {s:'rank_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'guild_name', t:7},
          {s:'lev', t:2},
          {s:'face_id', t:6},
          {s:'avatar_bid', t:6},
          {s:'val1', t:6},
          {s:'val2', t:6},
          {s:'val3', t:6},
          {s:'idx', t:2},
          {s:'desc', t:7}
      ]}
   ],
   12901 : [
      {s:'is_cluster', t:2},
      {s:'type', t:4},
      {s:'time', t:6}
   ],
   12902 : [
      {s:'is_cluster', t:2},
      {s:'rank_list', t:9, f:[
          {s:'type', t:4},
          {s:'name', t:7},
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'guild_name', t:7},
          {s:'face_id', t:6},
          {s:'avatar_bid', t:6},
          {s:'val1', t:6},
          {s:'val2', t:6},
          {s:'val3', t:6}
      ]}
   ],
   12903 : [
      {s:'start', t:2},
      {s:'num', t:2},
      {s:'len', t:2},
      {s:'time', t:6},
      {s:'my_idx', t:4},
      {s:'gname', t:7},
      {s:'leader_name', t:7},
      {s:'glev', t:2},
      {s:'power', t:6},
      {s:'rank_list', t:9, f:[
          {s:'name', t:7},
          {s:'lev', t:2},
          {s:'members_num', t:2},
          {s:'members_max', t:2},
          {s:'leader_name', t:7},
          {s:'power', t:6},
          {s:'idx', t:2},
          {s:'leader_rid', t:6},
          {s:'leader_srvid', t:7},
          {s:'leader_face', t:6},
          {s:'leader_lev', t:2},
          {s:'leader_avatar_bid', t:6}
      ]}
   ],
   12904 : [
      {s:'start', t:2},
      {s:'num', t:2},
      {s:'len', t:2},
      {s:'time', t:6},
      {s:'my_idx', t:4},
      {s:'lev', t:2},
      {s:'face_id', t:4},
      {s:'avatar_bid', t:6},
      {s:'name', t:7},
      {s:'pid', t:4},
      {s:'pbid', t:4},
      {s:'plev', t:2},
      {s:'pquality', t:2},
      {s:'pstar', t:2},
      {s:'power', t:6},
      {s:'rank_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:2},
          {s:'face_id', t:6},
          {s:'avatar_bid', t:6},
          {s:'power', t:6},
          {s:'idx', t:2},
          {s:'pid', t:4},
          {s:'pbid', t:4},
          {s:'plev', t:2},
          {s:'pquality', t:2},
          {s:'pstar', t:2}
      ]}
   ],
   13000 : [
      {s:'mode', t:2},
      {s:'chapter_id', t:2},
      {s:'dun_id', t:6},
      {s:'status', t:2},
      {s:'is_first', t:2},
      {s:'cool_time', t:6},
      {s:'max_dun_id', t:6},
      {s:'auto_num', t:2},
      {s:'auto_num_max', t:2},
      {s:'mode_list', t:9, f:[
          {s:'mode', t:2},
          {s:'chapter_list', t:9, f:[
              {s:'chapter_id', t:2},
              {s:'status', t:2},
              {s:'dun_list', t:9, f:[
                  {s:'dun_id', t:6},
                  {s:'status', t:2},
                  {s:'cool_time', t:6},
                  {s:'auto_num', t:2}
              ]}
          ]}
      ]}
   ],
   13001 : [
      {s:'mode', t:2},
      {s:'chapter_id', t:2},
      {s:'dun_id', t:6},
      {s:'status', t:2},
      {s:'is_first', t:2},
      {s:'cool_time', t:6},
      {s:'max_dun_id', t:6}
   ],
   13002 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13003 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13004 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13005 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'dun_id', t:6},
      {s:'num', t:4},
      {s:'items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   13006 : [
      {s:'fast_combat_num', t:2},
      {s:'fast_combat_max', t:2},
      {s:'auto_num', t:2},
      {s:'auto_num_max', t:2},
      {s:'is_auto_combat', t:2},
      {s:'fast_combat_add_time', t:4},
      {s:'fast_combat_w_num', t:2},
      {s:'fast_combat_p_num', t:2},
      {s:'fast_combat_free_num', t:2},
      {s:'is_holiday', t:2}
   ],
   13007 : [
      {s:'type', t:2},
      {s:'dun_id', t:6},
      {s:'time', t:6},
      {s:'old_lev', t:2},
      {s:'new_lev', t:2},
      {s:'items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'auto_start_dun_id', t:6},
      {s:'auto_end_dun_id', t:6},
      {s:'fast_add_time1', t:6},
      {s:'fast_add_time2', t:6},
      {s:'old_exp', t:6},
      {s:'new_exp', t:6},
      {s:'vip_buff', t:6},
      {s:'honor_buff', t:6}
   ],
   13008 : [
      {s:'list', t:9, f:[
          {s:'id', t:2}
      ]}
   ],
   13009 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   13010 : [
      {s:'dun_id', t:6},
      {s:'chapter_id', t:2}
   ],
   13011 : [
      {s:'buff_list', t:9, f:[
          {s:'bid', t:6},
          {s:'end_time', t:6}
      ]}
   ],
   13012 : [
      {s:'chapter_list', t:9, f:[
          {s:'chapter_id', t:6},
          {s:'award_list', t:9, f:[
              {s:'award_id', t:6},
              {s:'status', t:6}
          ]}
      ]}
   ],
   13013 : [
      {s:'chapter_list', t:9, f:[
          {s:'chapter_id', t:6},
          {s:'award_list', t:9, f:[
              {s:'award_id', t:6},
              {s:'status', t:6}
          ]}
      ]}
   ],
   13014 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'chapter_id', t:6},
      {s:'award_id', t:6},
      {s:'status', t:6}
   ],
   13015 : [
      {s:'dungeon_replay_log', t:9, f:[
          {s:'rid', t:6},
          {s:'sid', t:7},
          {s:'name', t:7},
          {s:'face_id', t:6},
          {s:'power', t:6},
          {s:'time', t:6},
          {s:'repaly_id', t:6},
          {s:'type', t:2}
      ]}
   ],
   13016 : [
      {s:'result', t:2},
      {s:'item_rewards', t:9, f:[
          {s:'bid', t:6},
          {s:'is_bind', t:2},
          {s:'num', t:6},
          {s:'id', t:6}
      ]},
      {s:'combat_type', t:4},
      {s:'partner_bid', t:6},
      {s:'partner_hurt', t:6},
      {s:'partner_total_hurt', t:6},
      {s:'lev', t:2},
      {s:'exp', t:6},
      {s:'new_lev', t:2},
      {s:'new_exp', t:6},
      {s:'auto_num', t:4},
      {s:'target_role_name', t:7},
      {s:'hurt_statistics', t:9, f:[
          {s:'type', t:2},
          {s:'partner_hurts', t:9, f:[
              {s:'rid', t:6},
              {s:'srvid', t:7},
              {s:'id', t:6},
              {s:'bid', t:6},
              {s:'star', t:6},
              {s:'lev', t:6},
              {s:'camp_type', t:6},
              {s:'dps', t:6},
              {s:'cure', t:6},
              {s:'ext_data', t:9, f:[
                  {s:'key', t:6},
                  {s:'val', t:6}
              ]}
          ]}
      ]},
      {s:'use_skin', t:6}
   ],
   13017 : [
      {s:'hook_time', t:6},
      {s:'list', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   13018 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13019 : [
   ],
   13020 : [
      {s:'val', t:6}
   ],
   13030 : [
      {s:'list', t:9, f:[
          {s:'type', t:6},
          {s:'day_num', t:2}
      ]},
      {s:'pass_list', t:9, f:[
          {s:'id', t:6}
      ]}
   ],
   13031 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13032 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   13039 : [
   ],
   13040 : [
      {s:'flag', t:2}
   ],
   13300 : [
      {s:'present_count', t:4},
      {s:'draw_count', t:4},
      {s:'draw_all', t:4},
      {s:'friend_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:2},
          {s:'sex', t:2},
          {s:'career', t:2},
          {s:'face_id', t:4},
          {s:'power', t:6},
          {s:'intimacy', t:6},
          {s:'login_time', t:6},
          {s:'login_out_time', t:6},
          {s:'is_online', t:2},
          {s:'is_cross', t:2},
          {s:'gid', t:6},
          {s:'gsrv_id', t:7},
          {s:'gname', t:7},
          {s:'main_partner_id', t:6},
          {s:'partner_bid', t:6},
          {s:'partner_lev', t:4},
          {s:'partner_star', t:2},
          {s:'is_awake', t:2},
          {s:'is_used', t:2},
          {s:'is_present', t:2},
          {s:'is_draw', t:2},
          {s:'avatar_bid', t:6},
          {s:'dun_id', t:6}
      ]}
   ],
   13301 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'login_time', t:6},
      {s:'is_online', t:2},
      {s:'login_out_time', t:6}
   ],
   13302 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'lev', t:2},
      {s:'sex', t:2},
      {s:'career', t:2},
      {s:'face_id', t:4},
      {s:'power', t:6},
      {s:'intimacy', t:6},
      {s:'login_time', t:6},
      {s:'login_out_time', t:6},
      {s:'is_online', t:2},
      {s:'is_cross', t:2},
      {s:'gid', t:6},
      {s:'gsrv_id', t:7},
      {s:'gname', t:7},
      {s:'main_partner_id', t:6},
      {s:'partner_bid', t:6},
      {s:'partner_lev', t:4},
      {s:'partner_star', t:2},
      {s:'is_awake', t:2},
      {s:'is_used', t:2},
      {s:'is_present', t:2},
      {s:'is_draw', t:2},
      {s:'avatar_bid', t:6},
      {s:'dun_id', t:6}
   ],
   13303 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13304 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'sex', t:2},
      {s:'career', t:2},
      {s:'lev', t:2},
      {s:'avatar_bid', t:6}
   ],
   13305 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13306 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13307 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   13308 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   13309 : [
      {s:'role_ids', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7}
      ]}
   ],
   13310 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'lev', t:2},
      {s:'sex', t:2},
      {s:'career', t:2},
      {s:'face_id', t:4},
      {s:'power', t:6},
      {s:'intimacy', t:6},
      {s:'login_time', t:6},
      {s:'login_out_time', t:6},
      {s:'is_online', t:2},
      {s:'is_cross', t:2},
      {s:'gid', t:6},
      {s:'gsrv_id', t:7},
      {s:'gname', t:7},
      {s:'main_partner_id', t:6},
      {s:'partner_bid', t:6},
      {s:'partner_lev', t:4},
      {s:'partner_star', t:2},
      {s:'is_awake', t:2},
      {s:'is_used', t:2},
      {s:'is_present', t:2},
      {s:'is_draw', t:2},
      {s:'avatar_bid', t:6},
      {s:'dun_id', t:6}
   ],
   13311 : [
      {s:'friend_req_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'sex', t:2},
          {s:'career', t:2},
          {s:'lev', t:2},
          {s:'face_id', t:4},
          {s:'power', t:6},
          {s:'avatar_bid', t:6}
      ]}
   ],
   13312 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13314 : [
      {s:'role_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'sex', t:2},
          {s:'career', t:2},
          {s:'lev', t:2},
          {s:'power', t:6},
          {s:'face_id', t:4}
      ]}
   ],
   13315 : [
      {s:'code', t:2}
   ],
   13316 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'present_count', t:4},
      {s:'draw_count', t:4},
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'type', t:2},
      {s:'is_present', t:2},
      {s:'is_draw', t:2}
   ],
   13317 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'type', t:2},
      {s:'list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'is_present', t:2},
          {s:'is_draw', t:2}
      ]}
   ],
   13320 : [
      {s:'recommend_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'sex', t:2},
          {s:'career', t:2},
          {s:'lev', t:2},
          {s:'face_id', t:4},
          {s:'power', t:6}
      ]}
   ],
   13330 : [
      {s:'black_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:2},
          {s:'sex', t:2},
          {s:'career', t:2},
          {s:'face_id', t:4},
          {s:'power', t:6},
          {s:'login_out_time', t:6},
          {s:'is_online', t:2},
          {s:'gid', t:6},
          {s:'gsrv_id', t:7},
          {s:'gname', t:7}
      ]}
   ],
   13331 : [
      {s:'type', t:2},
      {s:'black_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:2},
          {s:'sex', t:2},
          {s:'career', t:2},
          {s:'face_id', t:4},
          {s:'power', t:6},
          {s:'login_time', t:6},
          {s:'is_online', t:2},
          {s:'gid', t:6},
          {s:'gsrv_id', t:7},
          {s:'gname', t:7}
      ]}
   ],
   13332 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   13333 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'rid', t:6},
      {s:'srv_id', t:7}
   ],
   13334 : [
      {s:'role_ids', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7}
      ]}
   ],
   13401 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'type', t:2},
      {s:'is_half', t:2},
      {s:'item_list', t:9, f:[
          {s:'item_id', t:6},
          {s:'ext', t:9, f:[
              {s:'key', t:2},
              {s:'val', t:6}
          ]}
      ]}
   ],
   13402 : [
      {s:'code', t:2},
      {s:'type', t:2},
      {s:'eid', t:6},
      {s:'is_half', t:2},
      {s:'ext', t:9, f:[
          {s:'key', t:2},
          {s:'val', t:6}
      ]},
      {s:'msg', t:7}
   ],
   13403 : [
      {s:'type', t:6},
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'count', t:6},
      {s:'free_count', t:6},
      {s:'num', t:6},
      {s:'refresh_time', t:6},
      {s:'item_list', t:9, f:[
          {s:'item_id', t:6},
          {s:'item_num', t:6},
          {s:'order', t:6},
          {s:'price', t:6},
          {s:'type', t:2},
          {s:'pay_type', t:6},
          {s:'has_buy', t:6},
          {s:'limit_count', t:6},
          {s:'discount_type', t:6},
          {s:'discount', t:6},
          {s:'main_attr', t:9, f:[
              {s:'attr_type', t:2},
              {s:'val', t:6}
          ]},
          {s:'pay_type2', t:6},
          {s:'price2', t:6},
          {s:'score', t:6}
      ]}
   ],
   13404 : [
   ],
   13405 : [
      {s:'type', t:6},
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'count', t:6},
      {s:'free_count', t:6},
      {s:'num', t:6},
      {s:'refresh_time', t:6},
      {s:'item_list', t:9, f:[
          {s:'item_id', t:6},
          {s:'item_num', t:6},
          {s:'order', t:6},
          {s:'price', t:6},
          {s:'type', t:2},
          {s:'pay_type', t:6},
          {s:'has_buy', t:6},
          {s:'limit_count', t:6},
          {s:'discount_type', t:6},
          {s:'discount', t:6},
          {s:'main_attr', t:9, f:[
              {s:'attr_type', t:2},
              {s:'val', t:6}
          ]},
          {s:'pay_type2', t:6},
          {s:'price2', t:6},
          {s:'score', t:6}
      ]}
   ],
   13407 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'order', t:6}
   ],
   13408 : [
      {s:'code', t:2}
   ],
   13409 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'count', t:6},
      {s:'item_list', t:9, f:[
          {s:'pos', t:6},
          {s:'item_id', t:6},
          {s:'item_num', t:6},
          {s:'price', t:6},
          {s:'status', t:6}
      ]}
   ],
   13410 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'item_list', t:9, f:[
          {s:'pos', t:6},
          {s:'item_id', t:6},
          {s:'item_num', t:6},
          {s:'price', t:6},
          {s:'status', t:6}
      ]}
   ],
   13411 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'count', t:6},
      {s:'item_list', t:9, f:[
          {s:'pos', t:6},
          {s:'item_id', t:6},
          {s:'item_num', t:6},
          {s:'price', t:6},
          {s:'status', t:6}
      ]}
   ],
   13412 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'type', t:6},
      {s:'day', t:6},
      {s:'item_list', t:9, f:[
          {s:'item_id', t:6},
          {s:'status', t:6}
      ]}
   ],
   13413 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'type', t:6},
      {s:'day', t:6},
      {s:'item_list', t:9, f:[
          {s:'item_id', t:6},
          {s:'status', t:6}
      ]}
   ],
   13414 : [
      {s:'code', t:2}
   ],
   13415 : [
      {s:'type', t:6},
      {s:'count', t:4},
      {s:'max_count', t:4},
      {s:'free_count', t:2},
      {s:'max_free_count', t:2},
      {s:'item_list', t:9, f:[
          {s:'order', t:2},
          {s:'item_id', t:6},
          {s:'item_num', t:6},
          {s:'price', t:6},
          {s:'type', t:2},
          {s:'pay_type', t:2},
          {s:'buycount', t:6},
          {s:'discount_type', t:6},
          {s:'discount', t:6}
      ]}
   ],
   13416 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'order', t:6}
   ],
   13417 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13418 : [
   ],
   13419 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13420 : [
      {s:'type', t:6},
      {s:'count', t:6},
      {s:'free_count', t:6},
      {s:'refresh_time', t:6}
   ],
   13500 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13501 : [
      {s:'page', t:4},
      {s:'flag', t:2},
      {s:'num', t:4},
      {s:'page_total', t:4},
      {s:'all_count', t:4},
      {s:'name', t:7},
      {s:'guilds', t:9, f:[
          {s:'gid', t:6},
          {s:'gsrv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:2},
          {s:'members_num', t:2},
          {s:'members_max', t:2},
          {s:'leader_name', t:7},
          {s:'apply_type', t:2},
          {s:'apply_lev', t:2},
          {s:'is_apply', t:2}
      ]}
   ],
   13503 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'gid', t:6},
      {s:'gsrv_id', t:7},
      {s:'is_apply', t:2}
   ],
   13505 : [
      {s:'type', t:2},
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13507 : [
      {s:'page', t:2},
      {s:'page_total', t:2},
      {s:'num', t:2},
      {s:'guids', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:2},
          {s:'face', t:6},
          {s:'power', t:6},
          {s:'vip_lev', t:2},
          {s:'is_online', t:2}
      ]}
   ],
   13513 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13514 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13516 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13518 : [
      {s:'gid', t:6},
      {s:'gsrv_id', t:7},
      {s:'name', t:7},
      {s:'lev', t:2},
      {s:'members_num', t:2},
      {s:'members_max', t:2},
      {s:'leader_name', t:7},
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'sign', t:7},
      {s:'exp', t:6},
      {s:'day_exp', t:6},
      {s:'apply_type', t:2},
      {s:'apply_lev', t:2},
      {s:'recruit_num', t:2},
      {s:'rank_idx', t:3}
   ],
   13519 : [
      {s:'members', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:2},
          {s:'face', t:6},
          {s:'post', t:2},
          {s:'online', t:2},
          {s:'vip_lev', t:2},
          {s:'power', t:6},
          {s:'join_time', t:6},
          {s:'login_time', t:6},
          {s:'donate', t:6},
          {s:'day_donate', t:6},
          {s:'avatar_bid', t:6},
          {s:'sex', t:2},
          {s:'active_lev', t:2}
      ]}
   ],
   13520 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'position', t:2},
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13521 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13522 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13523 : [
      {s:'donate_list', t:9, f:[
          {s:'type', t:2},
          {s:'num', t:2}
      ]},
      {s:'boxes', t:9, f:[
          {s:'box_id', t:2}
      ]},
      {s:'donate_exp', t:6},
      {s:'day_send_num', t:2},
      {s:'day_recv_num', t:2}
   ],
   13524 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13534 : [
      {s:'type', t:2},
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'type', t:2},
          {s:'name', t:7},
          {s:'post', t:6},
          {s:'num', t:2},
          {s:'max_num', t:2},
          {s:'max_val', t:6},
          {s:'time', t:6},
          {s:'flag', t:2},
          {s:'msg_id', t:2}
      ]}
   ],
   13535 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'day_send_num', t:2}
   ],
   13536 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6},
      {s:'type', t:2},
      {s:'val', t:6},
      {s:'day_recv_num', t:2}
   ],
   13540 : [
      {s:'id', t:6},
      {s:'type', t:2},
      {s:'name', t:7},
      {s:'face_id', t:6},
      {s:'avatar_bid', t:6},
      {s:'post', t:6},
      {s:'val', t:6},
      {s:'list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'face_id', t:6},
          {s:'avatar_bid', t:6},
          {s:'post', t:6},
          {s:'val', t:6},
          {s:'time', t:6}
      ]}
   ],
   13541 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13542 : [
      {s:'type', t:2},
      {s:'members', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:2},
          {s:'face', t:6},
          {s:'post', t:2},
          {s:'online', t:2},
          {s:'vip_lev', t:2},
          {s:'power', t:6},
          {s:'join_time', t:6},
          {s:'login_time', t:6},
          {s:'donate', t:6},
          {s:'day_donate', t:6},
          {s:'avatar_bid', t:6},
          {s:'sex', t:2},
          {s:'active_lev', t:2}
      ]}
   ],
   13545 : [
      {s:'list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'face_id', t:6},
          {s:'avatar_bid', t:6},
          {s:'price', t:6},
          {s:'num', t:6}
      ]}
   ],
   13546 : [
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'num', t:6}
      ]}
   ],
   13558 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13565 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13568 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13573 : [
      {s:'code', t:2}
   ],
   13574 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'box_id', t:2}
   ],
   13575 : [
      {s:'donate_exp', t:6}
   ],
   13576 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13601 : [
      {s:'flag', t:2},
      {s:'msg', t:7},
      {s:'period', t:2},
      {s:'charge', t:6},
      {s:'cur_day', t:6},
      {s:'num', t:6},
      {s:'end_time', t:6},
      {s:'welfare_list', t:9, f:[
          {s:'day', t:6},
          {s:'goal_id', t:6},
          {s:'status', t:2},
          {s:'target_val', t:6},
          {s:'value', t:6}
      ]},
      {s:'grow_list', t:9, f:[
          {s:'day', t:6},
          {s:'goal_id', t:6},
          {s:'condition', t:6},
          {s:'lev', t:6},
          {s:'status', t:2},
          {s:'target_type', t:2},
          {s:'progress', t:9, f:[
              {s:'id', t:4},
              {s:'finish', t:2},
              {s:'target', t:6},
              {s:'target_val', t:6},
              {s:'value', t:6}
          ]}
      ]},
      {s:'price_list', t:9, f:[
          {s:'day', t:6},
          {s:'status', t:2}
      ]},
      {s:'finish_list', t:9, f:[
          {s:'goal_id', t:6},
          {s:'status', t:2}
      ]}
   ],
   13602 : [
      {s:'flag', t:2},
      {s:'msg', t:7},
      {s:'type', t:2},
      {s:'day_type', t:6},
      {s:'id', t:6},
      {s:'item', t:6},
      {s:'status', t:2},
      {s:'num', t:6}
   ],
   13603 : [
      {s:'grow_list', t:9, f:[
          {s:'day', t:6},
          {s:'goal_id', t:6},
          {s:'condition', t:6},
          {s:'lev', t:6},
          {s:'status', t:2},
          {s:'target_type', t:2},
          {s:'progress', t:9, f:[
              {s:'id', t:4},
              {s:'finish', t:2},
              {s:'target', t:6},
              {s:'target_val', t:6},
              {s:'value', t:6}
          ]}
      ]}
   ],
   13604 : [
      {s:'period', t:2},
      {s:'cur_day', t:6},
      {s:'end_time', t:6},
      {s:'lev', t:6},
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'target_val', t:6},
          {s:'value', t:6}
      ]}
   ],
   13605 : [
      {s:'lev', t:6},
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'target_val', t:6},
          {s:'value', t:6}
      ]}
   ],
   13606 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   13607 : [
      {s:'lev', t:6},
      {s:'reward_list', t:9, f:[
          {s:'id', t:4}
      ]}
   ],
   13608 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   14100 : [
      {s:'day', t:2},
      {s:'status', t:2}
   ],
   14101 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'day', t:2},
      {s:'status', t:2}
   ],
   14102 : [
      {s:'attr_list', t:9, f:[
          {s:'id', t:6},
          {s:'status', t:2}
      ]}
   ],
   14103 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6},
      {s:'status', t:2}
   ],
   14104 : [
   ],
   16400 : [
      {s:'feat_list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'end_time', t:6},
          {s:'finish_time', t:6},
          {s:'progress', t:9, f:[
              {s:'id', t:4},
              {s:'finish', t:2},
              {s:'target', t:6},
              {s:'target_val', t:6},
              {s:'value', t:6}
          ]}
      ]}
   ],
   16401 : [
      {s:'feat_list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'end_time', t:6},
          {s:'finish_time', t:6},
          {s:'progress', t:9, f:[
              {s:'id', t:4},
              {s:'finish', t:2},
              {s:'target', t:6},
              {s:'target_val', t:6},
              {s:'value', t:6}
          ]}
      ]}
   ],
   16402 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   16601 : [
      {s:'holiday_list', t:9, f:[
          {s:'camp_id', t:6},
          {s:'bid', t:6},
          {s:'title', t:7},
          {s:'title2', t:7},
          {s:'ico', t:7},
          {s:'type_ico', t:2},
          {s:'top_banner', t:7},
          {s:'rule_str', t:7},
          {s:'time_str', t:7},
          {s:'bottom_alert', t:7},
          {s:'aim_title', t:7},
          {s:'panel_type', t:2},
          {s:'channel_ban', t:7},
          {s:'sort_val', t:2},
          {s:'reward_title', t:7},
          {s:'remain_sec', t:6},
          {s:'cli_type', t:6},
          {s:'cli_type_name', t:7}
      ]}
   ],
   16602 : [
      {s:'holiday_list', t:9, f:[
          {s:'bid', t:6},
          {s:'can_get_num', t:2}
      ]}
   ],
   16603 : [
      {s:'bid', t:6},
      {s:'cli_type', t:6},
      {s:'remain_sec', t:6},
      {s:'finish', t:6},
      {s:'aim_list', t:9, f:[
          {s:'aim', t:6},
          {s:'aim_str', t:7},
          {s:'status', t:2},
          {s:'item_list', t:9, f:[
              {s:'bid', t:6},
              {s:'num', t:6}
          ]},
          {s:'aim_args', t:9, f:[
              {s:'aim_args_key', t:2},
              {s:'aim_args_val', t:6},
              {s:'aim_args_str', t:7}
          ]}
      ]},
      {s:'item_effect_list', t:9, f:[
          {s:'bid', t:6},
          {s:'effect_1', t:2},
          {s:'effect_2', t:2}
      ]},
      {s:'args', t:9, f:[
          {s:'args_key', t:2},
          {s:'args_val', t:6},
          {s:'args_str', t:7}
      ]},
      {s:'client_reward', t:7},
      {s:'rank_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'sex', t:2},
          {s:'career', t:2},
          {s:'lev', t:2},
          {s:'val', t:6},
          {s:'rank_args', t:9, f:[
              {s:'rank_args_key', t:2},
              {s:'rank_args_val', t:6}
          ]}
      ]}
   ],
   16604 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16605 : [
      {s:'status', t:9, f:[
          {s:'bid', t:6},
          {s:'code', t:2},
          {s:'end_time', t:6}
      ]}
   ],
   16606 : [
      {s:'bid', t:6},
      {s:'can_get_num', t:2}
   ],
   16607 : [
      {s:'type', t:2}
   ],
   16610 : [
      {s:'bid', t:6},
      {s:'aim', t:6},
      {s:'item_bid', t:6}
   ],
   16620 : [
      {s:'holiday_list', t:9, f:[
          {s:'bid', t:6},
          {s:'cli_type', t:6},
          {s:'remain_sec', t:6},
          {s:'finish', t:6},
          {s:'aim_list', t:9, f:[
              {s:'aim', t:6},
              {s:'aim_str', t:7},
              {s:'status', t:2},
              {s:'item_list', t:9, f:[
                  {s:'bid', t:6},
                  {s:'num', t:6}
              ]},
              {s:'aim_args', t:9, f:[
                  {s:'aim_args_key', t:2},
                  {s:'aim_args_val', t:6},
                  {s:'aim_args_str', t:7}
              ]}
          ]},
          {s:'item_effect_list', t:9, f:[
              {s:'bid', t:6},
              {s:'effect_1', t:2},
              {s:'effect_2', t:2}
          ]},
          {s:'args', t:9, f:[
              {s:'args_key', t:2},
              {s:'args_val', t:6},
              {s:'args_str', t:7}
          ]},
          {s:'client_reward', t:7},
          {s:'rank_list', t:9, f:[
              {s:'rid', t:6},
              {s:'srv_id', t:7},
              {s:'name', t:7},
              {s:'sex', t:2},
              {s:'career', t:2},
              {s:'lev', t:2},
              {s:'val', t:6},
              {s:'rank_args', t:9, f:[
                  {s:'rank_args_key', t:2},
                  {s:'rank_args_val', t:6}
              ]}
          ]}
      ]}
   ],
   16630 : [
      {s:'code', t:2},
      {s:'items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   16631 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16633 : [
      {s:'code', t:2},
      {s:'items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   16634 : [
   ],
   16635 : [
      {s:'code', t:2},
      {s:'items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   16636 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16637 : [
      {s:'dial_data', t:9, f:[
          {s:'type', t:6},
          {s:'count', t:6},
          {s:'lucky', t:6},
          {s:'frist_type', t:6},
          {s:'lucky_award', t:9, f:[
              {s:'lucky', t:6}
          ]},
          {s:'end_time', t:6},
          {s:'rand_lists', t:9, f:[
              {s:'pos', t:2},
              {s:'id', t:6},
              {s:'status', t:2}
          ]},
          {s:'log_list', t:9, f:[
              {s:'role_name', t:7},
              {s:'bid', t:6},
              {s:'num', t:6}
          ]}
      ]}
   ],
   16638 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'frist_awards', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'awards1', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'awards2', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'awards3', t:9, f:[
          {s:'pos', t:2}
      ]}
   ],
   16639 : [
      {s:'type', t:6},
      {s:'count', t:6},
      {s:'lucky', t:6},
      {s:'frist_type', t:6},
      {s:'lucky_award', t:9, f:[
          {s:'lucky', t:6}
      ]},
      {s:'end_time', t:6},
      {s:'rand_lists', t:9, f:[
          {s:'pos', t:2},
          {s:'id', t:6},
          {s:'status', t:2}
      ]}
   ],
   16640 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'type', t:6}
   ],
   16641 : [
      {s:'type', t:6},
      {s:'log_list', t:9, f:[
          {s:'role_name', t:7},
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   16642 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'type', t:6}
   ],
   16643 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'frist_awards', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'awards1', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'awards2', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'awards3', t:9, f:[
          {s:'pos', t:2}
      ]}
   ],
   16650 : [
      {s:'rank', t:6},
      {s:'rank_award', t:9, f:[
          {s:'rank1', t:6},
          {s:'rank2', t:6},
          {s:'award', t:9, f:[
              {s:'bid', t:6},
              {s:'num', t:6}
          ]}
      ]}
   ],
   16660 : [
      {s:'holiday_exchanges', t:9, f:[
          {s:'bid', t:6},
          {s:'end_time', t:6},
          {s:'exchange_name', t:7},
          {s:'need_id', t:6},
          {s:'exchange_list', t:9, f:[
              {s:'aim', t:6},
              {s:'aim_str', t:7},
              {s:'buy_count', t:6},
              {s:'limit_buy', t:6},
              {s:'lable', t:6},
              {s:'expend_id', t:6},
              {s:'expend_num', t:6},
              {s:'item_list', t:9, f:[
                  {s:'bid', t:6},
                  {s:'num', t:6}
              ]},
              {s:'aim_args', t:9, f:[
                  {s:'aim_args_key', t:2},
                  {s:'aim_args_val', t:6},
                  {s:'aim_args_str', t:7}
              ]}
          ]}
      ]}
   ],
   16661 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'bid', t:6},
      {s:'aim', t:6},
      {s:'buy_count', t:6}
   ],
   16665 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16666 : [
   ],
   16670 : [
      {s:'num', t:6},
      {s:'gold', t:6},
      {s:'is_free', t:2},
      {s:'holiday_lev', t:6},
      {s:'award_list', t:9, f:[
          {s:'id', t:6},
          {s:'status', t:6}
      ]}
   ],
   16671 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'id', t:2},
      {s:'flag', t:2}
   ],
   16672 : [
      {s:'count', t:2},
      {s:'awards2', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   16673 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   16674 : [
      {s:'type', t:2},
      {s:'log_list', t:9, f:[
          {s:'role_name', t:7},
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   16675 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   16676 : [
      {s:'gold', t:6}
   ],
   16680 : [
      {s:'lucky', t:6},
      {s:'free_num', t:2},
      {s:'endtime', t:6},
      {s:'egg_status', t:9, f:[
          {s:'pos', t:2},
          {s:'type', t:2},
          {s:'status', t:2},
          {s:'show_reward', t:9, f:[
              {s:'item_id', t:6},
              {s:'num', t:6}
          ]}
      ]}
   ],
   16681 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16682 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16683 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16684 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16685 : [
      {s:'type', t:2},
      {s:'log_list', t:9, f:[
          {s:'role_name', t:7},
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   16686 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16687 : [
      {s:'bid', t:6},
      {s:'code', t:2}
   ],
   16688 : [
      {s:'buy_info', t:9, f:[
          {s:'id', t:2},
          {s:'day_num', t:6},
          {s:'all_num', t:6},
          {s:'s_day_num', t:6},
          {s:'s_all_num', t:6}
      ]}
   ],
   16689 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6},
      {s:'num', t:6}
   ],
   16691 : [
      {s:'code', t:2},
      {s:'items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   16692 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16693 : [
      {s:'code', t:2},
      {s:'items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   16694 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16695 : [
      {s:'code', t:2},
      {s:'items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   16696 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16697 : [
      {s:'code', t:2},
      {s:'items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   16698 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16700 : [
      {s:'list', t:9, f:[
          {s:'id', t:2},
          {s:'name', t:7},
          {s:'need_rmb', t:6},
          {s:'get_gold', t:6},
          {s:'add_gold', t:6},
          {s:'is_first', t:2},
          {s:'pic', t:2}
      ]}
   ],
   16705 : [
      {s:'card1_is_reward', t:2},
      {s:'card1_end_time', t:6},
      {s:'card1_days', t:4},
      {s:'card1_acc', t:4},
      {s:'card2_is_reward', t:2},
      {s:'card2_end_time', t:6},
      {s:'card2_days', t:4},
      {s:'card2_acc', t:4}
   ],
   16706 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'card_type', t:2}
   ],
   16707 : [
      {s:'status', t:2}
   ],
   16708 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16710 : [
      {s:'list', t:9, f:[
          {s:'lev', t:2}
      ]}
   ],
   16711 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16712 : [
      {s:'charge_sum', t:6},
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'status', t:2}
      ]}
   ],
   16713 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'status', t:2}
      ]}
   ],
   16730 : [
      {s:'time', t:6},
      {s:'state', t:2}
   ],
   16731 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16800 : [
      {s:'type', t:2},
      {s:'arg_uint32', t:9, f:[
          {s:'key', t:2},
          {s:'value', t:6}
      ]},
      {s:'arg_str', t:9, f:[
          {s:'key', t:2},
          {s:'value', t:7}
      ]},
      {s:'idx', t:6}
   ],
   16801 : [
      {s:'buff_list', t:9, f:[
          {s:'bid', t:6},
          {s:'remain_seconds', t:6}
      ]}
   ],
   16802 : [
      {s:'bid', t:6}
   ],
   16900 : [
      {s:'lev', t:2},
      {s:'exp', t:6},
      {s:'day_exp', t:6},
      {s:'week_exp', t:6}
   ],
   16901 : [
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'target_val', t:6},
          {s:'value', t:6}
      ]}
   ],
   16902 : [
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'target_val', t:6},
          {s:'value', t:6}
      ]}
   ],
   16903 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   16904 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   19800 : [
      {s:'code', t:6}
   ],
   19801 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   19802 : [
      {s:'list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:2},
          {s:'vip', t:2},
          {s:'sex', t:2},
          {s:'online', t:2},
          {s:'power', t:6},
          {s:'face_id', t:6},
          {s:'avatar_bid', t:6}
      ]}
   ],
   19803 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'lev', t:2},
      {s:'vip', t:2},
      {s:'sex', t:2},
      {s:'online', t:2},
      {s:'power', t:6},
      {s:'face_id', t:6},
      {s:'avatar_bid', t:6}
   ],
   19804 : [
      {s:'list', t:9, f:[
          {s:'id', t:2},
          {s:'num', t:2},
          {s:'had', t:2}
      ]}
   ],
   19805 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:2},
      {s:'num', t:2},
      {s:'had', t:2}
   ],
   19806 : [
      {s:'status', t:2}
   ],
   19807 : [
      {s:'code', t:6},
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'lev', t:2},
      {s:'vip', t:2},
      {s:'online', t:2},
      {s:'power', t:6},
      {s:'face_id', t:6},
      {s:'avatar_bid', t:6}
   ],
   19901 : [
      {s:'type', t:2},
      {s:'replay_list', t:9, f:[
          {s:'name', t:7},
          {s:'flag', t:1},
          {s:'is_collect', t:1},
          {s:'id', t:6},
          {s:'combat_type', t:2},
          {s:'round', t:2},
          {s:'sec_type', t:6},
          {s:'a_rid', t:6},
          {s:'a_srv_id', t:7},
          {s:'a_name', t:7},
          {s:'a_lev', t:4},
          {s:'a_face', t:6},
          {s:'a_power', t:6},
          {s:'a_rank', t:2},
          {s:'a_formation_type', t:2},
          {s:'a_camp_type', t:2},
          {s:'b_rid', t:6},
          {s:'b_srv_id', t:7},
          {s:'b_name', t:7},
          {s:'b_lev', t:4},
          {s:'b_face', t:6},
          {s:'b_power', t:6},
          {s:'b_rank', t:2},
          {s:'b_formation_type', t:2},
          {s:'b_camp_type', t:2},
          {s:'ret', t:2},
          {s:'like', t:6},
          {s:'share', t:6},
          {s:'play', t:6},
          {s:'time', t:6},
          {s:'a_plist', t:9, f:[
              {s:'id', t:6},
              {s:'pos', t:2},
              {s:'bid', t:6},
              {s:'lev', t:4},
              {s:'star', t:2},
              {s:'break_lev', t:2},
              {s:'power', t:6},
              {s:'hp', t:6},
              {s:'hp_max', t:6},
              {s:'dps', t:6},
              {s:'behurt', t:6},
              {s:'cure', t:6}
          ]},
          {s:'b_plist', t:9, f:[
              {s:'id', t:6},
              {s:'pos', t:2},
              {s:'bid', t:6},
              {s:'lev', t:4},
              {s:'star', t:2},
              {s:'break_lev', t:2},
              {s:'power', t:6},
              {s:'hp', t:6},
              {s:'hp_max', t:6},
              {s:'dps', t:6},
              {s:'behurt', t:6},
              {s:'cure', t:6}
          ]}
      ]}
   ],
   19902 : [
      {s:'type', t:2},
      {s:'cond_type', t:6},
      {s:'start', t:6},
      {s:'num', t:2},
      {s:'len', t:6},
      {s:'replay_list', t:9, f:[
          {s:'name', t:7},
          {s:'flag', t:1},
          {s:'is_collect', t:1},
          {s:'id', t:6},
          {s:'combat_type', t:2},
          {s:'round', t:2},
          {s:'sec_type', t:6},
          {s:'a_rid', t:6},
          {s:'a_srv_id', t:7},
          {s:'a_name', t:7},
          {s:'a_lev', t:4},
          {s:'a_face', t:6},
          {s:'a_power', t:6},
          {s:'a_rank', t:2},
          {s:'a_formation_type', t:2},
          {s:'a_camp_type', t:2},
          {s:'b_rid', t:6},
          {s:'b_srv_id', t:7},
          {s:'b_name', t:7},
          {s:'b_lev', t:4},
          {s:'b_face', t:6},
          {s:'b_power', t:6},
          {s:'b_rank', t:2},
          {s:'b_formation_type', t:2},
          {s:'b_camp_type', t:2},
          {s:'ret', t:2},
          {s:'like', t:6},
          {s:'share', t:6},
          {s:'play', t:6},
          {s:'time', t:6},
          {s:'a_plist', t:9, f:[
              {s:'id', t:6},
              {s:'pos', t:2},
              {s:'bid', t:6},
              {s:'lev', t:4},
              {s:'star', t:2},
              {s:'break_lev', t:2},
              {s:'power', t:6},
              {s:'hp', t:6},
              {s:'hp_max', t:6},
              {s:'dps', t:6},
              {s:'behurt', t:6},
              {s:'cure', t:6}
          ]},
          {s:'b_plist', t:9, f:[
              {s:'id', t:6},
              {s:'pos', t:2},
              {s:'bid', t:6},
              {s:'lev', t:4},
              {s:'star', t:2},
              {s:'break_lev', t:2},
              {s:'power', t:6},
              {s:'hp', t:6},
              {s:'hp_max', t:6},
              {s:'dps', t:6},
              {s:'behurt', t:6},
              {s:'cure', t:6}
          ]}
      ]}
   ],
   19903 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   19904 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6},
      {s:'type', t:2}
   ],
   19905 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   19906 : [
      {s:'like', t:2}
   ],
   19907 : [
      {s:'replay_id', t:6},
      {s:'partner_id', t:6},
      {s:'type', t:2},
      {s:'pos', t:2},
      {s:'bid', t:6},
      {s:'lev', t:4},
      {s:'star', t:2},
      {s:'break_lev', t:2},
      {s:'power', t:6},
      {s:'now_hp', t:6},
      {s:'hp', t:6},
      {s:'atk', t:6},
      {s:'def', t:6},
      {s:'speed', t:6},
      {s:'crit_rate', t:6},
      {s:'crit_ratio', t:6},
      {s:'hit_magic', t:6},
      {s:'dodge_magic', t:6},
      {s:'dps', t:6},
      {s:'behurt', t:6},
      {s:'cure', t:6},
      {s:'skills', t:9, f:[
          {s:'pos', t:2},
          {s:'skill_bid', t:6}
      ]},
      {s:'eqms', t:9, f:[
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'type', t:6}
      ]},
      {s:'artifacts', t:9, f:[
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'artifact_pos', t:2},
          {s:'enchant', t:6},
          {s:'attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'extra_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'extra', t:9, f:[
              {s:'extra_k', t:6},
              {s:'extra_v', t:6}
          ]}
      ]},
      {s:'ext', t:9, f:[
          {s:'id', t:6},
          {s:'val', t:6}
      ]}
   ],
   19908 : [
      {s:'type', t:2},
      {s:'channel', t:4},
      {s:'name', t:7},
      {s:'flag', t:1},
      {s:'is_collect', t:1},
      {s:'id', t:6},
      {s:'combat_type', t:2},
      {s:'round', t:2},
      {s:'sec_type', t:6},
      {s:'a_rid', t:6},
      {s:'a_srv_id', t:7},
      {s:'a_name', t:7},
      {s:'a_lev', t:4},
      {s:'a_face', t:6},
      {s:'a_power', t:6},
      {s:'a_rank', t:2},
      {s:'a_formation_type', t:2},
      {s:'a_camp_type', t:2},
      {s:'b_rid', t:6},
      {s:'b_srv_id', t:7},
      {s:'b_name', t:7},
      {s:'b_lev', t:4},
      {s:'b_face', t:6},
      {s:'b_power', t:6},
      {s:'b_rank', t:2},
      {s:'b_formation_type', t:2},
      {s:'b_camp_type', t:2},
      {s:'ret', t:2},
      {s:'like', t:6},
      {s:'share', t:6},
      {s:'play', t:6},
      {s:'time', t:6},
      {s:'a_plist', t:9, f:[
          {s:'id', t:6},
          {s:'pos', t:2},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'break_lev', t:2},
          {s:'power', t:6},
          {s:'hp', t:6},
          {s:'hp_max', t:6},
          {s:'dps', t:6},
          {s:'behurt', t:6},
          {s:'cure', t:6}
      ]},
      {s:'b_plist', t:9, f:[
          {s:'id', t:6},
          {s:'pos', t:2},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'break_lev', t:2},
          {s:'power', t:6},
          {s:'hp', t:6},
          {s:'hp_max', t:6},
          {s:'dps', t:6},
          {s:'behurt', t:6},
          {s:'cure', t:6}
      ]}
   ],
   20000 : [
      {s:'combat_type', t:4},
      {s:'combat_map', t:6}
   ],
   20001 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20002 : [
      {s:'pos', t:4},
      {s:'owner_id', t:6},
      {s:'owner_srv_id', t:7},
      {s:'all_alive', t:9, f:[
          {s:'pos', t:4}
      ]},
      {s:'skill_plays', t:9, f:[
          {s:'order', t:2},
          {s:'actor', t:4},
          {s:'target', t:4},
          {s:'skill_bid', t:6},
          {s:'talk_pos', t:4},
          {s:'talk_content', t:7},
          {s:'effect_play', t:9, f:[
              {s:'order', t:4},
              {s:'actor', t:4},
              {s:'target', t:4},
              {s:'effect_bid', t:6},
              {s:'is_hit', t:2},
              {s:'is_crit', t:2},
              {s:'hp_changed', t:5},
              {s:'hp', t:5},
              {s:'is_dead', t:1},
              {s:'camp_restrain', t:1},
              {s:'buff_list', t:9, f:[
                  {s:'target', t:4},
                  {s:'buff_bid', t:6},
                  {s:'remain_round', t:4},
                  {s:'end_round', t:2},
                  {s:'action_type', t:2},
                  {s:'change_type', t:2},
                  {s:'change_value', t:5},
                  {s:'is_dead', t:1},
                  {s:'id', t:6}
              ]},
              {s:'summon_list', t:9, f:[
                  {s:'pos', t:4},
                  {s:'group', t:2},
                  {s:'owner_id', t:6},
                  {s:'owner_srv_id', t:7},
                  {s:'object_type', t:4},
                  {s:'object_id', t:6},
                  {s:'object_bid', t:6},
                  {s:'object_name', t:7},
                  {s:'star', t:2},
                  {s:'camp_type', t:1},
                  {s:'sex', t:1},
                  {s:'career', t:1},
                  {s:'lev', t:6},
                  {s:'hp', t:5},
                  {s:'hp_max', t:5},
                  {s:'face_id', t:5},
                  {s:'skills', t:9, f:[
                      {s:'skill_bid', t:6},
                      {s:'end_round', t:1}
                  ]},
                  {s:'extra_data', t:9, f:[
                      {s:'extra_key', t:2},
                      {s:'extra_value', t:6}
                  ]}
              ]},
              {s:'sub_effect_play_list', t:9, f:[
                  {s:'sub_target', t:4},
                  {s:'sub_effect_id', t:6},
                  {s:'sub_hp_changed', t:5},
                  {s:'sub_is_hit', t:2},
                  {s:'sub_skill_id', t:6},
                  {s:'extra_effect', t:9, f:[
                      {s:'extra_key', t:4},
                      {s:'extra_param', t:5}
                  ]}
              ]},
              {s:'is_blind', t:2},
              {s:'skill_bid_of_effect', t:6},
              {s:'actor_hp_changed', t:5},
              {s:'actor_is_dead', t:1},
              {s:'aid_actor', t:4},
              {s:'total_hurt', t:6},
              {s:'hurt_reward', t:9, f:[
                  {s:'assets_id', t:6},
                  {s:'assets_val', t:5}
              ]}
          ]}
      ]},
      {s:'round_buff', t:9, f:[
          {s:'target', t:4},
          {s:'buff_bid', t:6},
          {s:'remain_round', t:4},
          {s:'end_round', t:2},
          {s:'action_type', t:2},
          {s:'change_type', t:2},
          {s:'change_value', t:5},
          {s:'is_dead', t:1},
          {s:'id', t:6}
      ]},
      {s:'countdown_time', t:6},
      {s:'action_count', t:6},
      {s:'combat_type', t:4},
      {s:'hallows_list', t:9, f:[
          {s:'group', t:2},
          {s:'val', t:2}
      ]}
   ],
   20004 : [
      {s:'skill_plays', t:9, f:[
          {s:'order', t:2},
          {s:'actor', t:4},
          {s:'target', t:4},
          {s:'skill_bid', t:6},
          {s:'talk_pos', t:4},
          {s:'talk_content', t:7},
          {s:'effect_play', t:9, f:[
              {s:'order', t:4},
              {s:'actor', t:4},
              {s:'target', t:4},
              {s:'effect_bid', t:6},
              {s:'is_hit', t:2},
              {s:'is_crit', t:2},
              {s:'hp_changed', t:5},
              {s:'hp', t:5},
              {s:'is_dead', t:1},
              {s:'camp_restrain', t:1},
              {s:'buff_list', t:9, f:[
                  {s:'target', t:4},
                  {s:'buff_bid', t:6},
                  {s:'remain_round', t:4},
                  {s:'end_round', t:2},
                  {s:'action_type', t:2},
                  {s:'change_type', t:2},
                  {s:'change_value', t:5},
                  {s:'is_dead', t:1},
                  {s:'id', t:6}
              ]},
              {s:'summon_list', t:9, f:[
                  {s:'pos', t:4},
                  {s:'group', t:2},
                  {s:'owner_id', t:6},
                  {s:'owner_srv_id', t:7},
                  {s:'object_type', t:4},
                  {s:'object_id', t:6},
                  {s:'object_bid', t:6},
                  {s:'object_name', t:7},
                  {s:'star', t:2},
                  {s:'camp_type', t:1},
                  {s:'sex', t:1},
                  {s:'career', t:1},
                  {s:'lev', t:6},
                  {s:'hp', t:5},
                  {s:'hp_max', t:5},
                  {s:'face_id', t:5},
                  {s:'skills', t:9, f:[
                      {s:'skill_bid', t:6},
                      {s:'end_round', t:1}
                  ]},
                  {s:'extra_data', t:9, f:[
                      {s:'extra_key', t:2},
                      {s:'extra_value', t:6}
                  ]}
              ]},
              {s:'sub_effect_play_list', t:9, f:[
                  {s:'sub_target', t:4},
                  {s:'sub_effect_id', t:6},
                  {s:'sub_hp_changed', t:5},
                  {s:'sub_is_hit', t:2},
                  {s:'sub_skill_id', t:6},
                  {s:'extra_effect', t:9, f:[
                      {s:'extra_key', t:4},
                      {s:'extra_param', t:5}
                  ]}
              ]},
              {s:'is_blind', t:2},
              {s:'skill_bid_of_effect', t:6},
              {s:'actor_hp_changed', t:5},
              {s:'actor_is_dead', t:1},
              {s:'aid_actor', t:4},
              {s:'total_hurt', t:6},
              {s:'hurt_reward', t:9, f:[
                  {s:'assets_id', t:6},
                  {s:'assets_val', t:5}
              ]}
          ]}
      ]},
      {s:'round_buff', t:9, f:[
          {s:'target', t:4},
          {s:'buff_bid', t:6},
          {s:'remain_round', t:4},
          {s:'end_round', t:2},
          {s:'action_type', t:2},
          {s:'change_type', t:2},
          {s:'change_value', t:5},
          {s:'is_dead', t:1},
          {s:'id', t:6}
      ]},
      {s:'action_count', t:6},
      {s:'combat_type', t:4},
      {s:'star_list', t:9, f:[
          {s:'id', t:2},
          {s:'val', t:2}
      ]}
   ],
   20005 : [
   ],
   20006 : [
      {s:'result', t:2},
      {s:'item_rewards', t:9, f:[
          {s:'bid', t:6},
          {s:'is_bind', t:2},
          {s:'num', t:6},
          {s:'id', t:6}
      ]},
      {s:'show_panel_type', t:2},
      {s:'current_time', t:6},
      {s:'best_time', t:6},
      {s:'combat_type', t:4},
      {s:'target_role_name', t:7},
      {s:'hurt_statistics', t:9, f:[
          {s:'type', t:2},
          {s:'partner_hurts', t:9, f:[
              {s:'rid', t:6},
              {s:'srvid', t:7},
              {s:'id', t:6},
              {s:'bid', t:6},
              {s:'star', t:6},
              {s:'lev', t:6},
              {s:'camp_type', t:6},
              {s:'dps', t:6},
              {s:'cure', t:6},
              {s:'ext_data', t:9, f:[
                  {s:'key', t:6},
                  {s:'val', t:6}
              ]}
          ]}
      ]}
   ],
   20008 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20009 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20013 : [
      {s:'combat_type', t:4},
      {s:'formation', t:9, f:[
          {s:'group', t:2},
          {s:'formation_type', t:2},
          {s:'formation_lev', t:2}
      ]},
      {s:'objects', t:9, f:[
          {s:'pos', t:4},
          {s:'group', t:2},
          {s:'owner_id', t:6},
          {s:'owner_srv_id', t:7},
          {s:'object_type', t:4},
          {s:'object_id', t:6},
          {s:'object_bid', t:6},
          {s:'object_name', t:7},
          {s:'star', t:2},
          {s:'camp_type', t:1},
          {s:'sex', t:1},
          {s:'career', t:1},
          {s:'lev', t:6},
          {s:'hp', t:5},
          {s:'hp_max', t:5},
          {s:'face_id', t:5},
          {s:'skills', t:9, f:[
              {s:'skill_bid', t:6},
              {s:'end_round', t:1}
          ]},
          {s:'extra_data', t:9, f:[
              {s:'extra_key', t:2},
              {s:'extra_value', t:6}
          ]}
      ]},
      {s:'is_auto', t:2},
      {s:'buffs', t:9, f:[
          {s:'target', t:4},
          {s:'buff_bid', t:6},
          {s:'remain_round', t:4},
          {s:'end_round', t:2},
          {s:'action_type', t:2},
          {s:'change_type', t:2},
          {s:'change_value', t:5},
          {s:'is_dead', t:1},
          {s:'id', t:6}
      ]},
      {s:'current_wave', t:2},
      {s:'total_wave', t:4},
      {s:'play_speed', t:2},
      {s:'combat_map', t:6},
      {s:'extra_args', t:9, f:[
          {s:'param', t:6}
      ]},
      {s:'action_count', t:6},
      {s:'a_object_num', t:2},
      {s:'target_role_name', t:7},
      {s:'actor_role_name', t:7},
      {s:'begin_time', t:6},
      {s:'suppress', t:2},
      {s:'flag', t:2},
      {s:'halo_list', t:9, f:[
          {s:'group', t:2},
          {s:'type', t:4}
      ]},
      {s:'hallows_list', t:9, f:[
          {s:'group', t:2},
          {s:'val', t:2},
          {s:'max', t:2}
      ]},
      {s:'cli_string_ext_args', t:9, f:[
          {s:'param', t:7}
      ]}
   ],
   20014 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20015 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20016 : [
      {s:'target_id', t:6},
      {s:'target_srv_id', t:7},
      {s:'target_name', t:7},
      {s:'target_lev', t:2},
      {s:'target_face', t:6}
   ],
   20019 : [
   ],
   20020 : [
      {s:'combat_type', t:4},
      {s:'formation', t:9, f:[
          {s:'group', t:2},
          {s:'formation_type', t:2},
          {s:'formation_lev', t:2}
      ]},
      {s:'objects', t:9, f:[
          {s:'pos', t:4},
          {s:'group', t:2},
          {s:'owner_id', t:6},
          {s:'owner_srv_id', t:7},
          {s:'object_type', t:4},
          {s:'object_id', t:6},
          {s:'object_bid', t:6},
          {s:'object_name', t:7},
          {s:'star', t:2},
          {s:'camp_type', t:1},
          {s:'sex', t:1},
          {s:'career', t:1},
          {s:'lev', t:6},
          {s:'hp', t:5},
          {s:'hp_max', t:5},
          {s:'face_id', t:5},
          {s:'skills', t:9, f:[
              {s:'skill_bid', t:6},
              {s:'end_round', t:1}
          ]},
          {s:'extra_data', t:9, f:[
              {s:'extra_key', t:2},
              {s:'extra_value', t:6}
          ]}
      ]},
      {s:'is_auto', t:2},
      {s:'buffs', t:9, f:[
          {s:'target', t:4},
          {s:'buff_bid', t:6},
          {s:'remain_round', t:4},
          {s:'end_round', t:2},
          {s:'action_type', t:2},
          {s:'change_type', t:2},
          {s:'change_value', t:5},
          {s:'is_dead', t:1},
          {s:'id', t:6}
      ]},
      {s:'current_wave', t:2},
      {s:'total_wave', t:4},
      {s:'target_role_name', t:7},
      {s:'actor_role_name', t:7},
      {s:'halo_list', t:9, f:[
          {s:'group', t:2},
          {s:'type', t:4}
      ]}
   ],
   20022 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20026 : [
      {s:'drama_id', t:6}
   ],
   20027 : [
      {s:'combat_type', t:4},
      {s:'formation', t:9, f:[
          {s:'group', t:2},
          {s:'formation_type', t:2},
          {s:'formation_lev', t:2}
      ]},
      {s:'objects', t:9, f:[
          {s:'pos', t:4},
          {s:'group', t:2},
          {s:'owner_id', t:6},
          {s:'owner_srv_id', t:7},
          {s:'object_type', t:4},
          {s:'object_id', t:6},
          {s:'object_bid', t:6},
          {s:'object_name', t:7},
          {s:'star', t:2},
          {s:'camp_type', t:1},
          {s:'sex', t:1},
          {s:'career', t:1},
          {s:'lev', t:6},
          {s:'hp', t:5},
          {s:'hp_max', t:5},
          {s:'face_id', t:5},
          {s:'skills', t:9, f:[
              {s:'skill_bid', t:6},
              {s:'end_round', t:1}
          ]},
          {s:'extra_data', t:9, f:[
              {s:'extra_key', t:2},
              {s:'extra_value', t:6}
          ]}
      ]},
      {s:'is_auto', t:2},
      {s:'current_wave', t:2},
      {s:'total_wave', t:4},
      {s:'play_speed', t:2},
      {s:'extra_args', t:9, f:[
          {s:'param', t:6}
      ]},
      {s:'target_role_name', t:7},
      {s:'a_object_num', t:2},
      {s:'actor_role_name', t:7},
      {s:'suppress', t:2},
      {s:'halo_list', t:9, f:[
          {s:'group', t:2},
          {s:'type', t:4}
      ]},
      {s:'hallows_list', t:9, f:[
          {s:'group', t:2},
          {s:'val', t:2},
          {s:'max', t:2}
      ]},
      {s:'string_ext_args', t:9, f:[
          {s:'param', t:7}
      ]}
   ],
   20028 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20029 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20030 : [
      {s:'is_in_combat', t:2}
   ],
   20033 : [
      {s:'result', t:2},
      {s:'def_name', t:7},
      {s:'def_guild_name', t:7},
      {s:'def_lev', t:6},
      {s:'def_face_id', t:6},
      {s:'replay_id', t:6},
      {s:'is_province', t:2},
      {s:'hurt_statistics', t:9, f:[
          {s:'type', t:2},
          {s:'partner_hurts', t:9, f:[
              {s:'rid', t:6},
              {s:'srvid', t:7},
              {s:'id', t:6},
              {s:'bid', t:6},
              {s:'star', t:6},
              {s:'lev', t:6},
              {s:'camp_type', t:6},
              {s:'dps', t:6},
              {s:'cure', t:6},
              {s:'ext_data', t:9, f:[
                  {s:'key', t:6},
                  {s:'val', t:6}
              ]}
          ]}
      ]}
   ],
   20034 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   20036 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20060 : [
      {s:'combat_type', t:4},
      {s:'type', t:2}
   ],
   20061 : [
      {s:'combat_type', t:4},
      {s:'bid', t:6},
      {s:'partner_list', t:9, f:[
          {s:'pos', t:2},
          {s:'speed', t:4},
          {s:'bid', t:6},
          {s:'lev', t:2},
          {s:'star', t:2},
          {s:'quality', t:2},
          {s:'hp', t:6},
          {s:'crit', t:4},
          {s:'skill_list', t:9, f:[
              {s:'sid', t:6},
              {s:'effect_list', t:9, f:[
                  {s:'eid', t:6},
                  {s:'num', t:2},
                  {s:'min_hurt', t:6},
                  {s:'max_hurt', t:6}
              ]},
              {s:'rand', t:2}
          ]},
          {s:'use_skin', t:6}
      ]},
      {s:'wave_list', t:9, f:[
          {s:'unit_list', t:9, f:[
              {s:'pos', t:2},
              {s:'bid', t:6},
              {s:'speed', t:4},
              {s:'hp', t:6},
              {s:'crit', t:4},
              {s:'skill_list', t:9, f:[
                  {s:'sid', t:6},
                  {s:'effect_list', t:9, f:[
                      {s:'eid', t:6},
                      {s:'num', t:2},
                      {s:'min_hurt', t:6},
                      {s:'max_hurt', t:6}
                  ]},
                  {s:'rand', t:2}
              ]}
          ]}
      ]},
      {s:'dun_bid', t:6},
      {s:'b_formation_type', t:2}
   ],
   20062 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20063 : [
      {s:'type_list', t:9, f:[
          {s:'combat_type', t:4}
      ]}
   ],
   20200 : [
      {s:'rank', t:4},
      {s:'score', t:6},
      {s:'can_combat_num', t:2},
      {s:'buy_combat_num', t:2},
      {s:'ref_time', t:5},
      {s:'start_time', t:6},
      {s:'end_time', t:6},
      {s:'cont_win', t:4}
   ],
   20201 : [
      {s:'f_list', t:9, f:[
          {s:'idx', t:2},
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'sex', t:2},
          {s:'face', t:6},
          {s:'power', t:6},
          {s:'score', t:6},
          {s:'get_score', t:2},
          {s:'status', t:2},
          {s:'p_list', t:9, f:[
              {s:'pos', t:2},
              {s:'bid', t:6},
              {s:'lev', t:4},
              {s:'star', t:2},
              {s:'break_lev', t:2},
              {s:'use_skin', t:6}
          ]}
      ]},
      {s:'type', t:2}
   ],
   20202 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'lev', t:4},
      {s:'face', t:6},
      {s:'power', t:6},
      {s:'score', t:6},
      {s:'formation_type', t:2},
      {s:'formation_lev', t:2},
      {s:'p_list', t:9, f:[
          {s:'pos', t:2},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'quality', t:2},
          {s:'star', t:2},
          {s:'break_lev', t:2},
          {s:'use_skin', t:6}
      ]}
   ],
   20203 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20204 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20206 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20207 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20208 : [
      {s:'had_combat_num', t:4},
      {s:'num_list', t:9, f:[
          {s:'num', t:2}
      ]}
   ],
   20209 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20210 : [
      {s:'result', t:2},
      {s:'score', t:6},
      {s:'get_score', t:5},
      {s:'items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'tar_name', t:7},
      {s:'tar_lev', t:4},
      {s:'tar_face', t:6},
      {s:'tar_score', t:5},
      {s:'lose_score', t:5},
      {s:'target_role_name', t:7},
      {s:'hurt_statistics', t:9, f:[
          {s:'type', t:2},
          {s:'partner_hurts', t:9, f:[
              {s:'rid', t:6},
              {s:'srvid', t:7},
              {s:'id', t:6},
              {s:'bid', t:6},
              {s:'star', t:6},
              {s:'lev', t:6},
              {s:'camp_type', t:6},
              {s:'dps', t:6},
              {s:'cure', t:6},
              {s:'ext_data', t:9, f:[
                  {s:'key', t:6},
                  {s:'val', t:6}
              ]}
          ]}
      ]}
   ],
   20220 : [
      {s:'rank_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'rank', t:2},
          {s:'score', t:6},
          {s:'sex', t:2},
          {s:'lookid', t:6},
          {s:'worship', t:6},
          {s:'worship_status', t:2}
      ]}
   ],
   20221 : [
      {s:'rank', t:4},
      {s:'score', t:6},
      {s:'worship', t:6},
      {s:'rank_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'face', t:6},
          {s:'sex', t:2},
          {s:'rank', t:4},
          {s:'score', t:6},
          {s:'power', t:6},
          {s:'avatar_id', t:6},
          {s:'worship', t:6},
          {s:'worship_status', t:2}
      ]}
   ],
   20222 : [
      {s:'log_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'sex', t:2},
          {s:'face', t:6},
          {s:'avatar_id', t:6},
          {s:'power', t:6},
          {s:'score', t:3},
          {s:'type', t:2},
          {s:'ret', t:2},
          {s:'replay_id', t:6},
          {s:'time', t:6}
      ]}
   ],
   20223 : [
      {s:'flag', t:2}
   ],
   20250 : [
      {s:'start_time', t:6},
      {s:'end_time', t:6},
      {s:'step', t:2},
      {s:'step_status', t:2},
      {s:'step_status_time', t:6},
      {s:'round', t:2},
      {s:'round_status', t:2},
      {s:'round_status_time', t:6},
      {s:'flag', t:2}
   ],
   20251 : [
      {s:'rank', t:4},
      {s:'best_rank', t:4},
      {s:'can_bet', t:6},
      {s:'group', t:2}
   ],
   20252 : [
      {s:'step', t:2},
      {s:'round', t:2},
      {s:'group', t:2},
      {s:'a_bet', t:6},
      {s:'a_rid', t:6},
      {s:'a_srv_id', t:7},
      {s:'a_name', t:7},
      {s:'a_lev', t:4},
      {s:'a_face', t:6},
      {s:'a_avatar_id', t:6},
      {s:'a_sex', t:2},
      {s:'a_power', t:6},
      {s:'a_formation_type', t:2},
      {s:'a_formation_lev', t:2},
      {s:'a_plist', t:9, f:[
          {s:'pos', t:2},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'quality', t:2},
          {s:'star', t:2},
          {s:'break_lev', t:2},
          {s:'hurt', t:6},
          {s:'behurt', t:6},
          {s:'curt', t:6},
          {s:'ext_data', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:6}
          ]}
      ]},
      {s:'b_bet', t:6},
      {s:'b_rid', t:6},
      {s:'b_srv_id', t:7},
      {s:'b_name', t:7},
      {s:'b_lev', t:4},
      {s:'b_face', t:6},
      {s:'b_avatar_id', t:6},
      {s:'b_sex', t:2},
      {s:'b_power', t:6},
      {s:'b_formation_type', t:2},
      {s:'b_formation_lev', t:2},
      {s:'b_plist', t:9, f:[
          {s:'pos', t:2},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'quality', t:2},
          {s:'star', t:2},
          {s:'break_lev', t:2},
          {s:'hurt', t:6},
          {s:'behurt', t:6},
          {s:'curt', t:6},
          {s:'ext_data', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:6}
          ]}
      ]},
      {s:'ret', t:2},
      {s:'replay_id', t:6}
   ],
   20253 : [
      {s:'bet_type', t:2},
      {s:'bet_val', t:6},
      {s:'a_bet_ratio', t:4},
      {s:'b_bet_ratio', t:4},
      {s:'step', t:2},
      {s:'round', t:2},
      {s:'group', t:2},
      {s:'a_bet', t:6},
      {s:'a_rid', t:6},
      {s:'a_srv_id', t:7},
      {s:'a_name', t:7},
      {s:'a_lev', t:4},
      {s:'a_face', t:6},
      {s:'a_avatar_id', t:6},
      {s:'a_sex', t:2},
      {s:'a_power', t:6},
      {s:'a_formation_type', t:2},
      {s:'a_formation_lev', t:2},
      {s:'a_plist', t:9, f:[
          {s:'pos', t:2},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'quality', t:2},
          {s:'star', t:2},
          {s:'break_lev', t:2},
          {s:'hurt', t:6},
          {s:'behurt', t:6},
          {s:'curt', t:6},
          {s:'ext_data', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:6}
          ]}
      ]},
      {s:'b_bet', t:6},
      {s:'b_rid', t:6},
      {s:'b_srv_id', t:7},
      {s:'b_name', t:7},
      {s:'b_lev', t:4},
      {s:'b_face', t:6},
      {s:'b_avatar_id', t:6},
      {s:'b_sex', t:2},
      {s:'b_power', t:6},
      {s:'b_formation_type', t:2},
      {s:'b_formation_lev', t:2},
      {s:'b_plist', t:9, f:[
          {s:'pos', t:2},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'quality', t:2},
          {s:'star', t:2},
          {s:'break_lev', t:2},
          {s:'hurt', t:6},
          {s:'behurt', t:6},
          {s:'curt', t:6},
          {s:'ext_data', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:6}
          ]}
      ]},
      {s:'ret', t:2},
      {s:'replay_id', t:6}
   ],
   20254 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'can_bet', t:6},
      {s:'bet_type', t:2},
      {s:'bet_val', t:6}
   ],
   20255 : [
      {s:'list', t:9, f:[
          {s:'id', t:4},
          {s:'target', t:2},
          {s:'bet', t:6},
          {s:'get_bet', t:6},
          {s:'step', t:2},
          {s:'round', t:2},
          {s:'group', t:2},
          {s:'a_bet', t:6},
          {s:'a_rid', t:6},
          {s:'a_srv_id', t:7},
          {s:'a_name', t:7},
          {s:'a_lev', t:4},
          {s:'a_face', t:6},
          {s:'a_avatar_id', t:6},
          {s:'a_sex', t:2},
          {s:'a_power', t:6},
          {s:'a_formation_type', t:2},
          {s:'a_formation_lev', t:2},
          {s:'a_plist', t:9, f:[
              {s:'pos', t:2},
              {s:'bid', t:6},
              {s:'lev', t:4},
              {s:'quality', t:2},
              {s:'star', t:2},
              {s:'break_lev', t:2},
              {s:'hurt', t:6},
              {s:'behurt', t:6},
              {s:'curt', t:6},
              {s:'ext_data', t:9, f:[
                  {s:'key', t:6},
                  {s:'val', t:6}
              ]}
          ]},
          {s:'b_bet', t:6},
          {s:'b_rid', t:6},
          {s:'b_srv_id', t:7},
          {s:'b_name', t:7},
          {s:'b_lev', t:4},
          {s:'b_face', t:6},
          {s:'b_avatar_id', t:6},
          {s:'b_sex', t:2},
          {s:'b_power', t:6},
          {s:'b_formation_type', t:2},
          {s:'b_formation_lev', t:2},
          {s:'b_plist', t:9, f:[
              {s:'pos', t:2},
              {s:'bid', t:6},
              {s:'lev', t:4},
              {s:'quality', t:2},
              {s:'star', t:2},
              {s:'break_lev', t:2},
              {s:'hurt', t:6},
              {s:'behurt', t:6},
              {s:'curt', t:6},
              {s:'ext_data', t:9, f:[
                  {s:'key', t:6},
                  {s:'val', t:6}
              ]}
          ]},
          {s:'ret', t:2},
          {s:'replay_id', t:6}
      ]}
   ],
   20256 : [
      {s:'rank', t:4},
      {s:'cnum', t:2},
      {s:'win', t:2}
   ],
   20257 : [
      {s:'a_bet', t:6},
      {s:'b_bet', t:6},
      {s:'a_bet_ratio', t:4},
      {s:'b_bet_ratio', t:4}
   ],
   20258 : [
      {s:'list', t:9, f:[
          {s:'id', t:4},
          {s:'score', t:4},
          {s:'step', t:2},
          {s:'round', t:2},
          {s:'group', t:2},
          {s:'a_bet', t:6},
          {s:'a_rid', t:6},
          {s:'a_srv_id', t:7},
          {s:'a_name', t:7},
          {s:'a_lev', t:4},
          {s:'a_face', t:6},
          {s:'a_avatar_id', t:6},
          {s:'a_sex', t:2},
          {s:'a_power', t:6},
          {s:'a_formation_type', t:2},
          {s:'a_formation_lev', t:2},
          {s:'a_plist', t:9, f:[
              {s:'pos', t:2},
              {s:'bid', t:6},
              {s:'lev', t:4},
              {s:'quality', t:2},
              {s:'star', t:2},
              {s:'break_lev', t:2},
              {s:'hurt', t:6},
              {s:'behurt', t:6},
              {s:'curt', t:6},
              {s:'ext_data', t:9, f:[
                  {s:'key', t:6},
                  {s:'val', t:6}
              ]}
          ]},
          {s:'b_bet', t:6},
          {s:'b_rid', t:6},
          {s:'b_srv_id', t:7},
          {s:'b_name', t:7},
          {s:'b_lev', t:4},
          {s:'b_face', t:6},
          {s:'b_avatar_id', t:6},
          {s:'b_sex', t:2},
          {s:'b_power', t:6},
          {s:'b_formation_type', t:2},
          {s:'b_formation_lev', t:2},
          {s:'b_plist', t:9, f:[
              {s:'pos', t:2},
              {s:'bid', t:6},
              {s:'lev', t:4},
              {s:'quality', t:2},
              {s:'star', t:2},
              {s:'break_lev', t:2},
              {s:'hurt', t:6},
              {s:'behurt', t:6},
              {s:'curt', t:6},
              {s:'ext_data', t:9, f:[
                  {s:'key', t:6},
                  {s:'val', t:6}
              ]}
          ]},
          {s:'ret', t:2},
          {s:'replay_id', t:6}
      ]}
   ],
   20260 : [
      {s:'list', t:9, f:[
          {s:'group', t:2},
          {s:'pos_list', t:9, f:[
              {s:'pos', t:2},
              {s:'rid', t:6},
              {s:'srv_id', t:7},
              {s:'name', t:7},
              {s:'ret', t:2},
              {s:'replay_id', t:6}
          ]}
      ]}
   ],
   20261 : [
      {s:'pos_list', t:9, f:[
          {s:'pos', t:2},
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'face', t:6},
          {s:'ret', t:2},
          {s:'replay_id', t:6}
      ]}
   ],
   20262 : [
      {s:'group', t:2},
      {s:'pos', t:2}
   ],
   20263 : [
      {s:'step', t:2},
      {s:'round', t:2},
      {s:'group', t:2},
      {s:'a_bet', t:6},
      {s:'a_rid', t:6},
      {s:'a_srv_id', t:7},
      {s:'a_name', t:7},
      {s:'a_lev', t:4},
      {s:'a_face', t:6},
      {s:'a_avatar_id', t:6},
      {s:'a_sex', t:2},
      {s:'a_power', t:6},
      {s:'a_formation_type', t:2},
      {s:'a_formation_lev', t:2},
      {s:'a_plist', t:9, f:[
          {s:'pos', t:2},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'quality', t:2},
          {s:'star', t:2},
          {s:'break_lev', t:2},
          {s:'hurt', t:6},
          {s:'behurt', t:6},
          {s:'curt', t:6},
          {s:'ext_data', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:6}
          ]}
      ]},
      {s:'b_bet', t:6},
      {s:'b_rid', t:6},
      {s:'b_srv_id', t:7},
      {s:'b_name', t:7},
      {s:'b_lev', t:4},
      {s:'b_face', t:6},
      {s:'b_avatar_id', t:6},
      {s:'b_sex', t:2},
      {s:'b_power', t:6},
      {s:'b_formation_type', t:2},
      {s:'b_formation_lev', t:2},
      {s:'b_plist', t:9, f:[
          {s:'pos', t:2},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'quality', t:2},
          {s:'star', t:2},
          {s:'break_lev', t:2},
          {s:'hurt', t:6},
          {s:'behurt', t:6},
          {s:'curt', t:6},
          {s:'ext_data', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:6}
          ]}
      ]},
      {s:'ret', t:2},
      {s:'replay_id', t:6}
   ],
   20280 : [
      {s:'rank_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'rank', t:2},
          {s:'sex', t:2},
          {s:'lookid', t:6},
          {s:'worship', t:6},
          {s:'worship_status', t:2}
      ]}
   ],
   20281 : [
      {s:'rank', t:4},
      {s:'worship', t:6},
      {s:'power', t:6},
      {s:'rank_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'face', t:6},
          {s:'sex', t:2},
          {s:'rank', t:4},
          {s:'score', t:4},
          {s:'power', t:6},
          {s:'worship', t:6},
          {s:'worship_status', t:2}
      ]}
   ],
   20282 : [
      {s:'time', t:6},
      {s:'rank_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'face', t:6},
          {s:'sex', t:2},
          {s:'rank', t:4}
      ]}
   ],
   20300 : [
      {s:'activity_box', t:9, f:[
          {s:'activity', t:4}
      ]}
   ],
   20301 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'activity', t:2}
   ],
   20500 : [
      {s:'boss_list', t:9, f:[
          {s:'boss_id', t:6},
          {s:'status', t:2},
          {s:'first', t:2}
      ]},
      {s:'ext_list', t:9, f:[
          {s:'ext_id', t:2},
          {s:'status', t:2}
      ]}
   ],
   20501 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20502 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20530 : [
      {s:'can_combat_num', t:2},
      {s:'buy_combat_num', t:2},
      {s:'num_time', t:6}
   ],
   20531 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20532 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20533 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20535 : [
      {s:'boss_list', t:9, f:[
          {s:'boss_id', t:6},
          {s:'rnum', t:4},
          {s:'hp', t:6},
          {s:'hp_max', t:6},
          {s:'ref_time', t:6}
      ]}
   ],
   20536 : [
      {s:'boss_id', t:6},
      {s:'rnum', t:4},
      {s:'hp', t:6},
      {s:'hp_max', t:6},
      {s:'ref_time', t:6}
   ],
   20537 : [
      {s:'boss_id', t:6},
      {s:'role_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'hurt', t:6}
      ]}
   ],
   20538 : [
      {s:'boss_id', t:6},
      {s:'role_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'power', t:6},
          {s:'time', t:6}
      ]}
   ],
   20539 : [
      {s:'boss_id', t:6},
      {s:'hurt', t:6},
      {s:'item_rewards', t:9, f:[
          {s:'bid', t:6},
          {s:'is_bind', t:2},
          {s:'num', t:6},
          {s:'id', t:6}
      ]}
   ],
   20540 : [
      {s:'boss_list', t:9, f:[
          {s:'boss_id', t:6}
      ]}
   ],
   20541 : [
   ],
   20542 : [
      {s:'result', t:2},
      {s:'first_award', t:9, f:[
          {s:'item_id', t:6},
          {s:'num', t:6}
      ]},
      {s:'award', t:9, f:[
          {s:'item_id', t:6},
          {s:'num', t:6}
      ]}
   ],
   20600 : [
      {s:'pass_id', t:2},
      {s:'pass_num', t:2},
      {s:'id', t:2},
      {s:'room', t:2},
      {s:'is_kill_boss', t:2},
      {s:'map_id', t:2},
      {s:'is_all_finish', t:2},
      {s:'start_time', t:6},
      {s:'end_time', t:6}
   ],
   20601 : [
      {s:'buff_list', t:9, f:[
          {s:'bid', t:6},
          {s:'time', t:6}
      ]},
      {s:'holiday_buff_list', t:9, f:[
          {s:'bid', t:6},
          {s:'time', t:6}
      ]}
   ],
   20602 : [
      {s:'room_list', t:9, f:[
          {s:'id', t:2},
          {s:'status', t:2},
          {s:'lock', t:2},
          {s:'evt_id', t:6},
          {s:'res_id', t:2}
      ]}
   ],
   20603 : [
      {s:'room_list', t:9, f:[
          {s:'id', t:2},
          {s:'status', t:2},
          {s:'lock', t:2},
          {s:'evt_id', t:6},
          {s:'res_id', t:2}
      ]}
   ],
   20604 : [
      {s:'id', t:6},
      {s:'partners', t:9, f:[
          {s:'now_hp', t:6},
          {s:'partner_id', t:6},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'skills', t:9, f:[
              {s:'pos', t:2},
              {s:'skill_bid', t:6}
          ]},
          {s:'break_lev', t:2},
          {s:'power', t:6},
          {s:'is_lock', t:9, f:[
              {s:'lock_type', t:6},
              {s:'is_lock', t:2}
          ]},
          {s:'use_skin', t:6},
          {s:'atk', t:6},
          {s:'def_p', t:6},
          {s:'def_s', t:6},
          {s:'hp', t:6},
          {s:'speed', t:6},
          {s:'hit_rate', t:6},
          {s:'dodge_rate', t:6},
          {s:'crit_rate', t:6},
          {s:'crit_ratio', t:6},
          {s:'hit_magic', t:6},
          {s:'dodge_magic', t:6},
          {s:'def', t:6},
          {s:'atk2', t:6},
          {s:'hp2', t:6},
          {s:'def2', t:6},
          {s:'speed2', t:6},
          {s:'eqms', t:9, f:[
              {s:'id', t:6},
              {s:'base_id', t:6},
              {s:'type', t:6}
          ]},
          {s:'artifacts', t:9, f:[
              {s:'artifact_pos', t:2},
              {s:'id', t:6},
              {s:'base_id', t:6},
              {s:'enchant', t:6},
              {s:'attr', t:9, f:[
                  {s:'attr_id', t:6},
                  {s:'attr_val', t:6}
              ]},
              {s:'extra_attr', t:9, f:[
                  {s:'attr_id', t:6},
                  {s:'attr_val', t:6}
              ]},
              {s:'extra', t:9, f:[
                  {s:'extra_k', t:6},
                  {s:'extra_v', t:6}
              ]}
          ]}
      ]}
   ],
   20605 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20606 : [
      {s:'items_list', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'vip_buff', t:6}
   ],
   20607 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20608 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'room_id', t:2}
   ],
   20609 : [
      {s:'skill_list', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6},
          {s:'use_count', t:6}
      ]}
   ],
   20610 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   20611 : [
      {s:'room_list', t:9, f:[
          {s:'id', t:2},
          {s:'evt_id', t:6}
      ]}
   ],
   20612 : [
   ],
   20620 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'room_id', t:2},
      {s:'action', t:2}
   ],
   20621 : [
      {s:'sel_val', t:2},
      {s:'ret_val', t:2},
      {s:'ret', t:2},
      {s:'items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6},
          {s:'move_to', t:2}
      ]}
   ],
   20623 : [
      {s:'ret', t:2},
      {s:'sel_val', t:2},
      {s:'right', t:2},
      {s:'num', t:2},
      {s:'max', t:2},
      {s:'bid', t:6},
      {s:'ret_msg', t:7},
      {s:'now_items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'max_items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'ret_items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6},
          {s:'move_to', t:2}
      ]}
   ],
   20624 : [
      {s:'hp_per', t:2}
   ],
   20625 : [
      {s:'id', t:2},
      {s:'skill_id', t:6}
   ],
   20627 : [
      {s:'evt_id', t:6},
      {s:'id', t:2}
   ],
   20628 : [
      {s:'msg', t:7},
      {s:'items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6},
          {s:'move_to', t:2}
      ]}
   ],
   20630 : [
      {s:'items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6},
          {s:'move_to', t:2}
      ]}
   ],
   20631 : [
      {s:'type', t:2},
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'pay_type', t:2},
          {s:'pay_val', t:6},
          {s:'bid', t:6},
          {s:'num', t:6},
          {s:'is_buy', t:2},
          {s:'discount', t:2}
      ]}
   ],
   20632 : [
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'pay_type', t:2},
          {s:'pay_val', t:6},
          {s:'bid', t:6},
          {s:'num', t:6},
          {s:'is_buy', t:2},
          {s:'discount', t:2}
      ]}
   ],
   20633 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:2}
   ],
   20634 : [
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'status', t:2}
      ]},
      {s:'kill_mon', t:6}
   ],
   20635 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20700 : [
      {s:'num', t:2},
      {s:'time', t:6}
   ],
   20701 : [
      {s:'list', t:9, f:[
          {s:'pos', t:2},
          {s:'num', t:6},
          {s:'status', t:2},
          {s:'look_id', t:6},
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'face_id', t:6},
          {s:'unit_id', t:6}
      ]}
   ],
   20702 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   20703 : [
      {s:'pos', t:2},
      {s:'list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'power', t:6},
          {s:'face_id', t:6},
          {s:'time', t:6},
          {s:'num', t:6},
          {s:'replay_id', t:6},
          {s:'formation_type', t:2},
          {s:'formation_lev', t:2},
          {s:'partner_list', t:9, f:[
              {s:'bid', t:6},
              {s:'lev', t:4},
              {s:'star', t:2}
          ]}
      ]}
   ],
   20705 : [
      {s:'pos', t:2},
      {s:'num1', t:6},
      {s:'num2', t:6},
      {s:'target_role_name', t:7},
      {s:'hurt_statistics', t:9, f:[
          {s:'type', t:2},
          {s:'partner_hurts', t:9, f:[
              {s:'rid', t:6},
              {s:'srvid', t:7},
              {s:'id', t:6},
              {s:'bid', t:6},
              {s:'star', t:6},
              {s:'lev', t:6},
              {s:'camp_type', t:6},
              {s:'dps', t:6},
              {s:'cure', t:6}
          ]}
      ]}
   ],
   21000 : [
      {s:'end_time', t:6},
      {s:'first_gift', t:9, f:[
          {s:'id', t:2},
          {s:'status', t:2}
      ]}
   ],
   21001 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   21002 : [
      {s:'count', t:4}
   ],
   21003 : [
   ],
   21004 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   21005 : [
      {s:'count', t:4},
      {s:'gold', t:6},
      {s:'next_gold', t:6}
   ],
   21006 : [
      {s:'first_gift', t:9, f:[
          {s:'id', t:2},
          {s:'count', t:4}
      ]}
   ],
   21007 : [
      {s:'type', t:2},
      {s:'ref_time', t:6},
      {s:'reg_day', t:6},
      {s:'first_gift', t:9, f:[
          {s:'id', t:6},
          {s:'count', t:4}
      ]}
   ],
   21008 : [
      {s:'status', t:2}
   ],
   21009 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   21010 : [
      {s:'status', t:2},
      {s:'num', t:6}
   ],
   21011 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   21012 : [
      {s:'choosen_status', t:2},
      {s:'has_choosen_id', t:2},
      {s:'first_gift', t:9, f:[
          {s:'id', t:2},
          {s:'status', t:2}
      ]}
   ],
   21013 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   21014 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   21015 : [
      {s:'open_id', t:9, f:[
          {s:'id', t:4}
      ]}
   ],
   21016 : [
      {s:'charge_id', t:6},
      {s:'status', t:2}
   ],
   21020 : [
      {s:'code', t:2}
   ],
   21100 : [
      {s:'status_list', t:9, f:[
          {s:'day', t:2},
          {s:'status', t:2}
      ]}
   ],
   21101 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'day', t:2}
   ],
   21200 : [
      {s:'gifts', t:9, f:[
          {s:'id', t:2},
          {s:'status', t:2},
          {s:'num', t:6}
      ]}
   ],
   21201 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:2}
   ],
   21210 : [
      {s:'gifts', t:9, f:[
          {s:'id', t:6},
          {s:'num', t:4},
          {s:'end_time', t:6}
      ]}
   ],
   21211 : [
      {s:'id', t:6}
   ],
   21220 : [
      {s:'gifts', t:9, f:[
          {s:'id', t:6},
          {s:'num', t:4},
          {s:'end_time', t:6}
      ]}
   ],
   21300 : [
      {s:'fid', t:6},
      {s:'max_id', t:6},
      {s:'count', t:6},
      {s:'buy_count', t:4},
      {s:'info', t:9, f:[
          {s:'boss_id', t:6},
          {s:'hp', t:6}
      ]},
      {s:'combat_info', t:9, f:[
          {s:'boss_id', t:6},
          {s:'dps', t:6}
      ]},
      {s:'buff_lev', t:4},
      {s:'buff_end_time', t:6},
      {s:'ref_time', t:6},
      {s:'worship', t:6},
      {s:'coldtime', t:6}
   ],
   21303 : [
      {s:'box_list', t:9, f:[
          {s:'fid', t:6},
          {s:'num', t:6}
      ]}
   ],
   21304 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'fid', t:6},
      {s:'num', t:6}
   ],
   21305 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   21308 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   21309 : [
      {s:'bossid', t:6},
      {s:'all_dps', t:6},
      {s:'best_partner', t:6},
      {s:'award_list', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'target_role_name', t:7},
      {s:'hurt_statistics', t:9, f:[
          {s:'type', t:2},
          {s:'partner_hurts', t:9, f:[
              {s:'rid', t:6},
              {s:'srvid', t:7},
              {s:'id', t:6},
              {s:'bid', t:6},
              {s:'star', t:6},
              {s:'lev', t:6},
              {s:'camp_type', t:6},
              {s:'dps', t:6},
              {s:'cure', t:6}
          ]}
      ]}
   ],
   21312 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'count', t:4},
      {s:'buy_count', t:4},
      {s:'type', t:2}
   ],
   21317 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'do_count', t:6},
      {s:'all_dps', t:6},
      {s:'best_partner', t:6},
      {s:'award_list', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'target_role_name', t:7},
      {s:'hurt_statistics', t:9, f:[
          {s:'type', t:2},
          {s:'partner_hurts', t:9, f:[
              {s:'rid', t:6},
              {s:'srvid', t:7},
              {s:'id', t:6},
              {s:'bid', t:6},
              {s:'star', t:6},
              {s:'lev', t:6},
              {s:'camp_type', t:6},
              {s:'dps', t:6},
              {s:'cure', t:6}
          ]}
      ]}
   ],
   21318 : [
      {s:'my_name', t:7},
      {s:'my_rank', t:6},
      {s:'my_max_id', t:2},
      {s:'my_dps', t:6},
      {s:'r_rid', t:6},
      {s:'r_srvid', t:7},
      {s:'r_name', t:7},
      {s:'face_id', t:6},
      {s:'lev', t:6},
      {s:'power', t:6},
      {s:'avatar_bid', t:6},
      {s:'rank_guild', t:9, f:[
          {s:'name', t:7},
          {s:'rank', t:2},
          {s:'r_name', t:7},
          {s:'max_id', t:6},
          {s:'day_dps', t:6}
      ]}
   ],
   21319 : [
      {s:'rank', t:6},
      {s:'mydps', t:6},
      {s:'worship', t:6},
      {s:'day_worship', t:6},
      {s:'rank_list', t:9, f:[
          {s:'rank', t:6},
          {s:'r_rid', t:6},
          {s:'r_srvid', t:7},
          {s:'name', t:7},
          {s:'family_name', t:7},
          {s:'all_dps', t:6},
          {s:'face_id', t:6},
          {s:'lev', t:6},
          {s:'power', t:6},
          {s:'avatar_bid', t:6},
          {s:'worship', t:6},
          {s:'worship_status', t:2}
      ]}
   ],
   21320 : [
      {s:'award_list', t:9, f:[
          {s:'fid', t:6},
          {s:'status', t:2}
      ]}
   ],
   21321 : [
      {s:'fid', t:6},
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   21322 : [
      {s:'code', t:2}
   ],
   21323 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'coldtime', t:6}
   ],
   21401 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   21403 : [
      {s:'code', t:2}
   ],
   21409 : [
      {s:'time', t:2}
   ],
   21410 : [
      {s:'type', t:2},
      {s:'role_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'camp', t:2},
          {s:'lev', t:2},
          {s:'status', t:2},
          {s:'effect', t:2},
          {s:'score', t:4},
          {s:'win_acc', t:4},
          {s:'win_best', t:2},
          {s:'pos_x', t:2},
          {s:'pos_y', t:2},
          {s:'skill_effect', t:9, f:[
              {s:'id', t:2}
          ]}
      ]}
   ],
   21411 : [
      {s:'role_move_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'pos_x', t:2},
          {s:'pos_y', t:2}
      ]}
   ],
   21412 : [
      {s:'score_a', t:6},
      {s:'score_b', t:6},
      {s:'group', t:2},
      {s:'zone', t:2}
   ],
   21413 : [
      {s:'type', t:2},
      {s:'guard_list', t:9, f:[
          {s:'id', t:2},
          {s:'camp', t:2},
          {s:'bid', t:6},
          {s:'pos_x', t:2},
          {s:'pos_y', t:2},
          {s:'status', t:2},
          {s:'hp', t:6},
          {s:'max_hp', t:6}
      ]}
   ],
   21415 : [
      {s:'ret', t:2},
      {s:'role_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'camp', t:2},
          {s:'lev', t:2},
          {s:'score', t:4},
          {s:'win_acc', t:4},
          {s:'win_best', t:2}
      ]}
   ],
   21416 : [
      {s:'type', t:2},
      {s:'camp1', t:2},
      {s:'face1', t:6},
      {s:'srv_id1', t:7},
      {s:'name1', t:7},
      {s:'face2', t:6},
      {s:'srv_id2', t:7},
      {s:'name2', t:7}
   ],
   21420 : [
      {s:'skill_list', t:9, f:[
          {s:'id', t:2},
          {s:'cdtime', t:6},
          {s:'num', t:2}
      ]}
   ],
   21421 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   21425 : [
      {s:'group', t:2},
      {s:'cnum', t:2},
      {s:'win', t:2}
   ],
   21426 : [
      {s:'cnum_list', t:9, f:[
          {s:'num', t:2}
      ]},
      {s:'win_list', t:9, f:[
          {s:'num', t:2}
      ]}
   ],
   21427 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'type', t:2},
      {s:'num', t:2}
   ],
   21500 : [
      {s:'avatar_frame', t:9, f:[
          {s:'base_id', t:6},
          {s:'expire_time', t:6}
      ]}
   ],
   21501 : [
      {s:'base_id', t:6}
   ],
   21502 : [
      {s:'avatar_frame', t:9, f:[
          {s:'base_id', t:6},
          {s:'expire_time', t:6}
      ]}
   ],
   21503 : [
      {s:'avatar_frame', t:9, f:[
          {s:'base_id', t:6},
          {s:'expire_time', t:6}
      ]}
   ],
   21504 : [
      {s:'attr', t:9, f:[
          {s:'key', t:2},
          {s:'val', t:6}
      ]}
   ],
   22100 : [
      {s:'step', t:2},
      {s:'servers', t:9, f:[
          {s:'srv_id', t:7},
          {s:'srv_name', t:7},
          {s:'process_val', t:6}
      ]},
      {s:'step_reward', t:9, f:[
          {s:'step', t:2},
          {s:'status', t:2}
      ]}
   ],
   22101 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'step', t:2}
   ],
   22200 : [
      {s:'list', t:9, f:[
          {s:'id', t:2},
          {s:'lev', t:2},
          {s:'exp', t:6},
          {s:'step', t:2},
          {s:'all_attr', t:9, f:[
              {s:'name', t:2},
              {s:'val', t:6}
          ]}
      ]}
   ],
   22201 : [
      {s:'id', t:2},
      {s:'lev', t:2},
      {s:'exp', t:6},
      {s:'step', t:2},
      {s:'all_attr', t:9, f:[
          {s:'name', t:2},
          {s:'val', t:6}
      ]}
   ],
   22202 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:2}
   ],
   22203 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:2}
   ],
   22204 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:2}
   ],
   22205 : [
      {s:'id', t:2}
   ],
   22700 : [
      {s:'is_cluster', t:2},
      {s:'rank_list', t:9, f:[
          {s:'id', t:2},
          {s:'end_time', t:6}
      ]}
   ],
   22701 : [
      {s:'id', t:2},
      {s:'end_time', t:6},
      {s:'rank', t:2},
      {s:'rank_list', t:9, f:[
          {s:'idx', t:2},
          {s:'name', t:7},
          {s:'lev', t:2},
          {s:'face_id', t:6},
          {s:'avatar_id', t:6},
          {s:'rid', t:6},
          {s:'srv_id', t:7}
      ]}
   ],
   22702 : [
      {s:'feat_list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'end_time', t:6},
          {s:'finish_time', t:6},
          {s:'progress', t:9, f:[
              {s:'id', t:4},
              {s:'finish', t:2},
              {s:'target', t:6},
              {s:'target_val', t:6},
              {s:'value', t:6}
          ]}
      ]}
   ],
   22703 : [
      {s:'feat_list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'end_time', t:6},
          {s:'finish_time', t:6},
          {s:'progress', t:9, f:[
              {s:'id', t:4},
              {s:'finish', t:2},
              {s:'target', t:6},
              {s:'target_val', t:6},
              {s:'value', t:6}
          ]}
      ]}
   ],
   22704 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'quest_id', t:6}
   ],
   23200 : [
      {s:'recruit_list', t:9, f:[
          {s:'group_id', t:4},
          {s:'draw_list', t:9, f:[
              {s:'times', t:2},
              {s:'kv_list', t:9, f:[
                  {s:'key', t:6},
                  {s:'val', t:6},
                  {s:'str_val', t:7}
              ]}
          ]}
      ]},
      {s:'is_share', t:2},
      {s:'is_day_share', t:2}
   ],
   23201 : [
      {s:'group_id', t:4},
      {s:'times', t:2},
      {s:'flag', t:6},
      {s:'rewards', t:9, f:[
          {s:'base_id', t:6},
          {s:'num', t:6}
      ]},
      {s:'partner_bids', t:9, f:[
          {s:'partner_bid', t:6},
          {s:'init_star', t:2}
      ]},
      {s:'partner_chips', t:9, f:[
          {s:'partner_bid', t:6},
          {s:'chip_bid', t:6},
          {s:'chip_num', t:6}
      ]}
   ],
   23202 : [
      {s:'group_id', t:4},
      {s:'free_cd_end', t:6},
      {s:'free_times', t:2}
   ],
   23203 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'is_share', t:2},
      {s:'is_day_share', t:2}
   ],
   23204 : [
      {s:'recruit_group', t:9, f:[
          {s:'group_id', t:4},
          {s:'draw_list', t:9, f:[
              {s:'times', t:2},
              {s:'kv_list', t:9, f:[
                  {s:'key', t:6},
                  {s:'val', t:6},
                  {s:'str_val', t:7}
              ]}
          ]}
      ]}
   ],
   23205 : [
      {s:'need_times', t:2}
   ],
   23210 : [
      {s:'fals', t:2},
      {s:'end_time', t:6},
      {s:'rewards', t:9, f:[
          {s:'id', t:6},
          {s:'num', t:6},
          {s:'status', t:2}
      ]}
   ],
   23211 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   23212 : [
   ],
   23213 : [
      {s:'group_id', t:4},
      {s:'rewards', t:9, f:[
          {s:'base_id', t:6},
          {s:'num', t:6}
      ]}
   ],
   23214 : [
      {s:'partner_id', t:6},
      {s:'new_partner_bid', t:6},
      {s:'partner_ids', t:9, f:[
          {s:'id', t:6}
      ]}
   ],
   23215 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   23216 : [
      {s:'camp_id', t:6},
      {s:'free_time', t:6},
      {s:'times', t:6},
      {s:'start_time', t:6},
      {s:'end_time', t:6},
      {s:'item_id', t:6},
      {s:'item_num', t:6},
      {s:'must_count', t:4},
      {s:'reward_list', t:9, f:[
          {s:'id', t:4}
      ]}
   ],
   23217 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   23218 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   23219 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   23220 : [
      {s:'camp_id', t:6},
      {s:'free_time', t:6},
      {s:'times', t:6},
      {s:'start_time', t:6},
      {s:'end_time', t:6},
      {s:'item_id', t:6},
      {s:'item_num', t:6},
      {s:'must_count', t:4},
      {s:'reward_list', t:9, f:[
          {s:'id', t:4}
      ]}
   ],
   23221 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   23222 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   23300 : [
      {s:'base_id', t:6},
      {s:'honor', t:9, f:[
          {s:'base_id', t:6},
          {s:'expire_time', t:6}
      ]}
   ],
   23301 : [
      {s:'base_id', t:6}
   ],
   23302 : [
      {s:'honor', t:9, f:[
          {s:'base_id', t:6},
          {s:'expire_time', t:6}
      ]}
   ],
   23303 : [
      {s:'honor', t:9, f:[
          {s:'base_id', t:6},
          {s:'expire_time', t:6}
      ]}
   ],
   23400 : [
      {s:'gifts', t:9, f:[
          {s:'id', t:2},
          {s:'status', t:2}
      ]}
   ],
   23402 : [
      {s:'code', t:2}
   ],
   23403 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:2}
   ],
   23500 : [
      {s:'catalg', t:6},
      {s:'goods', t:9, f:[
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'cur_price', t:6},
          {s:'margin', t:6}
      ]}
   ],
   23501 : [
      {s:'flag', t:2}
   ],
   23502 : [
      {s:'flag', t:2}
   ],
   23504 : [
   ],
   23505 : [
      {s:'type', t:2},
      {s:'id', t:2},
      {s:'status', t:2},
      {s:'num', t:2}
   ],
   23506 : [
      {s:'cell_id', t:2},
      {s:'flag', t:2}
   ],
   23507 : [
      {s:'free_ids', t:9, f:[
          {s:'cell_id', t:2}
      ]},
      {s:'cells', t:9, f:[
          {s:'cell_id', t:2},
          {s:'item_base_id', t:6},
          {s:'num', t:2},
          {s:'price', t:6},
          {s:'expiry', t:6},
          {s:'item_attrs', t:9, f:[
              {s:'attr', t:2},
              {s:'value', t:6}
          ]},
          {s:'status', t:2}
      ]}
   ],
   23508 : [
      {s:'item_base_id', t:6},
      {s:'price', t:6}
   ],
   23509 : [
      {s:'refresh_time', t:6},
      {s:'data', t:9, f:[
          {s:'type', t:2},
          {s:'goods', t:9, f:[
              {s:'id', t:2},
              {s:'item_base_id', t:6},
              {s:'num', t:2},
              {s:'price', t:6},
              {s:'status', t:2},
              {s:'item_attrs', t:9, f:[
                  {s:'attr', t:2},
                  {s:'value', t:6}
              ]}
          ]}
      ]}
   ],
   23511 : [
      {s:'cell_id', t:2},
      {s:'flag', t:2}
   ],
   23512 : [
      {s:'cell_id', t:2},
      {s:'flag', t:2}
   ],
   23513 : [
   ],
   23514 : [
   ],
   23516 : [
      {s:'market_price', t:9, f:[
          {s:'source', t:2},
          {s:'base_id', t:6},
          {s:'assets', t:6},
          {s:'price', t:6}
      ]}
   ],
   23518 : [
      {s:'goods', t:9, f:[
          {s:'id', t:6},
          {s:'base_id', t:6},
          {s:'cur_price', t:6},
          {s:'margin', t:6}
      ]}
   ],
   23519 : [
   ],
   23520 : [
      {s:'limit_data', t:9, f:[
          {s:'item_id', t:6},
          {s:'count', t:6}
      ]}
   ],
   23601 : [
      {s:'reward', t:2},
      {s:'process', t:6},
      {s:'double', t:2},
      {s:'count', t:6}
   ],
   23602 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   23603 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   23604 : [
      {s:'ext_reward', t:9, f:[
          {s:'type', t:2},
          {s:'rate', t:6}
      ]}
   ],
   23606 : [
      {s:'ref_time', t:6},
      {s:'camp_type', t:2},
      {s:'list', t:9, f:[
          {s:'id', t:2},
          {s:'price', t:4},
          {s:'gain', t:6},
          {s:'num', t:2},
          {s:'max', t:2}
      ]}
   ],
   23607 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:2}
   ],
   23700 : [
      {s:'career', t:2},
      {s:'group_id', t:6},
      {s:'skill_ids', t:9, f:[
          {s:'skill_id', t:6}
      ]},
      {s:'group_ids', t:9, f:[
          {s:'group_id', t:6}
      ]}
   ],
   23701 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'career', t:2},
      {s:'skill_id', t:6}
   ],
   23702 : [
      {s:'career', t:2},
      {s:'group_id', t:6}
   ],
   23703 : [
      {s:'outline', t:9, f:[
          {s:'career', t:2},
          {s:'skill_id', t:6}
      ]}
   ],
   23800 : [
      {s:'order_list', t:9, f:[
          {s:'order_id', t:6},
          {s:'order_bid', t:6},
          {s:'status', t:2},
          {s:'end_time', t:6},
          {s:'assign_ids', t:9, f:[
              {s:'partner_id', t:6}
          ]}
      ]},
      {s:'free_times', t:2},
      {s:'coin_times', t:6}
   ],
   23801 : [
      {s:'order_id', t:6},
      {s:'order_bid', t:6},
      {s:'status', t:2},
      {s:'end_time', t:6},
      {s:'assign_ids', t:9, f:[
          {s:'partner_id', t:6}
      ]}
   ],
   23802 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   23803 : [
      {s:'flag', t:2},
      {s:'msg', t:7},
      {s:'order_id', t:6}
   ],
   23804 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   23805 : [
      {s:'flag', t:2}
   ],
   23820 : [
   ],
   23821 : [
      {s:'flag', t:2}
   ],
   23900 : [
      {s:'max_round', t:4},
      {s:'current_round', t:4},
      {s:'day_pass_round', t:4},
      {s:'my_idx', t:4},
      {s:'rank_list', t:9, f:[
          {s:'idx', t:2},
          {s:'name', t:7},
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'val', t:6}
      ]},
      {s:'is_employ', t:2},
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'quality', t:2},
          {s:'power', t:6},
          {s:'ext_data', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:6}
          ]}
      ]},
      {s:'is_appoint', t:2},
      {s:'is_reward', t:2}
   ],
   23901 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   23902 : [
      {s:'round', t:4},
      {s:'max_round', t:4},
      {s:'buff_list', t:9, f:[
          {s:'id', t:6},
          {s:'group_id', t:4},
          {s:'count', t:4}
      ]},
      {s:'rest_round', t:4},
      {s:'max_reward_round', t:4},
      {s:'reward_flag', t:2},
      {s:'acc_reward', t:9, f:[
          {s:'base_id', t:6},
          {s:'num', t:6}
      ]},
      {s:'id', t:6},
      {s:'status', t:2}
   ],
   23903 : [
      {s:'id', t:6},
      {s:'status', t:2}
   ],
   23904 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   23905 : [
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'quality', t:2},
          {s:'power', t:6},
          {s:'ext_data', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:6}
          ]}
      ]}
   ],
   23906 : [
      {s:'list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'id', t:6},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'quality', t:2},
          {s:'power', t:6},
          {s:'ext_data', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:6}
          ]}
      ]}
   ],
   23907 : [
      {s:'list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'id', t:6},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'quality', t:2},
          {s:'power', t:6},
          {s:'ext_data', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:6}
          ]}
      ]}
   ],
   23908 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   23909 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   23910 : [
      {s:'is_select', t:2},
      {s:'list', t:9, f:[
          {s:'group_id', t:2},
          {s:'buff_id', t:4}
      ]},
      {s:'partner', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'pos', t:2},
          {s:'id', t:6},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'quality', t:2},
          {s:'hp_per', t:2},
          {s:'use_skin', t:6}
      ]},
      {s:'formation_type', t:2},
      {s:'formation_lev', t:2},
      {s:'round', t:4},
      {s:'end_time', t:6}
   ],
   23911 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24000 : [
      {s:'plunders', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'gid', t:6},
          {s:'gsrv_id', t:7},
          {s:'name', t:7},
          {s:'gname', t:7},
          {s:'quality', t:2},
          {s:'end_time', t:6},
          {s:'plunder_lists', t:9, f:[
              {s:'rid', t:6},
              {s:'srv_id', t:7}
          ]}
      ]}
   ],
   24001 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   24002 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   24003 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   24004 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   24005 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'plunders', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'gid', t:6},
          {s:'gsrv_id', t:7},
          {s:'name', t:7},
          {s:'gname', t:7},
          {s:'quality', t:2},
          {s:'end_time', t:6}
      ]}
   ],
   24006 : [
      {s:'status', t:2},
      {s:'quality', t:2},
      {s:'end_time', t:6},
      {s:'plunder_count', t:6},
      {s:'datas', t:9, f:[
          {s:'id', t:2},
          {s:'val', t:2}
      ]}
   ],
   24010 : [
      {s:'quality', t:2},
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'gid', t:6},
      {s:'gsrv_id', t:7},
      {s:'name', t:7},
      {s:'lev', t:4},
      {s:'face', t:6},
      {s:'power', t:6},
      {s:'guild_name', t:7},
      {s:'formation_type', t:2},
      {s:'formation_lev', t:2},
      {s:'p_list', t:9, f:[
          {s:'pos', t:2},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'quality', t:2},
          {s:'star', t:2},
          {s:'break_lev', t:2}
      ]}
   ],
   24011 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   24012 : [
      {s:'result', t:2},
      {s:'item_rewards', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   24013 : [
      {s:'type', t:2},
      {s:'logs', t:9, f:[
          {s:'id', t:6},
          {s:'quality', t:2},
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'guild_name', t:7},
          {s:'lev', t:4},
          {s:'sex', t:2},
          {s:'face', t:6},
          {s:'power', t:6},
          {s:'avatar_id', t:6},
          {s:'ret', t:2},
          {s:'atk_ret', t:2},
          {s:'atk_count', t:2},
          {s:'time', t:6},
          {s:'help_count', t:6},
          {s:'help_time', t:6},
          {s:'items', t:9, f:[
              {s:'bid', t:6},
              {s:'num', t:6}
          ]},
          {s:'replay_id', t:6}
      ]}
   ],
   24014 : [
      {s:'quality', t:2},
      {s:'id', t:6},
      {s:'type', t:2},
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'lev', t:4},
      {s:'face', t:6},
      {s:'avatar_id', t:6},
      {s:'power', t:6},
      {s:'guild_name', t:7},
      {s:'formation_type', t:2},
      {s:'formation_lev', t:2},
      {s:'p_list', t:9, f:[
          {s:'pos', t:2},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'quality', t:2},
          {s:'star', t:2},
          {s:'break_lev', t:2}
      ]}
   ],
   24015 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   24017 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24018 : [
      {s:'id', t:6},
      {s:'quality', t:2},
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'guild_name', t:7},
      {s:'lev', t:4},
      {s:'sex', t:2},
      {s:'face', t:6},
      {s:'power', t:6},
      {s:'avatar_id', t:6},
      {s:'ret', t:2},
      {s:'atk_ret', t:2},
      {s:'atk_count', t:2},
      {s:'time', t:6},
      {s:'help_count', t:6},
      {s:'help_time', t:6},
      {s:'items', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'replay_id', t:6}
   ],
   24019 : [
      {s:'plunders', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'gid', t:6},
          {s:'gsrv_id', t:7},
          {s:'name', t:7},
          {s:'gname', t:7},
          {s:'quality', t:2},
          {s:'end_time', t:6}
      ]}
   ],
   24020 : [
      {s:'code', t:2}
   ],
   24100 : [
      {s:'hallows', t:9, f:[
          {s:'id', t:6},
          {s:'step', t:6},
          {s:'lucky', t:6},
          {s:'lucky_endtime', t:6},
          {s:'seal', t:6},
          {s:'add_attr', t:9, f:[
              {s:'attr_id', t:6},
              {s:'attr_val', t:6}
          ]},
          {s:'skill', t:9, f:[
              {s:'lev', t:6},
              {s:'skill_bid', t:6}
          ]},
          {s:'look_id', t:6}
      ]}
   ],
   24101 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   24103 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'hallows_id', t:6}
   ],
   24104 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   24107 : [
      {s:'id', t:6},
      {s:'step', t:6},
      {s:'lucky', t:6},
      {s:'lucky_endtime', t:6},
      {s:'seal', t:6},
      {s:'add_attr', t:9, f:[
          {s:'attr_id', t:6},
          {s:'attr_val', t:6}
      ]},
      {s:'skill', t:9, f:[
          {s:'lev', t:6},
          {s:'skill_bid', t:6}
      ]},
      {s:'look_id', t:6}
   ],
   24108 : [
      {s:'id', t:6},
      {s:'step', t:6},
      {s:'lucky', t:6},
      {s:'lucky_endtime', t:6},
      {s:'seal', t:6},
      {s:'add_attr', t:9, f:[
          {s:'attr_id', t:6},
          {s:'attr_val', t:6}
      ]},
      {s:'skill', t:9, f:[
          {s:'lev', t:6},
          {s:'skill_bid', t:6}
      ]},
      {s:'look_id', t:6}
   ],
   24120 : [
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'target_val', t:6},
          {s:'value', t:6}
      ]}
   ],
   24121 : [
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'target_val', t:6},
          {s:'value', t:6}
      ]}
   ],
   24122 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24123 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24124 : [
      {s:'is_first', t:2}
   ],
   24125 : [
      {s:'hallows_looks', t:9, f:[
          {s:'id', t:6},
          {s:'endtime', t:6},
          {s:'eqm_hallows', t:6}
      ]}
   ],
   24126 : [
      {s:'id', t:6},
      {s:'endtime', t:6},
      {s:'eqm_hallows', t:6}
   ],
   24127 : [
      {s:'id', t:6},
      {s:'endtime', t:6},
      {s:'eqm_hallows', t:6}
   ],
   24128 : [
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'target_val', t:6},
          {s:'value', t:6}
      ]}
   ],
   24129 : [
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'target_val', t:6},
          {s:'value', t:6}
      ]}
   ],
   24130 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24131 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24132 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24133 : [
      {s:'id', t:6}
   ],
   24200 : [
      {s:'count', t:6},
      {s:'result', t:2},
      {s:'ranks', t:9, f:[
          {s:'rank', t:6},
          {s:'name', t:7}
      ]},
      {s:'gname1', t:7},
      {s:'hp1', t:4},
      {s:'buff_lev1', t:4},
      {s:'gname2', t:7},
      {s:'g_id', t:6},
      {s:'g_sid', t:7},
      {s:'hp2', t:4},
      {s:'defense', t:9, f:[
          {s:'pos', t:2},
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'face', t:6},
          {s:'power', t:6},
          {s:'hp', t:4},
          {s:'hp_max', t:4},
          {s:'relic_def_count', t:4},
          {s:'status', t:2}
      ]}
   ],
   24201 : [
      {s:'pos', t:6},
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'lev', t:4},
      {s:'face', t:6},
      {s:'power', t:6},
      {s:'formation_type', t:4},
      {s:'formation_lev', t:4},
      {s:'hp', t:4},
      {s:'hp_max', t:4},
      {s:'def_count', t:4},
      {s:'relic_def_count', t:4},
      {s:'defense', t:9, f:[
          {s:'pos', t:2},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2}
      ]}
   ],
   24202 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'count', t:6}
   ],
   24203 : [
      {s:'result', t:2},
      {s:'timer', t:6},
      {s:'item_rewards', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   24204 : [
      {s:'status', t:2},
      {s:'flag', t:2},
      {s:'start_time', t:6},
      {s:'end_time', t:6}
   ],
   24205 : [
      {s:'match_info', t:9, f:[
          {s:'g_id1', t:6},
          {s:'g_sid1', t:7},
          {s:'srv_name1', t:7},
          {s:'guild_name1', t:7},
          {s:'rank1', t:6},
          {s:'g_id2', t:6},
          {s:'g_sid2', t:7},
          {s:'srv_name2', t:7},
          {s:'guild_name2', t:7},
          {s:'rank2', t:6},
          {s:'status', t:2},
          {s:'g_id', t:6},
          {s:'g_sid', t:7}
      ]}
   ],
   24206 : [
      {s:'flag', t:2},
      {s:'defense', t:9, f:[
          {s:'pos', t:2},
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'face', t:6},
          {s:'power', t:6},
          {s:'hp', t:4},
          {s:'hp_max', t:4},
          {s:'relic_def_count', t:4},
          {s:'status', t:2}
      ]}
   ],
   24207 : [
      {s:'ranks', t:9, f:[
          {s:'rank', t:6},
          {s:'name', t:7}
      ]},
      {s:'hp', t:4},
      {s:'buff_lev', t:4},
      {s:'hp2', t:4}
   ],
   24208 : [
      {s:'hp', t:4},
      {s:'defense', t:9, f:[
          {s:'pos', t:2},
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'face', t:6},
          {s:'power', t:6},
          {s:'hp', t:4},
          {s:'hp_max', t:4},
          {s:'relic_def_count', t:4},
          {s:'status', t:2}
      ]}
   ],
   24209 : [
      {s:'power', t:6},
      {s:'formation_type', t:6},
      {s:'formation_lev', t:6},
      {s:'defense', t:9, f:[
          {s:'pos', t:2},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2}
      ]},
      {s:'guild_war_role_log', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'face', t:6},
          {s:'power', t:6},
          {s:'time', t:6},
          {s:'repaly_id', t:6},
          {s:'hp', t:4},
          {s:'result', t:2},
          {s:'formation_type', t:6},
          {s:'formation_lev', t:6},
          {s:'defense', t:9, f:[
              {s:'pos', t:2},
              {s:'bid', t:6},
              {s:'lev', t:4},
              {s:'star', t:2}
          ]}
      ]}
   ],
   24210 : [
   ],
   24212 : [
      {s:'guild_war_log', t:9, f:[
          {s:'flag1', t:2},
          {s:'flag2', t:2},
          {s:'time', t:6},
          {s:'rid1', t:6},
          {s:'srv_id1', t:7},
          {s:'name1', t:7},
          {s:'rid2', t:6},
          {s:'srv_id2', t:7},
          {s:'name2', t:7},
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'gname', t:7},
          {s:'int_args', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:6}
          ]},
          {s:'str_args', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:7}
          ]}
      ]}
   ],
   24213 : [
      {s:'ranks', t:9, f:[
          {s:'rank', t:6},
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'face', t:6},
          {s:'lev', t:6},
          {s:'name', t:7},
          {s:'star', t:6},
          {s:'war_score', t:6}
      ]}
   ],
   24214 : [
      {s:'result', t:2}
   ],
   24220 : [
      {s:'result', t:2},
      {s:'end_time', t:6},
      {s:'status', t:2},
      {s:'guild_war_box', t:9, f:[
          {s:'order', t:4},
          {s:'rid', t:6},
          {s:'sid', t:7},
          {s:'name', t:7},
          {s:'item_id', t:6},
          {s:'item_num', t:6}
      ]}
   ],
   24221 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   24223 : [
      {s:'order', t:4},
      {s:'rid', t:6},
      {s:'sid', t:7},
      {s:'name', t:7},
      {s:'item_id', t:6},
      {s:'item_num', t:6}
   ],
   24300 : [
      {s:'rank', t:4},
      {s:'best_rank', t:4},
      {s:'can_combat_num', t:2},
      {s:'buy_combat_num', t:2},
      {s:'ref_time', t:5},
      {s:'combat_time', t:5}
   ],
   24301 : [
      {s:'f_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'idx', t:2},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'sex', t:2},
          {s:'face', t:6},
          {s:'power', t:6},
          {s:'rank', t:6},
          {s:'look', t:6}
      ]},
      {s:'type', t:2}
   ],
   24302 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'lev', t:4},
      {s:'vip_lev', t:2},
      {s:'face', t:6},
      {s:'sex', t:2},
      {s:'power', t:6},
      {s:'rank', t:6},
      {s:'gname', t:7},
      {s:'avatar_id', t:6},
      {s:'formation_type', t:2},
      {s:'formation_lev', t:2},
      {s:'p_list', t:9, f:[
          {s:'pos', t:2},
          {s:'id', t:6},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'quality', t:2},
          {s:'star', t:2},
          {s:'is_robot', t:2}
      ]}
   ],
   24303 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24304 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24305 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24306 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24307 : [
      {s:'result', t:2},
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'def_name', t:7},
      {s:'def_lev', t:6},
      {s:'def_face', t:6},
      {s:'def_change_rank', t:5},
      {s:'def_rank', t:6},
      {s:'is_change_best_rank', t:6},
      {s:'atk_change_rank', t:5},
      {s:'atk_rank', t:6},
      {s:'reward', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'target_role_name', t:7},
      {s:'hurt_statistics', t:9, f:[
          {s:'type', t:2},
          {s:'partner_hurts', t:9, f:[
              {s:'rid', t:6},
              {s:'srvid', t:7},
              {s:'id', t:6},
              {s:'bid', t:6},
              {s:'star', t:6},
              {s:'lev', t:6},
              {s:'camp_type', t:6},
              {s:'dps', t:6},
              {s:'cure', t:6}
          ]}
      ]}
   ],
   24308 : [
      {s:'rank_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'gname', t:7},
          {s:'rank', t:6},
          {s:'lookid', t:6},
          {s:'worship', t:6},
          {s:'worship_status', t:2}
      ]}
   ],
   24309 : [
      {s:'rank', t:4},
      {s:'best_rank', t:4},
      {s:'rank_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'gname', t:7},
          {s:'lev', t:4},
          {s:'face', t:6},
          {s:'sex', t:2},
          {s:'rank', t:4},
          {s:'power', t:6},
          {s:'avatar_id', t:6}
      ]}
   ],
   24310 : [
      {s:'replay_srv_id', t:7},
      {s:'log_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'sex', t:2},
          {s:'face', t:6},
          {s:'avatar_id', t:6},
          {s:'power', t:6},
          {s:'type', t:2},
          {s:'ret', t:2},
          {s:'rank_type', t:2},
          {s:'rank', t:6},
          {s:'replay_id', t:6},
          {s:'time', t:6}
      ]}
   ],
   24311 : [
      {s:'replay_srv_id', t:7},
      {s:'log_list', t:9, f:[
          {s:'atk_rid', t:6},
          {s:'atk_srv_id', t:7},
          {s:'atk_name', t:7},
          {s:'atk_face', t:6},
          {s:'atk_rank', t:6},
          {s:'def_rid', t:6},
          {s:'def_srv_id', t:7},
          {s:'def_name', t:7},
          {s:'def_face', t:6},
          {s:'def_rank', t:6},
          {s:'ret', t:2},
          {s:'replay_id', t:6},
          {s:'time', t:6}
      ]}
   ],
   24312 : [
      {s:'code', t:2}
   ],
   24313 : [
      {s:'code', t:2}
   ],
   24314 : [
      {s:'code', t:2}
   ],
   24315 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24316 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24400 : [
      {s:'guard_id', t:6},
      {s:'reward', t:9, f:[
          {s:'reward_id', t:6}
      ]},
      {s:'rewards', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]}
   ],
   24401 : [
      {s:'id', t:2},
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'name', t:7},
      {s:'face', t:6},
      {s:'lev', t:2},
      {s:'power', t:6},
      {s:'guards', t:9, f:[
          {s:'pos', t:2},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'hp_per', t:2},
          {s:'ext_data', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:6}
          ]}
      ]},
      {s:'rewards', t:9, f:[
          {s:'bid', t:6},
          {s:'num', t:6}
      ]},
      {s:'is_holiday', t:2},
      {s:'status', t:2}
   ],
   24402 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:2}
   ],
   24403 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24404 : [
      {s:'list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'id', t:6},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'power', t:6},
          {s:'ext_data', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:6}
          ]}
      ]}
   ],
   24405 : [
      {s:'list', t:9, f:[
          {s:'id', t:6}
      ]}
   ],
   24406 : [
      {s:'list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'id', t:6},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'power', t:6},
          {s:'is_employ', t:2},
          {s:'ext_data', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:6}
          ]}
      ]}
   ],
   24407 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   24408 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24409 : [
      {s:'list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'id', t:6},
          {s:'bid', t:6},
          {s:'lev', t:4},
          {s:'star', t:2},
          {s:'power', t:6},
          {s:'is_used', t:2},
          {s:'hp_per', t:2},
          {s:'ext_data', t:9, f:[
              {s:'key', t:6},
              {s:'val', t:6}
          ]}
      ]},
      {s:'p_list', t:9, f:[
          {s:'id', t:6},
          {s:'hp_per', t:2}
      ]}
   ],
   24410 : [
      {s:'is_show', t:2}
   ],
   24411 : [
      {s:'is_show', t:2}
   ],
   24500 : [
      {s:'list', t:9, f:[
          {s:'id', t:2},
          {s:'status', t:2},
          {s:'expire_time', t:6}
      ]}
   ],
   24501 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24502 : [
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'status', t:2},
          {s:'expire_time', t:6}
      ]}
   ],
   24600 : [
      {s:'status', t:2},
      {s:'start_time', t:6},
      {s:'end_time', t:6},
      {s:'flag', t:2}
   ],
   24601 : [
      {s:'id', t:6},
      {s:'title', t:7},
      {s:'memo', t:7},
      {s:'rewards', t:9, f:[
          {s:'bid', t:6},
          {s:'bind', t:2},
          {s:'num', t:6}
      ]}
   ],
   24602 : [
      {s:'questionnaire_list', t:9, f:[
          {s:'id', t:6},
          {s:'title', t:7},
          {s:'sort', t:4},
          {s:'topic_type', t:2},
          {s:'specific_type', t:2},
          {s:'must', t:2},
          {s:'jump', t:2},
          {s:'topic', t:6},
          {s:'option', t:7},
          {s:'option_list', t:7}
      ]}
   ],
   24603 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24604 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24700 : [
      {s:'ids', t:9, f:[
          {s:'id', t:6},
          {s:'status', t:2}
      ]}
   ],
   24701 : [
      {s:'id', t:6},
      {s:'current_day', t:4},
      {s:'group_id', t:4},
      {s:'endtime', t:6},
      {s:'status', t:2}
   ],
   24702 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   24801 : [
      {s:'all_num', t:6},
      {s:'award_list', t:9, f:[
          {s:'id', t:2},
          {s:'flag', t:2}
      ]}
   ],
   24802 : [
      {s:'flag', t:2},
      {s:'msg', t:7},
      {s:'count', t:6},
      {s:'rand_list', t:9, f:[
          {s:'rand_id', t:6},
          {s:'status', t:2}
      ]}
   ],
   24803 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   24804 : [
      {s:'lev', t:6},
      {s:'exp', t:6},
      {s:'camp_id', t:6},
      {s:'group_id', t:6},
      {s:'combat_num', t:4},
      {s:'start_time', t:6},
      {s:'end_time', t:6},
      {s:'show_list', t:9, f:[
          {s:'show_id', t:2},
          {s:'num', t:6}
      ]},
      {s:'make_list', t:9, f:[
          {s:'id', t:6},
          {s:'num', t:6}
      ]}
   ],
   24805 : [
      {s:'lev', t:6},
      {s:'reward_list', t:9, f:[
          {s:'id', t:4}
      ]}
   ],
   24806 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   24807 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   24808 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   24809 : [
      {s:'flag', t:2},
      {s:'msg', t:7},
      {s:'combat_num', t:4}
   ],
   24810 : [
      {s:'quest_list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'end_time', t:6},
          {s:'finish_time', t:6},
          {s:'progress', t:9, f:[
              {s:'id', t:4},
              {s:'finish', t:2},
              {s:'target', t:6},
              {s:'target_val', t:6},
              {s:'value', t:6}
          ]}
      ]},
      {s:'camp_id', t:6}
   ],
   24811 : [
      {s:'id', t:6},
      {s:'finish', t:2},
      {s:'end_time', t:6},
      {s:'finish_time', t:6},
      {s:'progress', t:9, f:[
          {s:'id', t:4},
          {s:'finish', t:2},
          {s:'target', t:6},
          {s:'target_val', t:6},
          {s:'value', t:6}
      ]}
   ],
   24812 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   24813 : [
      {s:'quest_list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'end_time', t:6},
          {s:'finish_time', t:6},
          {s:'progress', t:9, f:[
              {s:'id', t:4},
              {s:'finish', t:2},
              {s:'target', t:6},
              {s:'target_val', t:6},
              {s:'value', t:6}
          ]}
      ]},
      {s:'camp_id', t:6}
   ],
   24814 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   24815 : [
      {s:'quest_list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'end_time', t:6},
          {s:'finish_time', t:6},
          {s:'progress', t:9, f:[
              {s:'id', t:4},
              {s:'finish', t:2},
              {s:'target', t:6},
              {s:'target_val', t:6},
              {s:'value', t:6}
          ]}
      ]},
      {s:'camp_id', t:6}
   ],
   24816 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   24817 : [
      {s:'quest_list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'end_time', t:6},
          {s:'finish_time', t:6},
          {s:'progress', t:9, f:[
              {s:'id', t:4},
              {s:'finish', t:2},
              {s:'target', t:6},
              {s:'target_val', t:6},
              {s:'value', t:6}
          ]}
      ]},
      {s:'camp_id', t:6}
   ],
   24818 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6}
   ],
   25100 : [
      {s:'state', t:2},
      {s:'quests', t:9, f:[
          {s:'id', t:6},
          {s:'val', t:6},
          {s:'status', t:2}
      ]},
      {s:'end_time', t:6}
   ],
   25101 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   25102 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   25300 : [
      {s:'period', t:2},
      {s:'cur_day', t:6},
      {s:'end_time', t:6},
      {s:'lev', t:6},
      {s:'exp', t:6},
      {s:'rmb_status', t:2},
      {s:'exp_status', t:2},
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'type', t:2},
          {s:'finish', t:2},
          {s:'target_val', t:6},
          {s:'value', t:6},
          {s:'end_time', t:6}
      ]}
   ],
   25301 : [
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'type', t:2},
          {s:'finish', t:2},
          {s:'target_val', t:6},
          {s:'value', t:6},
          {s:'end_time', t:6}
      ]}
   ],
   25302 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   25303 : [
      {s:'lev', t:6},
      {s:'reward_list', t:9, f:[
          {s:'id', t:4},
          {s:'status', t:2},
          {s:'rmb_status', t:2}
      ]}
   ],
   25304 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   25305 : [
      {s:'lev', t:6},
      {s:'exp', t:6}
   ],
   25306 : [
      {s:'rmb_status', t:2},
      {s:'exp_status', t:2},
      {s:'list', t:9, f:[
          {s:'id', t:6},
          {s:'status', t:2}
      ]}
   ],
   25307 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   25308 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   25309 : [
      {s:'is_pop', t:2},
      {s:'cur_day', t:6}
   ],
   25400 : [
      {s:'order', t:2},
      {s:'score', t:6},
      {s:'rank', t:6},
      {s:'count', t:2}
   ],
   25401 : [
      {s:'order', t:2},
      {s:'score', t:6},
      {s:'rank', t:6},
      {s:'count', t:2},
      {s:'buy_count', t:2},
      {s:'hp_per', t:6},
      {s:'award_info', t:9, f:[
          {s:'award_id', t:6}
      ]}
   ],
   25402 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'count', t:2},
      {s:'buy_count', t:2}
   ],
   25403 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'award_info', t:9, f:[
          {s:'award_id', t:6}
      ]}
   ],
   25404 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   25405 : [
      {s:'result', t:2},
      {s:'dps_score', t:6},
      {s:'kill_score', t:6},
      {s:'all_dps', t:6},
      {s:'best_partner', t:6},
      {s:'target_role_name', t:7},
      {s:'hurt_statistics', t:9, f:[
          {s:'type', t:2},
          {s:'partner_hurts', t:9, f:[
              {s:'rid', t:6},
              {s:'srvid', t:7},
              {s:'id', t:6},
              {s:'bid', t:6},
              {s:'star', t:6},
              {s:'lev', t:6},
              {s:'camp_type', t:6},
              {s:'dps', t:6},
              {s:'cure', t:6},
              {s:'ext_data', t:9, f:[
                  {s:'key', t:6},
                  {s:'val', t:6}
              ]}
          ]}
      ]}
   ],
   25410 : [
      {s:'round', t:2},
      {s:'difficulty', t:2},
      {s:'order', t:2},
      {s:'order_type', t:2},
      {s:'round_combat', t:6},
      {s:'round_boss', t:6},
      {s:'count', t:2},
      {s:'buy_count', t:2},
      {s:'endtime', t:6},
      {s:'hp_per', t:6},
      {s:'status', t:2}
   ],
   25411 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'count', t:2},
      {s:'buy_count', t:2}
   ],
   25412 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   25413 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   25414 : [
      {s:'p_list', t:9, f:[
          {s:'id', t:6},
          {s:'count', t:2}
      ]}
   ],
   25800 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'city_id', t:6}
   ],
   25801 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'flag', t:2}
   ],
   25802 : [
      {s:'rank', t:4},
      {s:'rank_list', t:9, f:[
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'name', t:7},
          {s:'lev', t:4},
          {s:'face', t:6},
          {s:'rank', t:4},
          {s:'avatar_bid', t:6},
          {s:'fans_num', t:6}
      ]}
   ],
   25805 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'pos', t:2},
      {s:'id', t:6}
   ],
   25806 : [
      {s:'point', t:6},
      {s:'honor_badges', t:9, f:[
          {s:'id', t:6},
          {s:'time', t:6}
      ]},
      {s:'use_badges', t:9, f:[
          {s:'pos', t:2},
          {s:'id', t:6}
      ]}
   ],
   25807 : [
      {s:'id', t:6}
   ],
   25810 : [
      {s:'feat_list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'end_time', t:6},
          {s:'finish_time', t:6},
          {s:'progress', t:9, f:[
              {s:'id', t:4},
              {s:'finish', t:2},
              {s:'target', t:6},
              {s:'target_val', t:6},
              {s:'value', t:6}
          ]}
      ]},
      {s:'finish_list', t:9, f:[
          {s:'id', t:6},
          {s:'finish_time', t:6}
      ]}
   ],
   25811 : [
      {s:'feat_list', t:9, f:[
          {s:'id', t:6},
          {s:'finish', t:2},
          {s:'end_time', t:6},
          {s:'finish_time', t:6},
          {s:'progress', t:9, f:[
              {s:'id', t:4},
              {s:'finish', t:2},
              {s:'target', t:6},
              {s:'target_val', t:6},
              {s:'value', t:6}
          ]}
      ]}
   ],
   25812 : [
      {s:'code', t:2},
      {s:'msg', t:7},
      {s:'id', t:6},
      {s:'finish_time', t:6}
   ],
   25813 : [
   ],
   25814 : [
      {s:'result', t:2}
   ],
   25815 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   25816 : [
      {s:'id', t:6},
      {s:'finish_time', t:6},
      {s:'share_id', t:6}
   ],
   25817 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   25818 : [
      {s:'id', t:6},
      {s:'finish_time', t:6},
      {s:'share_id', t:6}
   ],
   25819 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   25820 : [
      {s:'point', t:6},
      {s:'num', t:6},
      {s:'share_id', t:6}
   ],
   25830 : [
      {s:'start', t:4},
      {s:'num', t:2},
      {s:'max_num', t:6},
      {s:'progress', t:9, f:[
          {s:'id', t:6},
          {s:'order', t:6},
          {s:'time', t:6},
          {s:'arge', t:9, f:[
              {s:'pos', t:2},
              {s:'val', t:7}
          ]}
      ]}
   ],
   25831 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   25832 : [
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'start', t:4},
      {s:'num', t:2},
      {s:'max_num', t:4},
      {s:'room_grow_info', t:9, f:[
          {s:'id', t:6},
          {s:'order', t:6},
          {s:'time', t:6},
          {s:'arge', t:9, f:[
              {s:'pos', t:2},
              {s:'val', t:7}
          ]}
      ]}
   ],
   25835 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   25836 : [
      {s:'result', t:2},
      {s:'msg', t:7}
   ],
   25837 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'start', t:4},
      {s:'num', t:2},
      {s:'max_num', t:6},
      {s:'room_bbs_info', t:9, f:[
          {s:'bbs_id', t:6},
          {s:'bbs_type', t:6},
          {s:'reply_name', t:7},
          {s:'msg', t:7},
          {s:'time', t:6},
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'face_id', t:6},
          {s:'avatar_id', t:6},
          {s:'lev', t:4},
          {s:'sex', t:2},
          {s:'name', t:7}
      ]}
   ],
   25838 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'bbs_id', t:6}
   ],
   25839 : [
      {s:'result', t:2},
      {s:'msg', t:7},
      {s:'type', t:2}
   ],
   25840 : [
   ],
   25841 : [
      {s:'max_num', t:6},
      {s:'rid', t:6},
      {s:'srv_id', t:7},
      {s:'room_bbs_info', t:9, f:[
          {s:'bbs_id', t:6},
          {s:'bbs_type', t:6},
          {s:'reply_name', t:7},
          {s:'msg', t:7},
          {s:'time', t:6},
          {s:'rid', t:6},
          {s:'srv_id', t:7},
          {s:'face_id', t:6},
          {s:'avatar_id', t:6},
          {s:'lev', t:4},
          {s:'sex', t:2},
          {s:'name', t:7}
      ]}
   ],
   30001 : [
      {s:'id', t:6},
      {s:'finish', t:2},
      {s:'target_val', t:6},
      {s:'value', t:6}
   ],
   30002 : [
      {s:'code', t:2},
      {s:'msg', t:7}
   ],
   30100 : [
      {s:'flag', t:2},
      {s:'msg', t:7}
   ],
   30101 : [
      {s:'code', t:2}
   ],
   30102 : [
      {s:'code', t:2}
   ]
};
